import axios from 'axios';
export { default as axios } from 'axios';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * 判断是否server环境
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
var isServer = typeof window === 'undefined';

/**
 * 获取当前window实例
 * @ignore
 */
function getWindow() {
    return isServer ? global : window;
}
/**
 * @ignore
 */
function setWindowInstance(key, value) {
    getWindow()[key] = value;
}

/*
 * @Author: victorjhu
 * @Date: 2023-01-03 17:27:53
 */
function getBrowserInfo() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if (isServer) {
        return null;
    }
    var userAgentStr = ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    var browserInfo = {};
    var browserArray = {
        IE: (window === null || window === void 0 ? void 0 : window.ActiveXObject) || 'ActiveXObject' in window,
        Chrome: userAgentStr.indexOf('chrome') > -1 && userAgentStr.indexOf('safari') > -1,
        Firefox: userAgentStr.indexOf('firefox') > -1,
        Opera: userAgentStr.indexOf('opera') > -1,
        Safari: userAgentStr.indexOf('safari') > -1 && userAgentStr.indexOf('chrome') === -1,
        Edge: userAgentStr.indexOf('edge') > -1 || userAgentStr.indexOf('edg') > -1,
        QQBrowser: userAgentStr.indexOf('qqbrowser') > -1 || userAgentStr.indexOf('qq') > -1,
        WeixinBrowser: userAgentStr.indexOf('micromessenger') > -1,
        VivoBrowser: userAgentStr.indexOf('vivobrowser') > -1,
        HuaweiBrowser: userAgentStr.indexOf('huaweibrowser') > -1,
        MiuiBrowser: userAgentStr.indexOf('miuibrowser') > -1,
        TencentWemeet: userAgentStr.indexOf('app/tencent_wemeet') > -1,
        DingTalk: userAgentStr.indexOf('dingtalk') > -1,
        Youku: userAgentStr.indexOf('youku') > -1,
        HeyTapBrowser: userAgentStr.indexOf('heytapbrowser') > -1, // HeyTapBrowser
    };
    for (var _i = 0, _u = Object.keys(browserArray); _i < _u.length; _i++) {
        var i = _u[_i];
        if (browserArray[i]) {
            var versions = void 0;
            if (i === 'IE') {
                versions = (_b = userAgentStr.match(/(msie\s|trident.*rv:)([\w.]+)/)) === null || _b === void 0 ? void 0 : _b[2];
            }
            else if (i === 'Chrome') {
                for (var _v = 0, _w = Object.keys(navigator.mimeTypes); _v < _w.length; _v++) {
                    var mt = _w[_v];
                    // 检测是否是360浏览器(测试只有pc端的360才起作用)
                    if (navigator.mimeTypes[mt].type === 'application/360softmgrplugin') {
                        i = '360';
                    }
                }
                versions = (_c = userAgentStr.match(/chrome\/([\d.]+)/)) === null || _c === void 0 ? void 0 : _c[1];
            }
            else if (i === 'Firefox') {
                versions = (_d = userAgentStr.match(/firefox\/([\d.]+)/)) === null || _d === void 0 ? void 0 : _d[1];
            }
            else if (i === 'Opera') {
                versions = (_e = userAgentStr.match(/opera\/([\d.]+)/)) === null || _e === void 0 ? void 0 : _e[1];
            }
            else if (i === 'Safari') {
                versions = (_f = userAgentStr.match(/version\/([\d.]+)/)) === null || _f === void 0 ? void 0 : _f[1];
            }
            else if (i === 'Edge') {
                versions = ((_g = userAgentStr.match(/edge\/([\d.]+)/)) === null || _g === void 0 ? void 0 : _g[1]) || ((_h = userAgentStr.match(/edg\/([\d.]+)/)) === null || _h === void 0 ? void 0 : _h[1]);
            }
            else if (i === 'QQBrowser') {
                versions = ((_j = userAgentStr.match(/qqbrowser\/([\d.]+)/)) === null || _j === void 0 ? void 0 : _j[1]) || ((_k = userAgentStr.match(/qq\/([\d.]+)/)) === null || _k === void 0 ? void 0 : _k[1]);
            }
            else if (i === 'WeixinBrowser') {
                versions = (_l = userAgentStr.match(/micromessenger\/([\d.]+)/)) === null || _l === void 0 ? void 0 : _l[1];
            }
            else if (i === 'VivoBrowser') {
                versions = (_m = userAgentStr.match(/vivobrowser\/([\d.]+)/)) === null || _m === void 0 ? void 0 : _m[1];
            }
            else if (i === 'HuaweiBrowser') {
                versions = (_o = userAgentStr.match(/huaweibrowser\/([\d.]+)/)) === null || _o === void 0 ? void 0 : _o[1];
            }
            else if (i === 'MiuiBrowser') {
                versions = (_p = userAgentStr.match(/miuibrowser\/([\d.]+)/)) === null || _p === void 0 ? void 0 : _p[1];
            }
            else if (i === 'TencentWemeet') {
                versions = (_q = userAgentStr.match(/app_version\/([\d.]+)/)) === null || _q === void 0 ? void 0 : _q[1];
            }
            else if (i === 'DingTalk') {
                versions = (_r = userAgentStr.match(/dingtalk\/([\d.]+)/)) === null || _r === void 0 ? void 0 : _r[1];
            }
            else if (i === 'Youku') {
                versions = (_s = userAgentStr.match(/youku\/([\d.]+)/)) === null || _s === void 0 ? void 0 : _s[1];
            }
            else if (i === 'HeyTapBrowser') {
                versions = (_t = userAgentStr.match(/heytapbrowser\/([\d.]+)/)) === null || _t === void 0 ? void 0 : _t[1];
            }
            browserInfo.type = i;
            browserInfo.versions = versions;
        }
    }
    return browserInfo;
}

/*
 * @Author: victorjhu
 * @Date: 2023-01-03 17:27:53
 */
/**
 * 从document获取cookie
 * @param cookieName {string} cookie名称
 * @param cookieSource {string} next.js从ctx.req.headers.cookie获取cookie, 如果为空则从document获取
 */
function getCookie(cookieName, cookieSource) {
    var arr;
    var cookieValue = '';
    var reg = new RegExp("(^| )".concat(cookieName, "=([^;]*)(;|$)"));
    if (cookieSource && typeof cookieSource === 'string') {
        cookieValue = cookieSource;
    }
    else if (!isServer) {
        cookieValue = document.cookie;
    }
    if ((arr = cookieValue.match(reg))) {
        return unescape(arr[2]);
    }
    return null;
}

function parseCookie(cookieStr) {
    if (cookieStr === void 0) { cookieStr = ''; }
    var cookies = {};
    if (!cookieStr) {
        return cookies;
    }
    var list = cookieStr.split(';');
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < list.length; i++) {
        var cookie = list[i];
        var p = cookie.indexOf('=');
        var name_1 = cookie.substring(0, p).trim();
        cookies[name_1] = cookie.substring(p + 1).trim();
    }
    return cookies;
}

/**
 * Get cookies from document or request.
 */
function getCookies(ctx) {
    var _a;
    if (isServer) {
        if ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) {
            return parseCookie(ctx.req.headers.cookie);
        }
        return {};
    }
    return parseCookie(document.cookie);
}

function getFlashVersion() {
    var version = '0,0,0';
    // IE
    try {
        version = new window.ActiveXObject('ShockwaveFlash.ShockwaveFlash')
            .GetVariable('$version')
            .replace(/\D+/g, ',')
            .match(/^,?(.+),?$/)[0];
    }
    catch (error) {
        try {
            if (navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
                version = (navigator.plugins['Shockwave Flash 2.0'] || navigator.plugins['Shockwave Flash']).description
                    .replace(/\D+/g, ',')
                    .match(/^,?(.+),?$/)[0];
            }
        }
        catch (error) {
            // satisfy linter
        }
    }
    return version.split(',');
}

/**
 * 获取UserAgent
 * @param ua {string} 浏览器userAgent,不传或者传空字符串则自动获取
 */
function getUserAgent(ua) {
    if (ua === void 0) { ua = ''; }
    if (isServer) {
        return ua || '';
    }
    return ua || window.navigator.userAgent || '';
}

/**
 *
  繁体中文 Q: app_lang/zh-tc
  简体中文 Q: app_lang/zh-cn
  English Q: app_lang/en-us
  日本语 Q： app_lang/ja
 * @returns string
 */
function getLang(ua) {
    // 匹配语言
    var matches = getUserAgent(ua).match(/app_lang\/([\w-]+)/);
    // 语言映射， 左边为本地文件夹名, 右边为可能 的ua
    var languages = {
        'zh-CN': ['zh-cn'],
        'zh-TW': ['zh-ts', 'zh-tw', 'zh-tc'],
        en: ['en-us', 'en-uk'],
        ru: ['ru'],
        jp: ['jp'],
        ja: ['ja'],
        ko: ['ko'],
        ms: ['ms'],
    };
    if (Array.isArray(matches) && matches.length > 1) {
        var langLow = matches[1].toLowerCase().replace('_', '-');
        for (var _i = 0, _a = Object.entries(languages); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], v = _b[1];
            if (v.includes(langLow)) {
                return key;
            }
        }
        return 'zh-CN';
    }
    // 默认返回中文
    return 'zh-CN';
}

/**
 * 是否是安卓设备
 * @param ua 浏览器的userAgent
 * @example
 * ```
 *    if (isAndroid()) {
 *      console.log('is android')
 *    }
 * ```
 */
function isAndroid(ua) {
    if (ua === void 0) { ua = ''; }
    var userAgent = getUserAgent(ua);
    return /android|adr/i.test(userAgent);
}

function isMobile(ua) {
    if (ua === void 0) { ua = ''; }
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(getUserAgent(ua));
}

function isSafari(userAgent) {
    if (userAgent === void 0) { userAgent = ''; }
    var ua = getUserAgent(userAgent).toLowerCase();
    var fd = function (ss) { return ua.indexOf(ss) > -1; };
    var nf = function (ss) { return ua.indexOf(ss) === -1; };
    var a = fd('safari/');
    var b = nf('chrome/');
    var c = nf('qq/') && nf('mqqbrowser');
    return a && b && c;
}

/**
 * 判断是否ipad默认浏览器
 * @returns boolean
 */
function isIpad(ua) {
    if (ua === void 0) { ua = ''; }
    if (isAndroid(getUserAgent(ua))) {
        return false;
    }
    if (/iPad/i.test(getUserAgent(ua))) {
        return true;
    }
    // 之前发现对于（当时来说）新版iPad，存在其safari浏览器的UA不带iPad字样的情况。
    // 这种情况的一个ua实例是：
    // Mozilla/5.0 (Macintosh;Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko)
    // Version/13.0.1 Safari/605.1.15
    // 实际上我认为这是苹果的bug。对于这种情况，判断如下：
    return !!(isSafari(ua) && !isMobile(ua) && navigator.maxTouchPoints);
}

function isMac(ua) {
    return !isMobile() && /macintosh|mac os x/i.test(getUserAgent(ua));
}

var getOsName = function () {
    if (/Win/.test(navigator.appVersion) && !/Mac/.test(navigator.appVersion)) {
        return 'windows';
    }
    if (/Android/.test(navigator.appVersion)) {
        return 'android';
    }
    // iOS和Mac的顺不能变，经测试发现Mac的浏览器里会有iOS的字样
    if (/iPhone/.test(navigator.appVersion)) {
        return 'ios';
    }
    if (isIpad()) {
        return 'ios';
    }
    if (isMac()) {
        return 'mac';
    }
    if (navigator.userAgent.includes('Linux')) {
        return 'linux';
    }
    return 'unknown';
};

/**
 * 获取webkit信息
 * @param apple 是够是apple平台
 */
function getWebkitInfo(apple) {
    var webkitVersionMap = /applewebkit\/([\d.]+)/i.exec(getUserAgent());
    if (apple) {
        return webkitVersionMap ? Number.parseFloat(webkitVersionMap.pop()) : null;
    }
    return webkitVersionMap;
}

function isAndroidPad() {
    var _a, _b;
    return (isAndroid() && !navigator.userAgent.toLowerCase().includes('mobile'))
        || (isAndroid() && ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.screen) === null || _b === void 0 ? void 0 : _b.width) > 600);
}

function isChrome(ua) {
    return /Chrome/i.test(getUserAgent(ua));
}

// 判断是否是钉钉
function isDingTalk(ua) {
    return /DingTalk/i.test(getUserAgent(ua));
}

function isEdge(ua) {
    if (ua === void 0) { ua = ''; }
    return /Edge/i.test(getUserAgent(ua));
}

function isFF(ua) {
    if (ua === void 0) { ua = ''; }
    return getUserAgent(ua).toLowerCase()
        .indexOf('firefox') !== -1;
}

/**
 * iPhone
 */
function isIPhone(ua) {
    return /iphone/i.test(getUserAgent(ua));
}

/**
 * 是否为全面屏iPhone
 */
function isFullScreenIPhone(ua) {
    return !isServer && isIPhone(ua) && window.screen.height >= 812 && window.devicePixelRatio >= 2;
}

/**
 * 判断华为平板默认浏览器
 * @returns boolean
 */
function isHuaweiPadBrowser() {
    var _a, _b, _c;
    if (isServer)
        return false;
    return window.navigator.platform.toLowerCase().includes('linux')
        // @ts-ignore
        && ((_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.appPackageName) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes('huawei'))
        && !((_c = window.navigator.userAgent) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes('mobile'));
}

/**
 * 判断华为平板QQ浏览器
 * @returns boolean
 */
function isHuaweiPadQqBrowser(ua) {
    if (ua === void 0) { ua = ''; }
    var userAgent = getUserAgent(ua);
    return (/android|huawei/i.test(userAgent) && /qq/i.test(userAgent)
        && !/mobile/i.test(navigator.userAgent));
}

function isIE(ua) {
    if (ua === void 0) { ua = ''; }
    return /(msie\s|trident.*rv:)([\w.]+)/i.test(getUserAgent(ua));
}

function isIE8(ua) {
    if (ua === void 0) { ua = ''; }
    return /MSIE\s8\.0/i.test(getUserAgent(ua));
}

/**
 * ios 系统
 */
function isIOS(ua) {
    return !isAndroid(ua) && /iPhone|iPod|iPad/i.test(getUserAgent(ua));
}

function isLinux(ua) {
    if (ua === void 0) { ua = ''; }
    return !isMobile(ua) && /Linux/i.test(getUserAgent(ua));
}

/**
 * 腾讯会议App
 */
function isWeMeetApp(ua) {
    return /app\/tencent_wemeet/i.test(getUserAgent(ua));
}

/**
 * mac App
 */
function isMacApp(ua) {
    var userAgent = getUserAgent(ua);
    return !isIOS(userAgent) && isMac(userAgent) && isWeMeetApp(userAgent);
}

/**
 * 判断是否是mac版的微信webview
 * @param ua
 * @returns boolean
 */
function isMacWechat(ua) {
    return /MacWechat/i.test(getUserAgent(ua));
}

/**
 * 仅X5内核，QQ浏览器默认x5内核，但是agent没有TBS
 */
function isTBS(ua) {
    if (ua === void 0) { ua = ''; }
    return /tbs\/\d+/i.test(getUserAgent(ua));
}

/**
 * 移动端QQ浏览器 android QQ也为true
 */
function isMQQB(ua) {
    if (ua === void 0) { ua = ''; }
    return !isTBS() && /mqqbrowser\/\d+/i.test(getUserAgent(ua));
}

function isNative(u) {
    if (u === void 0) { u = ''; }
    var ua = getUserAgent(u);
    var nativeAgents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    return !!nativeAgents.find(function (item) { return getUserAgent(ua).indexOf(item) >= 0; });
}

/**
 * 判断是否是平板（安卓+ipad）
 * @returns boolean
 */
function isPad(ua) {
    if (ua === void 0) { ua = ''; }
    if (isIpad(ua))
        return true;
    if (!isMobile(ua) && (isAndroid(ua) || isHuaweiPadBrowser() || isHuaweiPadQqBrowser(ua))) {
        return true;
    }
    // 兼容ipad其他浏览器（遨游等）
    if (!isServer && !isMobile(ua) && navigator.maxTouchPoints === 5) {
        return true;
    }
    return false;
}

/**
 * 判断是否为 qq 内嵌浏览器
 */
function isQQ(ua) {
    var userAgent = getUserAgent(ua);
    if (isIOS(userAgent)) {
        return / QQ/i.test(userAgent);
    }
    return /QQTheme/i.test(userAgent) && /MQQBrowser/i.test(userAgent);
}

// qq 浏览器：非qq webview && ua 中含有 qqbroswer
function isQQB(ua) {
    return !isQQ(ua) && /QQBrowser/i.test(getUserAgent(ua));
}

/**
 * 微信浏览器
 * @deprecated 命名不规范，请使用`isWechat`替代,
 */
function isWeChat(ua) {
    var userAgent = getUserAgent(ua);
    // 不是企业微信
    return /micromessenger/i.test(userAgent) && !/wxwork/i.test(userAgent);
}
var isWechat = function (ua) { return isWeChat(ua); };

/**
 * 判断当前是否处于微信小程序webview
 */
function isWechatMiniProgram(ua) {
    if (ua === void 0) { ua = ''; }
    return isWechat(ua) && /miniProgram/i.test(getUserAgent(ua));
}

/**
 * 比较版本号
 * @param ver1
 * @param ver2
 */
function compareVersion(ver1, ver2) {
    if (typeof ver1 !== 'string') {
        throw new Error("version1 should be type of string: ".concat(ver1));
    }
    if (typeof ver2 !== 'string') {
        throw new Error("version2 should be type of string: ".concat(ver2));
    }
    var v1 = ver1.split('.');
    var v2 = ver2.split('.');
    var len1 = v1.length;
    var len2 = v2.length;
    for (var i = 0; i < len1 && i < len2; i++) {
        var num1 = parseInt(v1[i], 10);
        if (isNaN(num1) || num1 < 0) {
            throw new Error("invalid version1: ".concat(v1));
        }
        var num2 = parseInt(v2[i], 10);
        if (isNaN(num2) || num2 < 0) {
            throw new Error("invalid version2: ".concat(v2));
        }
        if (num1 < num2) {
            return -1;
        }
        if (num1 > num2) {
            return 1;
        }
    }
    if (len1 === len2) {
        return 0;
    }
    if (len1 > len2) {
        for (var i = len2; i < len1; i++) {
            if (v1[i] !== '0') {
                return 1;
            }
        }
        return 0;
    }
    for (var i = len1; i < len2; i++) {
        if (v2[i] !== '0') {
            return -1;
        }
    }
    return 0;
}

/**
 * 企业微信版本是否大于6.5.6
 * @param targetVersion {string} 目标版本号`6.5.6`
 * @prams ua {string} userAgent
 */
function isWxWorkGteVersion(targetVersion, ua) {
    if (targetVersion === void 0) { targetVersion = '6.5.6'; }
    if (ua === void 0) { ua = ''; }
    var userAgent = getUserAgent(ua);
    var wxInfo = userAgent.match(/wxwork\/([\d.]+)/i);
    return userAgent.includes('wxwork') && wxInfo && wxInfo.length >= 2 && compareVersion(wxInfo[1], targetVersion) >= 0;
}

/**
 * 企业微信版本是否大于3.1.2
 */
var isWxWorkGte312 = function (ua) {
    if (ua === void 0) { ua = ''; }
    var userAgent = getUserAgent(ua);
    var wxInfo = userAgent.match(/wxwork\/([\d.]+)/i);
    return userAgent.includes('wxwork') && wxInfo && wxInfo.length >= 2 && compareVersion(wxInfo[1], '3.1.2') >= 0;
};

/**
 * 企业微信的userAgent：Mozilla/5.0 (Linux; Android 9; Pixel 2 Build/PQ2A.190405.003; wv)
 * AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/66.0.3359.126
 * MQQBrowser/6.2 TBS/044605 Mobile Safari/537.36 wxwork/2.7.8 MicroMessenger/7.0.1 NetType/WIFI Language/zh
 */
function isWeiXinGte656(ua) {
    if (ua === void 0) { ua = ''; }
    var userAgent = getUserAgent(ua);
    var wxInfo = userAgent.match(/MicroMessenger\/([\d.]+)/i);
    return !userAgent.includes('wxwork') && wxInfo && wxInfo.length >= 2 && compareVersion(wxInfo[1], '6.5.6') >= 0;
}

/**
 * Windows 系统
 */
function isWin(ua) {
    return /windows|win32|win64/i.test(getUserAgent(ua));
}

/**
 * windows App
 */
function isWinApp(ua) {
    var userAgent = getUserAgent(ua);
    return isWin(userAgent) && isWeMeetApp(userAgent);
}

/**
 * windows 微信浏览器
 */
function isWindowsWechat(ua) {
    return /WindowsWechat/i.test(getUserAgent(ua));
}

/**
 * 企业微信私有化
 */
function isWxWorkLocal(ua) {
    if (ua === void 0) { ua = ''; }
    return getUserAgent(ua).toLowerCase()
        .indexOf('wxworklocal') !== -1;
}

/**
 * 企业微信
 */
function isWxWork(ua) {
    if (ua === void 0) { ua = ''; }
    return getUserAgent(ua).toLowerCase()
        .indexOf('wxwork') !== -1;
}

/**
 * 动态加载css文件
 * @param url string
 * return promise
 */
function loadCss(url) {
    return new Promise(function (resolve) {
        if (typeof document === 'undefined') {
            resolve(null);
            return;
        }
        var filename = url.split('/').reverse()[0];
        var link = document.getElementById(filename);
        if (link) {
            resolve(link);
            return;
        }
        var el = document.createElement('link');
        el.rel = 'stylesheet';
        el.href = url;
        el.id = filename;
        el.onload = function () {
            resolve({});
        };
        document.head.appendChild(el);
    });
}

function findScript(scriptElement, umd) {
    return scriptElement.src === umd.staticPath || scriptElement.src === umd.cdnPath;
}
function appendScript(umd, options) {
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve, reject) {
        var defer = options.defer, async = options.async;
        var s = document.createElement('script');
        s.src = umd.cdnPath;
        s.type = 'text/javascript';
        s.defer = defer;
        s.async = async;
        s.onload = function () {
            resolve();
        };
        s.onerror = function () {
            s.remove();
            var retry = document.createElement('script');
            retry.src = umd.staticPath;
            retry.type = 'text/javascript';
            retry.onload = function () {
                resolve();
            };
            retry.onerror = function () {
                reject();
            };
            document.head.appendChild(retry);
        };
        document.head.appendChild(s);
    });
}
/**
 * 加载一个UMD库
 * @param umdInput { UMDLibrary | string }
 * @param LoadScriptOption
 *  @return Promise<{namespace: Instance}>
 */
function loadScript(umdInput, options) {
    return new Promise(function (resolve) {
        var umd = umdInput;
        if (typeof umdInput === 'string') {
            umd = {
                namespace: '',
                cdnPath: umdInput,
                staticPath: umdInput,
            };
        }
        if (!umd.staticPath) {
            umd.staticPath = umd.cdnPath;
        }
        var domList = Array.from(document.scripts);
        var scriptElement = domList.find(function (el) { return findScript(el, umd); });
        if (scriptElement) {
            return scriptElement.addEventListener('onload', resolve);
        }
        if (umd.namespace && window[umd.namespace]) {
            resolve(window);
        }
        else {
            appendScript(umd, options).then(function () {
                resolve(window);
            });
        }
    });
}
/**
 * 加载多个UMD库
 * 返回数组
 * @param umds
 * @param LoadScriptOption
 * @return Promise<{[namespace: string]: Instance}>>
 */
function loadScripts(umds, options) {
    return Promise.all(umds.map(function (umd) { return loadScript(umd); }, options));
}

/**
 * 判断是本地环境
 * @param href {?string} 默认为当前页面的location.href
 * @example
 * ```
 *    isLocalEnv();
 *    isLocalEnv('http://localhost:8080');
 *    isLocalEnv('http://wemeet-dev:8080');
 *    isLocalEnv(location.href);
 * ```
 */
function isLocalEnv(href) {
    if (href === void 0) { href = ''; }
    if (!isServer && !href) {
        // eslint-disable-next-line no-param-reassign
        href = location.href;
    }
    return /:\/\/localhost/.test(href) || /:\/\/wemeet-dev/.test(href);
}

/**
 * 判断是测试环境
 * @param href {?string} 默认为当前页面的location.href
 * @example
 * ```
 * isTestEnv();
 * // 需要兼容特殊的页面
 * isTestEnv('http://test.txmeeting.oa.com/test/index.html');
 * isTestEnv('http://test.txmeeting.oa.com:8081/test/index.html');
 * isTestEnv('http://10.100.69.245:8081/test/index.html');
 * isTestEnv('http://testweb.wemeet.tencent.com');
 * isTestEnv('https://ulinktest.txmeeting.tencent.com');
 * ```
 */
function isTestEnv(href) {
    if (href === void 0) { href = ''; }
    if (!isServer && !href) {
        // eslint-disable-next-line no-param-reassign
        href = location.href;
    }
    return (/\.com\/test\//.test(href)
        || /:8081\/test\//.test(href)
        || /^https?:\/\/test(-\d+)?\.txmeeting\.tencent\.com/.test(href)
        || /^https?:\/\/test(-\d+)?\.cicd\.tencentmeeting\.com/.test(href)
        || /^https?:\/\/test-voov(-\d+)?\.cicd\.tencentmeeting\.com/.test(href)
        || /^(http|https):\/\/9\.221\.7\.217/i.test(href)
        || /^(http|https):\/\/testweb\.wemeet\.tencent\.com/i.test(href)
        || /^https?:\/\/test\.web\.voovmeeting\.com/i.test(href)
        || /^https:\/\/ulinktest\.txmeeting\.tencent\.com/i.test(href)
        || /^https?:\/\/dtest(-\d+)?\.cicd\.tencentmeeting\.com/.test(href)
        || /^https?:\/\/dtest-voov(-\d+)?\.cicd\.tencentmeeting\.com/.test(href));
}

/**
 * 判断是预发布环境
 * @param href {?string} 默认为当前页面的location.href
 * @example
 * ```
 *   isPreReleaseEnv();
 *   // 需要兼容特殊的页面
 *   isPreReleaseEnv('http://test.txmeeting.oa.com/pre-release/index.html');
 *   isPreReleaseEnv('http://test.txmeeting.oa.com:8081/pre-release/index.html');
 *   isPreReleaseEnv('http://10.100.69.245:8081/pre-release/index.html');
 *   isPreReleaseEnv('http://pre.txmeeting.tencent.com');
 *   isPreReleaseEnv('https://pre.txmeeting.tencent.com');
 *   isPreReleaseEnv('https://pre-1.cicd.tencentmeeting.com');
 * ```
 */
function isPreReleaseEnv(href) {
    if (href === void 0) { href = ''; }
    if (!isServer && !href) {
        // eslint-disable-next-line no-param-reassign
        href = location.href;
    }
    return (/\.com\/pre-release\//.test(href)
        || /:8081\/pre-release\//.test(href)
        || /https?:\/\/pre(-\d+)?\.txmeeting\.tencent\.com/.test(href)
        || /^https?:\/\/pre(-\d+)?\.cicd\.tencentmeeting\.com/.test(href));
}

/**
 * 加载Vconsole
 */
function loadVConsoleScript() {
    return __awaiter(this, void 0, void 0, function () {
        var WINDOW_1, vConsole_1;
        return __generator(this, function (_a) {
            if (isLocalEnv() || isTestEnv() || isPreReleaseEnv()) {
                WINDOW_1 = window;
                vConsole_1 = null;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (typeof WINDOW_1.VConsole !== 'undefined') {
                            resolve(vConsole_1);
                        }
                        else {
                            loadScript('https://meeting.tencent.com/static/lib/vconsole.min.js')
                                .then(function () {
                                var CONSOLE = WINDOW_1.VConsole;
                                if (CONSOLE) {
                                    vConsole_1 = new CONSOLE();
                                }
                                resolve(vConsole_1);
                            })
                                .catch(function (err) {
                                console.log(err);
                                reject(err);
                            });
                        }
                    })];
            }
            return [2 /*return*/, Promise.resolve()];
        });
    });
}

/**
 * 前端写入cookie
 * @param key 键
 * @param value {string} 值
 * @param days 过期时间，单位天
 * @param path 路径
 */
function setCookie(key, value, days, path) {
    if (isServer)
        return;
    var expires = '';
    if (days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(d.toGMTString());
    }
    document.cookie = "".concat(key, "=").concat(value).concat(expires).concat(path ? "; path=".concat(path) : '');
}

function isObject(value) {
    if (!value) {
        return false;
    }
    return Object.prototype.toString.call(value) === '[object Object]';
}

/**
 * localStorage clear
 * @param { LocalStorageClearOption } options 清理storage参数
 */
function localStorageClear(options) {
    if (isServer)
        return;
    if (!isObject(options)) {
        localStorage.clear();
        return;
    }
    var _a = options.whitelist, whitelist = _a === void 0 ? [] : _a;
    var cacheList = [];
    whitelist.forEach(function (item) {
        var value = localStorage.getItem(item);
        if (value === null) {
            return;
        }
        cacheList.push({
            key: item,
            value: value,
        });
    });
    localStorage.clear();
    cacheList.forEach(function (item) {
        localStorage.setItem(item.key, item.value);
    });
}

/**
 * localStorage 获取
 * @param { String } key  属性
 */
function localStorageGet(key) {
    if (isServer)
        return;
    return localStorage.getItem(key);
}

/**
 * localStorage 删除
 * @param { String } key  属性
 */
function localStorageRemove(key) {
    if (isServer)
        return;
    localStorage.removeItem(key);
}

/**
 * localStorage 存贮
 * @param { String } key  属性
 * @param { string } value 值
 * * @param { number } time 有效时间/秒
 */
function localStorageSet(key, value, time) {
    if (isServer)
        return;
    var finalValue = value;
    if (typeof value === 'object') {
        finalValue = JSON.stringify(value);
    }
    localStorage.setItem(key, finalValue);
    if (time) {
        setTimeout(function () {
            localStorage.removeItem(key);
        }, time * 1000);
    }
}

var browser = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getWindow: getWindow,
    setWindowInstance: setWindowInstance,
    getBrowserInfo: getBrowserInfo,
    getCookie: getCookie,
    getCookies: getCookies,
    getFlashVersion: getFlashVersion,
    getLang: getLang,
    getOsName: getOsName,
    getUserAgent: getUserAgent,
    getWebkitInfo: getWebkitInfo,
    isAndroidPad: isAndroidPad,
    isAndroid: isAndroid,
    isChrome: isChrome,
    isDingTalk: isDingTalk,
    isEdge: isEdge,
    isFF: isFF,
    isFullScreenIPhone: isFullScreenIPhone,
    isHuaweiPadBrowser: isHuaweiPadBrowser,
    isHuaweiPadQqBrowser: isHuaweiPadQqBrowser,
    isIE: isIE,
    isIE8: isIE8,
    isIOS: isIOS,
    isIpad: isIpad,
    isIPhone: isIPhone,
    isLinux: isLinux,
    isMacApp: isMacApp,
    isMacWechat: isMacWechat,
    isMac: isMac,
    isMobile: isMobile,
    isMQQB: isMQQB,
    isNative: isNative,
    isPad: isPad,
    isQQ: isQQ,
    isQQB: isQQB,
    isSafari: isSafari,
    isServer: isServer,
    isTBS: isTBS,
    isWechatMiniProgram: isWechatMiniProgram,
    isWeChat: isWeChat,
    isWechat: isWechat,
    isWxWorkGteVersion: isWxWorkGteVersion,
    isWxWorkGte312: isWxWorkGte312,
    isWeiXinGte656: isWeiXinGte656,
    isWeMeetApp: isWeMeetApp,
    isWinApp: isWinApp,
    isWindowsWechat: isWindowsWechat,
    isWin: isWin,
    isWxWorkLocal: isWxWorkLocal,
    isWxWork: isWxWork,
    loadCss: loadCss,
    loadScript: loadScript,
    loadScripts: loadScripts,
    loadVConsoleScript: loadVConsoleScript,
    parseCookie: parseCookie,
    setCookie: setCookie,
    localStorageClear: localStorageClear,
    localStorageGet: localStorageGet,
    localStorageRemove: localStorageRemove,
    localStorageSet: localStorageSet
});

function addClassName(target, className) {
    if (!target) {
        return;
    }
    var el = target;
    var classList = el.className.split(' ');
    if (classList.indexOf(className) === -1) {
        classList.push(className);
        el.className = classList.filter(function (cls) { return cls; }).join(' ');
    }
}
function removeClassName(target, className) {
    if (!target) {
        return;
    }
    var el = target;
    var classList = el.className.split(' ');
    classList = classList.filter(function (c) { return c !== className; });
    el.className = classList.join(' ');
}

/**
 * create-element
 *  web-base
 * @author michaelbguo@tencent.com
 * @time 2021/3/15 17:29
 * @version
 */
function createElement(tag, attr) {
    var el = document.createElement(tag);
    Object.getOwnPropertyNames(attr).forEach(function (key) {
        el.setAttribute(key, attr[key].toString());
    });
    return el;
}

/**
 * find-by-id
 *
 * @author michaelbguo@tencent.com
 * @time 2021/4/12 17:30
 * @version 0.0.1
 */
function findById(id) {
    return document.getElementById(id);
}

/* eslint-disable @typescript-eslint/prefer-for-of */
function forEachNode(domList, callback) {
    if (!callback) {
        return;
    }
    for (var i = 0; i < domList.length; i++) {
        callback(domList[i]);
    }
}

/**
 * 添加url查询参数
 * @param url strings
 * @param options object
 */
function addURLSearch(url, options) {
    if (url === void 0) { url = window.location.href; }
    if (options === void 0) { options = {}; }
    var urlArr = url.split('?');
    var dealSearchStr = function (obj, options, hash) {
        if (obj === void 0) { obj = {}; }
        if (options === void 0) { options = {}; }
        if (hash === void 0) { hash = ''; }
        var searchStr = '';
        var tmp = Object.assign({}, obj, options);
        var t = 0;
        Object.keys(tmp).forEach(function (i) {
            searchStr += "".concat((t !== 0 ? '&' : '') + i, "=").concat(tmp[i]);
            t += 1;
        });
        if (hash) {
            searchStr += "#".concat(hash);
        }
        if (t !== 0) {
            searchStr = "?".concat(searchStr);
        }
        return searchStr;
    };
    var resStr = '';
    if (urlArr[1]) {
        var searchArr = urlArr[1].split('#');
        var lists = searchArr[0].split('&');
        var obj_1 = {};
        lists.forEach(function (el) {
            var arr = el.split('=');
            obj_1[arr[0]] = arr[1] || '';
        });
        resStr = dealSearchStr(obj_1, options, searchArr[1]);
    }
    else {
        resStr = dealSearchStr({}, options, urlArr[0].split('#')[1]);
    }
    return urlArr[0] + resStr;
}

/**
 * 替代web-tools中的`atou`
 * @param source {string}
 */
function asciiToUnicode(source) {
    if (source === void 0) { source = ''; }
    try {
        if (isServer) {
            return Buffer.from(source, 'base64').toString();
        }
        return decodeURIComponent(escape(window.atob(source)));
    }
    catch (e) {
        return source;
    }
}

var atou = asciiToUnicode;

function dealSearchStr(obj, options, hash) {
    if (obj === void 0) { obj = {}; }
    if (options === void 0) { options = {}; }
    if (hash === void 0) { hash = ''; }
    var searchStr = '';
    var tmp = Object.assign({}, obj, options);
    var t = 0;
    Object.keys(tmp).forEach(function (i) {
        searchStr += "".concat((t !== 0 ? '&' : '') + i, "=").concat(tmp[i]);
        t += 1;
    });
    if (hash) {
        // add hash #
        searchStr += "#".concat(hash);
    }
    if (t !== 0) {
        // add ?
        searchStr = "?".concat(searchStr);
    }
    return searchStr;
}

/**
 * 从url中删除查询参数
 * @param url
 * @param key 要删除的key
 * @return string 删除后的url
 */
function deleteURLSearch(url, key) {
    if (url === void 0) { url = window.location.href; }
    var urlArr = url.split('?');
    var resStr = '';
    if (urlArr[1]) {
        var searchArr = urlArr[1].split('#');
        var lists = searchArr[0].split('&');
        var obj_1 = {};
        lists.forEach(function (el) {
            var arr = el.split('=');
            if (arr[0] !== key) {
                // 与 addURLSearch 的区别; 另外dealSearchStr的 options 为 {}
                obj_1[arr[0]] = arr[1] || '';
            }
        });
        resStr = dealSearchStr(obj_1, {}, searchArr[1]);
    }
    else {
        resStr = dealSearchStr({}, {}, urlArr[0].split('#')[1]);
    }
    return urlArr[0] + resStr;
}

/**
 * 将传入的参数转换为安全字符串
 * @param unsafe
 */
function escapeHtml(unsafe) {
    return String(unsafe)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&quot;')
        .replace(/'/g, '&#039;');
}

/**
 * filter-xss
 *
 * @author michaelbguo@tencent.com
 * @time 2021/4/13 14:18
 * @version 0.0.1
 */
function filterXss(text) {
    return text.replace(/[<>"()]/g, '');
}

/**
 * 腾讯会议内部版本号
 */
function getAppVersion(ua) {
    var _a;
    var userAgent = getUserAgent(ua);
    var res = '';
    var lowerUa = userAgent.toLowerCase();
    // 不是企业微信
    var regStrSaf = /app_version\/[\d._]*/gi;
    var verinfo = lowerUa.match(regStrSaf);
    if (verinfo && verinfo.length > 0) {
        _a = verinfo[0].split('/'), res = _a[1];
    }
    return res;
}

/* istanbul ignore file */
/**
 * 获取 guid
 * @deprecated 请使用 uuidv4，重复率更低
 */
function getGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * 获取随机长度字符串
 * @param length
 */
function getRandomString(length) {
    if (length === void 0) { length = 9; }
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var string = '';
    for (var i = 0; i < length; i++) {
        string += chars[Math.floor(Math.random() * chars.length)];
    }
    return string;
}

/* eslint-disable prefer-destructuring */
/**
 * 获取 url 搜索部分key所对应的值
 * - 若匹配到name，则返回name的值（string类型）
 * - 若未匹配到name，则返回false（boolean类型）
 * @param name 需要获取所对应值的 key
 * @param url
 * @return 匹配键所得到的值 or false
 */
function getRequest(name, url) {
    var urlSearch = url;
    if (!urlSearch) {
        urlSearch = window.location.href.split('?')[1];
    }
    else if (urlSearch.split('?')[1]) {
        urlSearch = urlSearch.split('?')[1];
    }
    // 去除 hash 值
    if (urlSearch) {
        urlSearch = String(urlSearch).split('#')[0];
    }
    var res = new RegExp("(^|&)".concat(name, "=([^&]*)")).exec(urlSearch);
    return !!res && res[2];
}

/**
 * 获取中英文字符串长度：中文算两个，英文算一个
 * @param str
 * @returns {number}
 */
var getStrLength = function (str) {
    if (!str) {
        return 0;
    }
    var strLength = 0;
    for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) < 128) {
            strLength += 1;
        }
        else {
            strLength += 2;
        }
    }
    return strLength;
};

// 获取微信相关的信息
// 参考信息: https://iwiki.woa.com/p/2021890652
var wxConfig = {
    // 腾讯小程序的配置 这个写在代码中是否安全?
    appid: 'wx33fd6cdc62520063',
    originId: 'gh_ebae2dbaabf7',
    // 测试小程序的配置
    testAppid: 'wx72965b9c7f10ecd3',
    testOriginId: 'gh_270e5bc81330',
};
// 这个是appid
var getWxAppid = function (url) {
    if (isServer) {
        if (!url)
            return wxConfig.appid; // 不传参数默认给正式的
        // 服务端渲染 传递url参数
        return (isTestEnv(url) || isPreReleaseEnv(url)) ? wxConfig.testAppid : wxConfig.appid;
    }
    return (isTestEnv() || isPreReleaseEnv()) ? wxConfig.testAppid : wxConfig.appid;
};
// 这个是原始id
var getWxOriginId = function (url) {
    if (isServer) {
        if (!url)
            return wxConfig.originId; // 不传参数默认给正式的
        return (isTestEnv(url) || isPreReleaseEnv(url)) ? wxConfig.testOriginId : wxConfig.originId;
    }
    return (isTestEnv() || isPreReleaseEnv()) ? wxConfig.testOriginId : wxConfig.originId;
};

/**
 * 校验是否是银行卡号
 * @param { string } value
 * @return true or false
 */
function isBankCardNum(value) {
    return /^[1-9]\d{9,29}$/g.test(value);
}

/**
 * 校验是否是中文名
 * @param { string } value
 * @return true or false
 */
function isChineseName(value) {
    return /^(?:[\u4e00-\u9fa5·]{2,16})$/g.test(value);
}

/**
 * 校验是否是邮箱格式
 * @param { string } value
 * @return true or false
 */
function isEmail(value) {
    return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(value) || /w+([-+.]w+)*@w+([-.]w+)*.w+([-.]w+)*/.test(value);
}

/**
 * 校验是否是身份证号
 * @param { string } value
 * @return true or false
 */
function isIdNum(value) {
    return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/g.test(value);
}

/**
 * 校验是否是邮政编码格式
 * @param { string } value
 * @return true or false
 */
function isPostcode(value) {
    return /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/g.test(value);
}

function utf8Encode(str) {
    var x;
    var y;
    var output = '';
    var i = -1;
    var l;
    if (str === null || str === void 0 ? void 0 : str.length) {
        l = str.length;
        while ((i += 1) < l) {
            /* Decode utf-16 surrogate pairs */
            x = str.charCodeAt(i);
            y = i + 1 < l ? str.charCodeAt(i + 1) : 0;
            if (0xD800 <= x && x <= 0xDBFF && 0xDC00 <= y && y <= 0xDFFF) {
                x = 0x10000 + ((x & 0x03FF) << 10) + (y & 0x03FF);
                i += 1;
            }
            /* Encode output as utf-8 */
            if (x <= 0x7F) {
                output += String.fromCharCode(x);
            }
            else if (x <= 0x7FF) {
                output += String.fromCharCode(0xC0 | ((x >>> 6) & 0x1F), 0x80 | (x & 0x3F));
            }
            else if (x <= 0xFFFF) {
                output += String.fromCharCode(0xE0 | ((x >>> 12) & 0x0F), 0x80 | ((x >>> 6) & 0x3F), 0x80 | (x & 0x3F));
            }
            else if (x <= 0x1FFFFF) {
                output += String.fromCharCode(0xF0 | ((x >>> 18) & 0x07), 0x80 | ((x >>> 12) & 0x3F), 0x80 | ((x >>> 6) & 0x3F), 0x80 | (x & 0x3F));
            }
        }
    }
    return output;
}
function binl2rstr(input) {
    var i;
    var l = input.length * 32;
    var output = '';
    for (i = 0; i < l; i += 8) {
        output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF);
    }
    return output;
}
function bitRol(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt));
}
function rstr2binl(input) {
    var i;
    var l = input.length * 8;
    var output = Array(input.length >> 2);
    var lo = output.length;
    for (i = 0; i < lo; i += 1) {
        output[i] = 0;
    }
    for (i = 0; i < l; i += 8) {
        output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32);
    }
    return output;
}
function safeAdd(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF);
}
function hex(s) {
    var input = binl2rstr(binl(rstr2binl(s), s.length * 8));
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i = 0;
    var l = input.length;
    for (; i < l; i += 1) {
        x = input.charCodeAt(i);
        output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f);
    }
    return output;
}
/**
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */
function binl(x, len) {
    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    /* append padding */
    // eslint-disable-next-line
    x[len >> 5] |= 0x80 << len % 32;
    // eslint-disable-next-line
    x[(((len + 64) >>> 9) << 4) + 14] = len;
    for (i = 0; i < x.length; i += 16) {
        olda = a;
        oldb = b;
        oldc = c;
        oldd = d;
        a = md5Ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = md5Ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5Ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5Ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5Ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5Ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5Ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5Ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5Ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5Ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5Ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5Ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5Ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5Ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5Ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5Ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5Gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5Gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5Gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5Gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = md5Gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5Gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5Gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5Gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5Gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5Gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5Gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5Gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5Gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5Gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5Gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5Gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5Hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5Hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5Hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5Hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5Hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5Hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5Hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5Hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5Hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5Hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = md5Hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5Hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5Hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5Hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5Hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5Hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5Ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = md5Ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5Ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5Ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5Ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5Ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5Ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5Ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5Ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5Ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5Ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5Ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5Ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5Ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5Ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5Ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [a, b, c, d];
}
/**
 * These functions implement the four basic operations the algorithm uses.
 */
function md5Cmn(q, a, b, x, s, t) {
    return safeAdd(bitRol(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5Ff(a, b, c, d, x, s, t) {
    return md5Cmn((b & c) | (~b & d), a, b, x, s, t);
}
function md5Gg(a, b, c, d, x, s, t) {
    return md5Cmn((b & d) | (c & ~d), a, b, x, s, t);
}
function md5Hh(a, b, c, d, x, s, t) {
    return md5Cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5Ii(a, b, c, d, x, s, t) {
    return md5Cmn(c ^ (b | ~d), a, b, x, s, t);
}
/**
 *
 * @param str 想要进行 md5 加密的字符串
 * @returns md5 字符串
 */
function md5(str) {
    var s = str;
    try {
        s = hex(utf8Encode(str));
    }
    catch (err) {
        console.log(err, 'md5 err');
    }
    return s;
}

function parseQueryString(query) {
    var vars = query.split('&').filter(function (v) { return v !== ''; });
    var queryString = {};
    if (!vars.length) {
        return queryString;
    }
    vars.forEach(function (var1) {
        var pair = var1.split('=');
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1]);
        if (typeof queryString[key] === 'undefined') {
            queryString[key] = value;
        }
        else if (typeof queryString[key] === 'string') {
            queryString[key] = [queryString[key], value];
        }
        else {
            queryString[key].push(value);
        }
    });
    return queryString;
}
function getQueryObject() {
    return parseQueryString(window.location.search.substring(1));
}

/**
 * 生成随机字符串，默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1
 * @param len 要生成字符串的长度
 */
function randomString(len) {
    if (len === void 0) { len = 9; }
    var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var string = '';
    for (var i = 0; i < len; i++) {
        string += chars[Math.floor(Math.random() * chars.length)];
    }
    return string;
}

/**
 * @name emoji-regex/text.js copied and modified
 * @link https://www.npmjs.com/package/emoji-regex
 */
var VAR_EMOJI_REG = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F?/g;
function removeEmoji(str) {
    return str.replace(VAR_EMOJI_REG, '');
}

function toString(obj) {
    return Object.prototype.toString.call(obj);
}

/**
 * ucs-2 string to base64 encoded ascii
 * @param s {string}
 */
function unicodeToAscii(s) {
    return window.btoa(unescape(encodeURIComponent(s)));
}

/**
 * 解析视频url地址
 * @param source
 */
function urlType(source) {
    var type;
    var url = source;
    // 将 http 替换成 https
    if (!source.includes('https')) {
        url = source.replace('http', 'https');
    }
    if (url.includes('flv')) {
        type = {
            src: url,
            type: 'video/flv',
        };
    }
    else if (url.includes('m3u8')) {
        type = {
            src: url,
            type: 'application/x-mpegURL',
        };
    }
    else if (url.includes('mp4')) {
        type = {
            src: url,
            type: 'video/mp4',
        };
    }
    else if (url.includes('webm')) {
        type = {
            src: url,
            type: 'video/webm',
        };
    }
    else {
        type = {
            src: url,
        };
    }
    return type;
}

var utoa = unicodeToAscii;

/* istanbul ignore file */
/**
 * 生成 v4 版本的 uuid
 * @returns uuid 字符串
 */
function uuidv4() {
    // eslint-disable-next-line
    return getGuid();
}

var strings = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addURLSearch: addURLSearch,
    asciiToUnicode: asciiToUnicode,
    atou: atou,
    compareVersion: compareVersion,
    dealSearchStr: dealSearchStr,
    deleteURLSearch: deleteURLSearch,
    escapeHtml: escapeHtml,
    filterXss: filterXss,
    getAppVersion: getAppVersion,
    getGuid: getGuid,
    getRandomString: getRandomString,
    getRequest: getRequest,
    getStrLength: getStrLength,
    wxConfig: wxConfig,
    getWxAppid: getWxAppid,
    getWxOriginId: getWxOriginId,
    isBankCardNum: isBankCardNum,
    isChineseName: isChineseName,
    isEmail: isEmail,
    isIdNum: isIdNum,
    isPostcode: isPostcode,
    md5: md5,
    parseQueryString: parseQueryString,
    getQueryObject: getQueryObject,
    randomString: randomString,
    removeEmoji: removeEmoji,
    toString: toString,
    unicodeToAscii: unicodeToAscii,
    urlType: urlType,
    utoa: utoa,
    uuidv4: uuidv4
});

/**
 * 用户图像 文字转图片 base64格式
 * @param txt {string}
 * @param fontSize {number}
 * @param canvasWidth {number}
 * @param canvasHeight {number}
 * @param fillTextX {number}
 * @param fillTextY {number}
 */
function textToImg(_a) {
    var _b = _a.txt, txt = _b === void 0 ? '' : _b, _c = _a.canvasWidth, canvasWidth = _c === void 0 ? 120 : _c, _d = _a.fontSize, fontSize = _d === void 0 ? 40 : _d, _e = _a.canvasHeight, canvasHeight = _e === void 0 ? 120 : _e, _f = _a.fillTextX, fillTextX = _f === void 0 ? 60 : _f, _g = _a.fillTextY, fillTextY = _g === void 0 ? 60 : _g, _h = _a.fillStyle, fillStyle = _h === void 0 ? '#006FFF' : _h;
    var fontWeight = 'bold';
    var canvas = document.createElement('canvas');
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    var context = canvas.getContext('2d');
    context.fillStyle = fillStyle;
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = '#FFF';
    context.font = "".concat(fontWeight, " ").concat(fontSize, "px sans-serif");
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillText(txt, fillTextX, fillTextY);
    return canvas.toDataURL('image/png');
}

var defaultAvatar = 'madialab-storage-1256380422.cos.ap-guangzhou.myqcloud.com/img/vst_ico80x80_2x.png';
var defaultParams = {
    username: '',
    avatar: '',
    isDefaultAvatar: -1,
    fontSize: 60,
    from: '',
    canvasWidth: 120,
    canvasHeight: 120,
    fillTextX: 60,
    fillTextY: 60,
    needDecode: true,
    fillStyle: '#006FFF',
};
/**
 * 自定义获取用户图像
 * @return {string}
 * @param params { UserInfoParams }
 */
function getAvatarImg(params) {
    var _a = Object.assign({}, defaultParams, params), username = _a.username, avatar = _a.avatar, isDefaultAvatar = _a.isDefaultAvatar, fontSize = _a.fontSize, from = _a.from, canvasWidth = _a.canvasWidth, canvasHeight = _a.canvasHeight, fillTextX = _a.fillTextX, fillTextY = _a.fillTextY, needDecode = _a.needDecode, fillStyle = _a.fillStyle;
    var avatorTxt = '';
    // 无username有avatar，直接使用avatar
    if (!username && avatar) {
        return avatar;
    }
    var font = fontSize;
    // avatar 地址为默认头像地址
    var isDefaultAvatarUrl = avatar && avatar.indexOf(defaultAvatar) !== -1;
    // avatar未传 或者 avatar传入默认头像地址 或者 isDefaultAvatar 标记位为1 则canvas生成头像
    if (!avatar || isDefaultAvatarUrl || isDefaultAvatar === 1) {
        avatorTxt = username;
        // 需要解码，则先解码处理
        if (needDecode) {
            avatorTxt = asciiToUnicode(username).trim();
        }
        // 有特殊符号则屏蔽符号，屏蔽后有效字符遵循规则1、2、3，屏蔽后无有效字符则显示”*“
        // 屏蔽字母、数字、中文以外的字符
        var txtFiltered = avatorTxt.replace(/[^a-zA-Z0-9\u4E00-\u9FA5]/g, '');
        // 规则1: 判断长度，如果小于1，直接返回'*'
        if (txtFiltered.length < 1) {
            avatorTxt = '*';
        }
        // 规则2: 判断长度，如果等于1，直接返回
        if (txtFiltered.length === 1) {
            avatorTxt = txtFiltered.toUpperCase();
        }
        // 规则3: 判断是不是包含字母以及-，但是不包含中文
        // 返回首字母大写
        if (/^[a-zA-Z-]+$/.test(txtFiltered)) {
            avatorTxt = txtFiltered.charAt(0).toUpperCase();
        }
        else {
            if (from !== 'pmi-detail') {
                font = 45;
            }
            // 兜底规则：返回最后两个字符
            avatorTxt = txtFiltered.substring(txtFiltered.length - 2);
        }
        return textToImg({
            txt: avatorTxt,
            canvasWidth: canvasWidth,
            canvasHeight: canvasHeight,
            fontSize: font,
            fillTextX: fillTextX,
            fillTextY: fillTextY,
            fillStyle: fillStyle,
        });
    }
    return avatar;
}

/**
 * 根据用户信息获取用户图像
 * @param userInfo {BaseUserInfo}
 * @param needDecode
 */
function getAvatarByUser(userInfo, needDecode) {
    if (needDecode === void 0) { needDecode = true; }
    var nickName = userInfo.nickName;
    if (nickName === '' && userInfo.userType === 2) {
        nickName = '企业微信用户';
    }
    return getAvatarImg({
        username: nickName || userInfo.userid,
        avatar: userInfo.avatar,
        needDecode: needDecode,
    });
}

/**
 * get-change-log
 * web-base
 * @author michaelbguo@tencent.com
 * @time 2021/3/5 16:08
 * @version 0.1.10
 * @param title {string}
 * @param data
 */
function getChangeLog(title, data) {
    var time = new Date().toTimeString()
        .split(' ')[0];
    console.log('%c%s', 'color:#1890ff', "".concat(title, ": change at ").concat(time));
    console.log('%o', 'color:#169fe6', data);
}

/**
 * get-elements
 *
 * @author michaelbguo@tencent.com
 * @time 2021/4/12 17:29
 * @version 0.0.1
 */
function getElements(selector) {
    if (selector.indexOf('.') !== -1) {
        return document.querySelectorAll(selector);
    }
    return document.getElementsByClassName(selector);
}

/**
 * 获取路径的host
 * @param href {string} url链接地址
 */
function getHost(href) {
    if (href === void 0) { href = ''; }
    if (href.startsWith('http://') || href.startsWith('https://')) {
        var host = href.replace(/^(https?:\/\/[^/]+).*$/, '$1');
        if (host) {
            return host;
        }
        return href;
    }
    if (!isServer) {
        return window.location.host;
    }
    return href;
}

function getHtmlLang() {
    if (typeof document === 'undefined') {
        return 'zh-CN';
    }
    return document.documentElement.lang || document.getElementsByTagName('html')[0].getAttribute('lang') || 'zh-CN';
}

/**
 * 获取当前页面的地址
 * @param ctx {?NextGetServerSidePropsContext} next.js的上下文
 * @returns {string} 当前页面的地址, 如果是服务端, 则返回空字符串或ctx的url
 */
function getLocationHref(ctx) {
    var _a;
    if (isServer) {
        return ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.url) || '';
    }
    return window.location.href;
}

/**
 * 获取用于展示的用户名
 * @param item 用户信息数据
 * @param englishBefore 昵称拼接时是否english_name在前
 * @returns string
 */
var getName = function (item, englishBefore) {
    if (englishBefore === void 0) { englishBefore = false; }
    if (item.nickname || item.nick_name) {
        return item.nickname || item.nick_name;
    }
    // 对local_name被编码的情况兼容解码处理
    var endStr = '';
    try {
        // 中文字符编码区
        var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
        if (reg.test(item.local_name)) {
            endStr = item.local_name;
        }
        else {
            endStr = asciiToUnicode(item.local_name);
        }
    }
    catch (error) {
        console.error(error);
        endStr = item.local_name;
    }
    if (item.local_name && item.english_name) {
        if (englishBefore) {
            return "".concat(item.english_name, "(").concat(endStr, ")");
        }
        return "".concat(endStr, "(").concat(item.english_name, ")");
    }
    if (item.local_name) {
        return endStr;
    }
    if (item.english_name) {
        return item.english_name;
    }
    return '';
};

/**
 * get-node-list
 *
 * @author michaelbguo@tencent.com
 * @time 2021/4/12 17:44
 * @version 0.0.1
 */
function getNodeList(selector) {
    return document.querySelectorAll(selector);
}

/**
 * 获取dom元素的绝对位置 - left
 * @author ethanjzhao@tencent.com
 * @date 2022-06-07 11:26:14
 * @param element
*/
function getOffsetLeft(element) {
    var actualLeft = element.offsetLeft;
    var current = element.offsetParent;
    while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
    }
    return actualLeft;
}

/**
 * 获取dom元素的绝对位置 - top
 * @author ethanjzhao@tencent.com
 * @date 2022-06-07 11:36:18
 * @param element
*/
function getOffsetTop(element) {
    var actualTop = element.offsetTop;
    var current = element.offsetParent;
    while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }
    return actualTop;
}

/**
 * 滚动到指定dom
 * @param { string } value
 * @return null
 */
function scrollToDom(value) {
    var _a;
    if (!value) {
        return;
    }
    (_a = document.querySelector(value)) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
        behavior: 'smooth',
    });
}

var dom = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addClassName: addClassName,
    removeClassName: removeClassName,
    createElement: createElement,
    findById: findById,
    forEachNode: forEachNode,
    getAvatarByUser: getAvatarByUser,
    getAvatarImg: getAvatarImg,
    getChangeLog: getChangeLog,
    getElements: getElements,
    getHost: getHost,
    getHtmlLang: getHtmlLang,
    getLocationHref: getLocationHref,
    getName: getName,
    getNodeList: getNodeList,
    getOffsetLeft: getOffsetLeft,
    getOffsetTop: getOffsetTop,
    scrollToDom: scrollToDom,
    textToImg: textToImg
});

var ConstantEnum = {
    /**
     * web-tools redux localStorage key
     */
    WEMEET_WEB_TOOLS_KEY: 'persist:root',
    /**
     * web-base localStorage key
     */
    WEMEET_STORAGE_KEY: 'tencent-meeting-web-redux-store',
    /**
     * 灯塔
     */
    WEMEET_BEACON_DEBUG_KEY: 'LOGDEBUGKEY00254',
    WEMEET_BEACON_PROD_KEY: '00000C2AM539PVHX',
    /**
     * 开启灯塔实时联调
     */
    WEMEET_BEACON_OPEN_DEBUG: 'debugBeacon',
    /**
     * 防水墙appid
     */
    CAPTCHA_APP_ID: '2099486352',
    /**
     * VooV 防水墙appid
     */
    VOOV_CAPTCHA_APP_ID: '188904464',
};

/**
 * Instance Id定义映射
 */
/**
 终端类型定义
 enum InstanceType {
  kInstanceTypeNone         = 0,
  kInstanceTypeWin          = 1,    // PC - windows
  kInstanceTypeMac          = 2,    // Mac
  kInstanceTypeAndroid      = 3,    // Android
  kInstanceTypeIPhone       = 4,    // iPhone
  kInstanceTypeWeb          = 5,    // web
  kInstanceTypeIPad         = 6,    // iPad
  kInstanceTypeAPad         = 7,    // aPad
  kInstanceTypeMiniProgram  = 8,    // wechat mini program
};
 */
var InstanceTypeMap = {
    0: 'None',
    1: 'Windows',
    2: 'Mac',
    3: 'Android',
    4: 'iPhone',
    5: 'Web',
    6: 'iPad',
    7: 'aPad',
    8: 'wxProgram',
};
/**
 * 获取当前客户端类型
 * @param userAgent
 */
function getDeviceType$2(userAgent) {
    return getInstanceId(userAgent).name;
}
/**
 * 获取当前客户端实例Id
 * @param userAgent
 */
function getInstanceId(userAgent) {
    var id = 0;
    if (isWinApp(userAgent)) {
        id = 1;
    }
    else if (isMacApp(userAgent)) {
        id = 2;
    }
    else if (isAndroid(userAgent) && isWeMeetApp(userAgent)) {
        id = 3;
    }
    else if (isIPhone(userAgent) && isWeMeetApp(userAgent)) {
        id = 4;
    }
    else if (!isWeMeetApp(userAgent)) {
        id = 5;
    }
    else if (isIpad(userAgent) && isWeMeetApp(userAgent)) {
        id = 6;
    }
    return {
        id: id,
        name: InstanceTypeMap[id] || '',
    };
}

/**
 * 判断是正式环境
 * @param href {?string} 默认为当前页面的location.href
 * @deprecated 推荐使用编译时环境变量代替
 * @example
 * ```
 * // 正式环境
 * isNormalEnv();
 * isNormalEnv('http://meeting.tencent.com');
 * isNormalEnv('http://cloud.tencent.com');
 * isNormalEnv('https://meeting.qq.com');
 * isNormalEnv('http://wemeet.qq.com');
 * isNormalEnv('https://voovmeeting.com');
 * ```
 */
function isNormalEnv(href) {
    if (href === void 0) { href = ''; }
    if (!isServer && !href) {
        // eslint-disable-next-line no-param-reassign
        href = location.href;
    }
    return (/^(http|https):\/\/(cloud|meeting|wemeet)\.(qq|tencent)\.com/.test(href)
        || /^(http|https):\/\/voovmeeting\.com/.test(href)
        || /prerelease\.cicd\.tencentmeeting\.com/.test(href));
}

var colorDic = {
    warn: {
        color: '#ff7b00',
        weight: 'bold',
    },
    debug: {
        color: '#ffb270',
        weight: 'bold',
    },
    info: {
        color: '#000000',
        weight: 'normal',
    },
    title: {
        color: '#000000',
        weight: 'bold',
    },
    gray: {
        color: 'gray',
        weight: 'lighter',
    },
    error: {
        color: 'red',
        weight: 'bold',
    },
    field: {
        color: '#2196F3',
        weight: 'bold',
    },
    normal: {
        color: 'black',
        weight: 'bold',
    },
    default: {
        color: 'black',
        weight: 'normal',
    },
};
var ColorEnum;
(function (ColorEnum) {
    ColorEnum["warn"] = "warn";
    ColorEnum["debug"] = "debug";
    ColorEnum["info"] = "info";
    ColorEnum["title"] = "title";
    ColorEnum["gray"] = "gray";
    ColorEnum["error"] = "error";
    ColorEnum["field"] = "field";
    ColorEnum["normal"] = "normal";
    ColorEnum["default"] = "default";
})(ColorEnum || (ColorEnum = {}));
function addStyle(type) {
    return "color: ".concat(colorDic[type].color, "; font-weight: ").concat(colorDic[type].weight);
}

/**
 * 数字前面添0补齐
 * @param {number} num             数字
 * @param {number} maxLength     补齐后长度
 */
var prefixZero = function (num, maxLength) { return '0'.repeat(maxLength - num.toString().length) + num; };
// 格式化时间 HH:mm:ss:msmsms
var formatTime = function (time) {
    // eslint-disable-next-line implicit-arrow-linebreak
    return "".concat(prefixZero(time.getHours(), 2), ":").concat(prefixZero(time.getMinutes(), 2), ":").concat(prefixZero(time.getSeconds(), 2), ".").concat(prefixZero(time.getMilliseconds(), 3));
};
function getNow() {
    return formatTime(new Date());
}

/**
 * 在字符串尾部补齐
 * @param {string} str             要补齐的字符串
 * @param {number} targetLength 补齐后字符串长度
 * @param {string} padString    用于补齐的字符串
 * ex: padEnd('a', 5, 'cb') -> 'acbcb'
 */
function padEnd(str, targetLength, padString) {
    // 字符串转数字，非数字转0
    /* eslint-disable no-param-reassign */
    targetLength >>= 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (str.length > targetLength) {
        return String(str);
    }
    targetLength -= str.length;
    if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
    }
    /* eslint-enable no-param-reassign */
    return String(str) + padString.slice(0, targetLength);
}

var shouldPrint = process.env.NODE_ENV !== 'production';
// 默认配置
var defaultOptions = {
    reportInterval: 1000,
};
var Printer = /** @class */ (function () {
    function Printer(logger, namespace, showTime) {
        if (showTime === void 0) { showTime = true; }
        this.showTime = true;
        this.logCacheQueue = [];
        this.logAllCacheQueue = [];
        this.logErrorCacheQueue = [];
        this.options = defaultOptions;
        /**
         * 上次上报的时间戳
         */
        this.preReportTimestamp = 0;
        this.logger = logger;
        this.namespace = namespace;
        this.showTime = showTime;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Printer.prototype.setConfig = function () {
        var _a, _b;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.setConfig) === null || _b === void 0 ? void 0 : _b.call.apply(_b, __spreadArray([_a], args, false));
    };
    Printer.prototype.getNamespace = function () {
        return this.namespace;
    };
    Printer.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!shouldPrint)
            return;
        console.log.apply(console, args);
    };
    Printer.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var head = this.getHeader();
        var logArgs = args;
        var queueArgs = Array.from(args);
        logArgs.unshift("%c".concat(head), addStyle(ColorEnum.title));
        this.info.apply(this, logArgs);
        queueArgs.unshift(head);
        // this.logQueue.push(...queueArgs);
        // this.pushToCache('log', queueArgs);
    };
    Printer.prototype.logAll = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var head = this.getHeader();
        var logArgs = args;
        var queueArgs = Array.from(args);
        logArgs.unshift("%c".concat(head), addStyle(ColorEnum.title));
        this.info.apply(this, logArgs);
        queueArgs.unshift(head);
        this.pushToCache('logAll', queueArgs);
    };
    Printer.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var head = this.getHeader();
        var logArgs = args;
        var queueArgs = Array.from(args);
        logArgs.unshift("%c".concat(head), addStyle(ColorEnum.error));
        this.info.apply(this, logArgs);
        queueArgs.unshift(head);
        this.pushToCache('error', queueArgs);
    };
    Printer.prototype.report = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var head = this.getHeader();
        var logArgs = args;
        var queueArgs = Array.from(args);
        logArgs.unshift("%c".concat(head), addStyle(ColorEnum.title));
        this.info.apply(this, logArgs);
        queueArgs.unshift(head);
        this.pushToCache('logAll', queueArgs);
    };
    Printer.prototype.table = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        console.table.apply(console, args);
    };
    Printer.prototype.group = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!shouldPrint)
            return;
        var head = this.getHeader();
        var argsTmp = args.splice(0, 1);
        args.unshift("%c".concat(head).concat(argsTmp), addStyle(ColorEnum.title));
        console.group.apply(console, args);
    };
    Printer.prototype.groupCollapsed = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!shouldPrint)
            return;
        var head = this.getHeader();
        var argsTmp = args.splice(0, 1);
        args.unshift("%c".concat(head).concat(argsTmp), addStyle(ColorEnum.title));
        console.groupCollapsed.apply(console, args);
    };
    Printer.prototype.groupEnd = function () {
        if (!shouldPrint)
            return;
        console.groupEnd();
    };
    Printer.prototype.groupObj = function (type, groupLog, Obj, componentName) {
        if (componentName === void 0) { componentName = ''; }
        var padding = 12;
        var warnDuration = 17;
        var errorDuration = 100;
        if (Obj.time) {
            var duration = Obj.time.toFixed(2);
            var colorStyle = void 0;
            if (duration < warnDuration) {
                colorStyle = addStyle(ColorEnum.gray);
            }
            else if (duration >= warnDuration && duration < errorDuration) {
                colorStyle = addStyle(ColorEnum.warn);
            }
            else {
                colorStyle = addStyle(ColorEnum.error);
            }
            this.groupCollapsed("%c".concat(type, " %c").concat(componentName, " ").concat(groupLog, " %c(in ").concat(duration, " ms)"), addStyle(ColorEnum.gray), addStyle(ColorEnum.normal), colorStyle);
        }
        else {
            this.groupCollapsed("%c".concat(type, " %c").concat(componentName, " ").concat(groupLog), addStyle(ColorEnum.gray), addStyle(ColorEnum.normal));
        }
        // eslint-disable-next-line no-restricted-syntax
        for (var key in Obj) {
            if (key !== 'time') {
                var value = Obj[key];
                var ftype = typeof value === 'object' ? '%o' : '%s';
                this.info("%c".concat(padEnd(" ".concat(key), padding), "%c").concat(ftype), addStyle(ColorEnum.field), addStyle(ColorEnum.default), value);
            }
        }
        this.groupEnd();
    };
    /**
     * @returns <string> log前置内容
     */
    Printer.prototype.getHeader = function () {
        var header = this.showTime ? "".concat(getNow()) : '';
        if (this.namespace) {
            header = "".concat(header, "][").concat(this.namespace);
        }
        return "[".concat(header, "]");
    };
    /**
     * 推送到缓存
     * @param type <'log' | 'logAll' | 'error'>
     * @param logInfo <any[]> log信息
     */
    Printer.prototype.pushToCache = function (type, logInfo) {
        switch (type) {
            case 'log':
                this.logCacheQueue.push(logInfo);
                break;
            case 'logAll':
                this.logAllCacheQueue.push(logInfo);
                this.sendLogAll();
                break;
            case 'error':
                this.logErrorCacheQueue.push(logInfo);
                break;
        }
        var now = new Date().getTime();
        if (now - this.preReportTimestamp > this.options.reportInterval) {
            this.preReportTimestamp = now;
            this.sendLog();
            // this.sendLogAll();
            this.sendError();
        }
    };
    Printer.prototype.sendLog = function () {
        if (this.logCacheQueue.length) {
            this.logger.log(this.logCacheQueue);
            this.logCacheQueue = [];
        }
    };
    Printer.prototype.sendLogAll = function () {
        if (this.logAllCacheQueue.length) {
            this.logger.logAll(this.logAllCacheQueue);
            this.logAllCacheQueue = [];
        }
    };
    Printer.prototype.sendError = function () {
        if (this.logErrorCacheQueue.length) {
            this.logger.error(this.logErrorCacheQueue);
            this.logErrorCacheQueue = [];
        }
    };
    return Printer;
}());

var AegisLogger = /** @class */ (function () {
    function AegisLogger(pluginPkg, options) {
        this.instance = new (pluginPkg.default || pluginPkg)(options);
    }
    AegisLogger.prototype.setConfig = function (options) {
        return this.instance.setConfig(options);
    };
    AegisLogger.prototype.useSpace = function (namespace) {
        return new Printer(this, namespace);
    };
    AegisLogger.prototype.log = function (args) {
        var _a;
        var _this = this;
        if (Array.isArray(args)) {
            args.forEach(function (item) {
                var _a;
                (_a = _this.instance).info.apply(_a, item);
            });
        }
        else {
            (_a = this.instance).info.apply(_a, args);
        }
    };
    AegisLogger.prototype.logAll = function (args) {
        var _a;
        var _this = this;
        if (Array.isArray(args)) {
            args.forEach(function (item) {
                var _a;
                (_a = _this.instance).infoAll.apply(_a, item);
            });
        }
        else {
            (_a = this.instance).infoAll.apply(_a, args);
        }
    };
    AegisLogger.prototype.error = function (args) {
        var _a;
        var _this = this;
        if (Array.isArray(args)) {
            args.forEach(function (item) {
                var _a;
                (_a = _this.instance).error.apply(_a, item);
            });
        }
        else {
            (_a = this.instance).error.apply(_a, args);
        }
    };
    return AegisLogger;
}());

var BeaconLogger = /** @class */ (function () {
    function BeaconLogger(pluginPkg) {
        this.config = {
            userid: '',
            device_type: '',
            user_agent: '',
            app_uid: '',
            app_id: '',
            user_ip: '',
            meeting_id: '',
            is_overseas: '',
            nav_platform: '',
        };
        this.instance = pluginPkg;
    }
    BeaconLogger.prototype.setConfig = function (options) {
        this.config = __assign(__assign({}, this.config), options);
        return this.config;
    };
    BeaconLogger.prototype.useSpace = function (namespace) {
        return new Printer(this, namespace);
    };
    BeaconLogger.prototype.log = function (eventName, reports) {
        if (reports === void 0) { reports = {}; }
        this.instance(eventName, __assign(__assign({}, this.config), reports));
    };
    BeaconLogger.prototype.logAll = function (eventName, reports) {
        if (reports === void 0) { reports = {}; }
        this.instance(eventName, __assign(__assign({}, this.config), reports));
    };
    BeaconLogger.prototype.error = function (eventName, reports) {
        if (reports === void 0) { reports = {}; }
        this.instance(eventName, __assign(__assign({}, this.config), reports));
    };
    BeaconLogger.prototype.report = function (eventName, reports) {
        if (reports === void 0) { reports = {}; }
        this.instance(eventName, __assign(__assign({}, this.config), reports));
    };
    return BeaconLogger;
}());

var PluginEnum;
(function (PluginEnum) {
    /**
     * aegis监控
     */
    PluginEnum["aegis"] = "aegis";
    /**
     * 灯塔上报
     */
    PluginEnum["beacon"] = "beacon";
})(PluginEnum || (PluginEnum = {}));
var pluginMap = {
    aegis: AegisLogger,
    beacon: BeaconLogger,
};

var LoggerUtil = /** @class */ (function () {
    function LoggerUtil() {
        this.installedPlugins = {};
        return this;
    }
    // 安装插件
    LoggerUtil.prototype.install = function (pluginName, pluginPkg, options) {
        if (this.installedPlugins[pluginName]) {
            console.warn("[loggerUtil]".concat(pluginName, "\u5DF2\u7ECF\u52A0\u8F7D\uFF0C\u65E0\u9700\u91CD\u590D\u52A0\u8F7D"));
        }
        // eslint-disable-next-line @typescript-eslint/naming-convention
        var PluginCls = pluginMap[pluginName];
        var plugin = new PluginCls(pluginPkg, options);
        this.installedPlugins[pluginName] = plugin;
    };
    // 使用插件
    LoggerUtil.prototype.use = function (pluginName, namespace) {
        if (!pluginName) {
            return new Printer(this, namespace);
        }
        if (this.installedPlugins[pluginName]) {
            if (namespace) {
                return this.installedPlugins[pluginName].useSpace(namespace);
            }
            return this.installedPlugins[pluginName];
        }
        // 私有化环境不上报，所以去除warning
        if (isNormalEnv() || isTestEnv() || isPreReleaseEnv() || isLocalEnv()) {
            console.warn("pluginName ".concat(pluginName, " is not install\uFF0C\u8BF7\u786E\u8BA4\u6587\u4EF6\u52A0\u8F7D\u987A\u5E8F\uFF0Clogger\u7684\u52A0\u8F7D\u9700\u8981\u7F6E\u4E8E\u4E1A\u52A1\u4EE3\u7801\u4E4B\u524D"));
        }
        return new Printer(this, namespace);
    };
    LoggerUtil.prototype.setConfig = function () { };
    LoggerUtil.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (_a = new Printer(this)).log.apply(_a, args);
    };
    LoggerUtil.prototype.logAll = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.log.apply(console, args);
    };
    LoggerUtil.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.error.apply(console, args);
    };
    LoggerUtil.prototype.report = function () { };
    return LoggerUtil;
}());
var loggerUtil = new LoggerUtil();

var loggerUtil$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LoggerUtil: LoggerUtil,
    loggerUtil: loggerUtil
});

/**
 * log的全局配置
 */
var Config = /** @class */ (function () {
    function Config(option) {
        this.options = {
            /**
             * 是否开启代理
             */
            openProxy: false,
        };
        if (!Config.instance) {
            this.options = __assign(__assign({}, this.options), option);
            Config.instance = this;
            return this;
        }
        Config.instance.set(option);
        return Config.instance;
    }
    Config.prototype.set = function (option) {
        if (option === void 0) { option = {}; }
        this.options = __assign(__assign({}, this.options), option);
    };
    Config.prototype.get = function () {
        return this.options;
    };
    return Config;
}());

var asyncPromise = null;
var getAegis = function () {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (asyncPromise) {
        return asyncPromise;
    }
    asyncPromise = import('@tencent/aegis-web-sdk');
    return asyncPromise;
};
var loadAegis = function (aegisOption, Aegis) { return __awaiter(void 0, void 0, void 0, function () {
    var logger, curAegis;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                logger = loggerUtil.use(undefined, 'load-aegis');
                curAegis = Aegis || getWindow().Aegis;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                if (!!curAegis) return [3 /*break*/, 3];
                return [4 /*yield*/, getAegis()];
            case 2:
                curAegis = (_b.sent()).default;
                _b.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                _b.sent();
                logger.error('loadScript aegis error');
                return [3 /*break*/, 5];
            case 5:
                loggerUtil.install(PluginEnum.aegis, curAegis, __assign({ reportApiSpeed: true, reportAssetSpeed: true }, aegisOption));
                return [2 /*return*/];
        }
    });
}); };

/**
 * 深拷贝 数组 或 对象
 * */
function deepCopy(o) {
    if (o instanceof Array) {
        var n = [];
        for (var i = 0; i < o.length; ++i) {
            n[i] = deepCopy(o[i]);
        }
        return n;
    }
    if (o instanceof Object) {
        var n = {};
        // eslint-disable-next-line no-restricted-syntax
        for (var i in o) {
            n[i] = deepCopy(o[i]);
        }
        return n;
    }
    return o;
}

/**
 * 企业类型
 */
var CorpTypeEnum;
(function (CorpTypeEnum) {
    /** 企业版 */
    CorpTypeEnum[CorpTypeEnum["CORP"] = 2] = "CORP";
    /** 企业微信版 */
    CorpTypeEnum[CorpTypeEnum["WEWORK_CORP"] = 3] = "WEWORK_CORP";
    /** 渠道付费版 */
    CorpTypeEnum[CorpTypeEnum["CHANNEL"] = 9] = "CHANNEL";
    /** 团队版 */
    CorpTypeEnum[CorpTypeEnum["TEAM"] = 11] = "TEAM";
    /** 教育版 */
    CorpTypeEnum[CorpTypeEnum["EDUCATION"] = 16] = "EDUCATION";
})(CorpTypeEnum || (CorpTypeEnum = {}));
/**
 * 付费类型
 */
var PayTagEnum;
(function (PayTagEnum) {
    /** 免费个人版 */
    PayTagEnum[PayTagEnum["FREE_PERSONAL"] = 0] = "FREE_PERSONAL";
    /** 付费个人专业版 */
    PayTagEnum[PayTagEnum["PAY_PROFESSIONAL"] = 1] = "PAY_PROFESSIONAL";
    /** 付费企业版 */
    PayTagEnum[PayTagEnum["PAY_ENTERPRISE"] = 2] = "PAY_ENTERPRISE";
    /** 付费商业版 */
    PayTagEnum[PayTagEnum["PAY_BUSINESS"] = 11] = "PAY_BUSINESS";
    /** 免费企业版 */
    PayTagEnum[PayTagEnum["FREE_ENTERPRISE"] = 15] = "FREE_ENTERPRISE";
    /** 付费教育版 */
    PayTagEnum[PayTagEnum["PAY_EDUCATION"] = 16] = "PAY_EDUCATION";
    /** 会员版 */
    PayTagEnum[PayTagEnum["PAY_MEMBER"] = 17] = "PAY_MEMBER";
})(PayTagEnum || (PayTagEnum = {}));
/**
 * 综合企业付费类型
 */
var CorpPayTypeEnum;
(function (CorpPayTypeEnum) {
    /** 免费个人版 */
    CorpPayTypeEnum[CorpPayTypeEnum["FREE_PERSONAL"] = 0] = "FREE_PERSONAL";
    /** 免费企业版 */
    CorpPayTypeEnum[CorpPayTypeEnum["FREE_ENTERPRISE"] = 1] = "FREE_ENTERPRISE";
    /** 免费企业微信版 */
    CorpPayTypeEnum[CorpPayTypeEnum["FREE_WEWORK"] = 2] = "FREE_WEWORK";
    /** 付费个人专业版 */
    CorpPayTypeEnum[CorpPayTypeEnum["PAY_PROFESSIONAL"] = 3] = "PAY_PROFESSIONAL";
    /** 付费企业版 */
    CorpPayTypeEnum[CorpPayTypeEnum["PAY_ENTERPRISE"] = 4] = "PAY_ENTERPRISE";
    /** 付费商业版 */
    CorpPayTypeEnum[CorpPayTypeEnum["PAY_BUSINESS"] = 5] = "PAY_BUSINESS";
    /** 付费教育版 */
    CorpPayTypeEnum[CorpPayTypeEnum["PAY_EDUCATION"] = 6] = "PAY_EDUCATION";
    /** 付费会员版 */
    CorpPayTypeEnum[CorpPayTypeEnum["PAY_MEMBER"] = 7] = "PAY_MEMBER";
    /** 未知类型 */
    CorpPayTypeEnum[CorpPayTypeEnum["UN_KNOWN"] = 8] = "UN_KNOWN";
})(CorpPayTypeEnum || (CorpPayTypeEnum = {}));
var PERSONAL_CORP_ID = '200000001';
/**
 * 获取 tag_type
 */
var getTagType = function (payTagData) {
    var _a;
    var payTag = payTagData === null || payTagData === void 0 ? void 0 : payTagData.tag_type;
    // 个人版从 user_pay_tag 取值
    if ((payTagData === null || payTagData === void 0 ? void 0 : payTagData.corp_id) === PERSONAL_CORP_ID && (payTagData === null || payTagData === void 0 ? void 0 : payTagData.user_pay_tag)) {
        payTag = (_a = payTagData === null || payTagData === void 0 ? void 0 : payTagData.user_pay_tag) === null || _a === void 0 ? void 0 : _a.tag_type;
    }
    return payTag;
};
/**
 * @param data
 * corpType：为 “/v2/account/login/refresh-token” 接口返回的 “corp_type”。http://cowork.yapi.woa.com/project/41/interface/api/92
 * payTagData “/v2/corp/corp/corp-pay-tag” 接口返回的 “data”。http://cowork.yapi.woa.com/project/41/interface/api/2088
 */
var getCorpPayType = function (data) {
    var _a = data || {}, corpType = _a.corpType, payTagData = _a.payTagData;
    var payTag = getTagType(payTagData);
    // 免费企业微信版
    if (corpType === CorpTypeEnum.WEWORK_CORP && payTag === PayTagEnum.FREE_ENTERPRISE) {
        return CorpPayTypeEnum.FREE_WEWORK;
    }
    switch (payTag) {
        case PayTagEnum.FREE_PERSONAL:
            return CorpPayTypeEnum.FREE_PERSONAL;
        case PayTagEnum.FREE_ENTERPRISE:
            return CorpPayTypeEnum.FREE_ENTERPRISE;
        case PayTagEnum.PAY_PROFESSIONAL:
            return CorpPayTypeEnum.PAY_PROFESSIONAL;
        case PayTagEnum.PAY_ENTERPRISE:
            return CorpPayTypeEnum.PAY_ENTERPRISE;
        case PayTagEnum.PAY_BUSINESS:
            return CorpPayTypeEnum.PAY_BUSINESS;
        case PayTagEnum.PAY_EDUCATION:
            return CorpPayTypeEnum.PAY_EDUCATION;
        case PayTagEnum.PAY_MEMBER:
            return CorpPayTypeEnum.PAY_MEMBER;
        default:
            return CorpPayTypeEnum.UN_KNOWN;
    }
};
// 是否是 “个人版”
var isPersonalCorpType = function (corpId) { return corpId === PERSONAL_CORP_ID; };

/**
 * 未登录下，获取跳转地址
 * 使用方法：window.location.replace(getLoginUrl(window.location.href))
 *
 * @param redirectLink 回跳地址。必填 完整回跳url，例如：https://meeting.tencent.com/user-center/personal-information. 无需 encode
 * @param extendsParams 需要增加的参数，例如 { m_source_id: xxx }, 给到登录页的参数，也可以 { default_login: 'personal' }
 * @param ua ua 默认为 navigator.useragent, 服务端可从request中获取
 * @returns string; eg: https://meeting.tencent.com/login.html?redirect_link=http...&x=a&y=b
 */
var getLoginUrl = function (redirectLink, extendsParams, ua) {
    var userAgent = getUserAgent(ua);
    var url = new URL(redirectLink);
    var basicUrl = '/login.html';
    if (isWechat(userAgent)) {
        basicUrl = '/v2/login/wechat';
    }
    if (isWxWork(userAgent)) {
        basicUrl = '/v2/login/wecom';
    }
    return addURLSearch("".concat(url.origin).concat(basicUrl, "?redirect_link=").concat(encodeURIComponent(redirectLink)), extendsParams);
};

var isPromise = function (e) {
    return (Promise.resolve(e) === e
        || Object.prototype.toString.call(e) === '[object Promise]'
        || Boolean(e && typeof e.then === 'function'));
};

var storageConfig = {
    /**
     * 用户配置
     */
    user: {},
    /**
     * 合并后的配置
     */
    merged: {
        debug: false,
        cache: true,
        logger: console,
    },
};

var ModuleMap = new Map([
    ['user-center', 'u'],
    ['v2', 'nm'],
    ['marketplace', 'mp'],
    ['dw', 'dw'],
    ['dm', 'dm'],
    ['dc', 'dc'],
    ['live', 'l'],
    ['s', 's'],
    ['web-base', 'wb'],
    ['met-component', 'mc'],
]);

function getFirstPath() {
    return window.location.pathname.split('/')[1];
}

var S_PREFIX = '#S';
var EXPIRED = '#EXPIRED';

function encode(data, expires) {
    var origin;
    if (expires) {
        origin = {
            '#v': data,
            '#e': Date.now() + expires * 1000,
        };
    }
    else {
        origin = data;
    }
    return origin;
}

function decode(encodeData) {
    if (encodeData['#e']) {
        if (encodeData['#e'] > Date.now()) {
            return encodeData['#v'];
        }
        return EXPIRED;
    }
    return encodeData;
}

function getValidData(encodeData) {
    if (!encodeData) {
        return encodeData;
    }
    return decode(encodeData);
}

/**
 * 生成存储key
 */
function genKey(moduleName) {
    return "".concat(S_PREFIX).concat(moduleName);
}

function set(preData, key, encodeData) {
    var _a, _b;
    if (!preData) {
        return _a = {},
            _a[key] = encodeData,
            _a;
    }
    return __assign(__assign({}, preData), (_b = {}, _b[key] = encodeData, _b));
}

function storageDebugger(tool, data) {
    if (storageConfig.merged.debug) {
        storageConfig.merged.logger.log("".concat(tool, " data from ").concat(storageConfig.merged.cache ? 'memory' : tool, " ->"), data);
    }
}

function getSharedLocalData() {
    if (isServer) {
        return sharedLocalData;
    }
    if (!getWindow()._WB_sharedLocalData) {
        getWindow()._WB_sharedLocalData = sharedLocalData;
    }
    return getWindow()._WB_sharedLocalData;
}
var sharedLocalData = {};
var hasSyncFromLocal = [];
var LocalStorage = /** @class */ (function () {
    function LocalStorage(module) {
        this.module = module;
    }
    /**
     * 设置数据
     * @param key 字段名
     * @param data 字段值
     * @param expires 过期时间-单位秒
     */
    // TODO try catch溢出处理
    LocalStorage.prototype.setItem = function (key, data, expires) {
        if (expires === void 0) { expires = 0; }
        this.syncLocalToMemory();
        // localStorage_key
        var lk = genKey(this.module);
        getSharedLocalData()[lk] = set(getSharedLocalData()[lk], key, encode(data, expires));
        localStorageSet(lk, getSharedLocalData()[lk]);
    };
    /**
     * 获取数据
     * @param {string} key 字段名
     * @returns StorageData
     */
    LocalStorage.prototype.getItem = function (key) {
        this.syncLocalToMemory();
        var moduleData = getSharedLocalData()[genKey(this.module)];
        if (!storageConfig.merged.cache) {
            moduleData = JSON.parse(localStorage.getItem(genKey(this.module)) || '{}');
        }
        var validData = getValidData(moduleData === null || moduleData === void 0 ? void 0 : moduleData[key]);
        if (validData === EXPIRED) {
            Reflect.deleteProperty(moduleData, key);
            localStorageSet(genKey(this.module), moduleData);
            storageDebugger('localStorage', 'expired');
            return undefined;
        }
        storageDebugger('localStorage', validData);
        return validData;
    };
    LocalStorage.prototype.removeItem = function (key) {
        this.syncLocalToMemory();
        // localStorage_key
        var lk = genKey(this.module);
        var moduleData = getSharedLocalData()[lk];
        if (moduleData) {
            Reflect.deleteProperty(moduleData, key);
            localStorageSet(lk, moduleData);
        }
    };
    LocalStorage.prototype.clear = function () {
        // localStorage_key
        var lk = genKey(this.module);
        Reflect.deleteProperty(getSharedLocalData(), lk);
        localStorage.removeItem(lk);
    };
    /**
     * 强制同步localStorage数据到memory
     */
    LocalStorage.prototype.sync = function () {
        getSharedLocalData()[genKey(this.module)] = JSON.parse(localStorage.getItem(genKey(this.module)) || '{}');
    };
    /**
     * 默认同步localStorage数据到memory
     */
    LocalStorage.prototype.syncLocalToMemory = function () {
        if (!hasSyncFromLocal.includes(genKey(this.module))) {
            this.sync();
            hasSyncFromLocal.push(genKey(this.module));
        }
    };
    return LocalStorage;
}());

function getSharedMemoryData() {
    if (isServer) {
        return sharedMemoryData;
    }
    if (!getWindow()._WB_sharedMemoryData) {
        getWindow()._WB_sharedMemoryData = sharedMemoryData;
    }
    return getWindow()._WB_sharedMemoryData;
}
var sharedMemoryData = {};
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage(module) {
        this.module = module;
    }
    /**
     * 设置数据
     * @param key 字段名
     * @param data 字段值
     * @param expires 过期时间-单位秒
     */
    MemoryStorage.prototype.setItem = function (key, data, expires) {
        if (expires === void 0) { expires = 0; }
        getSharedMemoryData()[genKey(this.module)] = set(getSharedMemoryData()[genKey(this.module)], key, encode(data, expires));
    };
    MemoryStorage.prototype.getItem = function (key) {
        var moduleData = getSharedMemoryData()[genKey(this.module)];
        var validData = getValidData(moduleData === null || moduleData === void 0 ? void 0 : moduleData[key]);
        if (validData === EXPIRED) {
            Reflect.deleteProperty(moduleData, key);
            return undefined;
        }
        return validData;
    };
    MemoryStorage.prototype.removeItem = function (key) {
        var moduleData = getSharedMemoryData()[genKey(this.module)];
        if (moduleData) {
            Reflect.deleteProperty(moduleData, key);
        }
    };
    MemoryStorage.prototype.clear = function () {
        Reflect.deleteProperty(getSharedMemoryData(), genKey(this.module));
    };
    MemoryStorage.prototype.getSharedMemoryData = function () {
        return getSharedMemoryData();
    };
    return MemoryStorage;
}());

function getSharedSessionData() {
    if (isServer) {
        return sharedSessionData;
    }
    if (!getWindow()._WB_sharedSessionData) {
        getWindow()._WB_sharedSessionData = sharedSessionData;
    }
    return getWindow()._WB_sharedSessionData;
}
var sharedSessionData = {};
var hasSyncFromSession = [];
var SessionStorage = /** @class */ (function () {
    function SessionStorage(module) {
        this.module = module;
    }
    /**
     * 设置数据
     * @param key 字段名
     * @param data 字段值
     * @param expires 过期时间-单位秒
     */
    // TODO try catch溢出处理
    SessionStorage.prototype.setItem = function (key, data, expires) {
        if (expires === void 0) { expires = 0; }
        this.syncSessionToMemory();
        // sessionStorage_key
        var sk = genKey(this.module);
        getSharedSessionData()[sk] = set(getSharedSessionData()[sk], key, encode(data, expires));
        sessionStorage.setItem(sk, JSON.stringify(getSharedSessionData()[sk]));
    };
    SessionStorage.prototype.getItem = function (key) {
        this.syncSessionToMemory();
        var moduleData = getSharedSessionData()[genKey(this.module)];
        if (!storageConfig.merged.cache) {
            moduleData = JSON.parse(sessionStorage.getItem(genKey(this.module)) || '{}');
        }
        var validData = getValidData(moduleData === null || moduleData === void 0 ? void 0 : moduleData[key]);
        if (validData === EXPIRED) {
            Reflect.deleteProperty(moduleData, key);
            sessionStorage.setItem(genKey(this.module), JSON.stringify(moduleData));
            storageDebugger('sessionStorage', 'expired');
            return undefined;
        }
        storageDebugger('sessionStorage', validData);
        return validData;
    };
    SessionStorage.prototype.removeItem = function (key) {
        this.syncSessionToMemory();
        // localStorage_key
        var sk = genKey(this.module);
        var moduleData = getSharedSessionData()[sk];
        if (moduleData) {
            Reflect.deleteProperty(moduleData, key);
            sessionStorage.setItem(sk, JSON.stringify(getSharedSessionData()[sk]));
        }
    };
    SessionStorage.prototype.clear = function () {
        // localStorage_key
        var sk = genKey(this.module);
        Reflect.deleteProperty(getSharedSessionData(), sk);
        sessionStorage.removeItem(sk);
    };
    /**
     * 强制同步sessionStorage数据到memory
     */
    SessionStorage.prototype.sync = function () {
        getSharedSessionData()[genKey(this.module)] = JSON.parse(sessionStorage.getItem(genKey(this.module)) || '{}');
    };
    /**
     * 默认同步sessionStorage数据到memory
     */
    SessionStorage.prototype.syncSessionToMemory = function () {
        if (!hasSyncFromSession.includes(genKey(this.module))) {
            this.sync();
            hasSyncFromSession.push(genKey(this.module));
        }
    };
    return SessionStorage;
}());

var Storage = /** @class */ (function () {
    function Storage(moduleName) {
        if (moduleName) {
            this.module = ModuleMap.get(moduleName) || moduleName;
        }
        else {
            if (isServer) {
                this.module = 's';
            }
            else {
                this.module = ModuleMap.get(getFirstPath()) || getFirstPath() || 'root';
            }
        }
    }
    /**
     * 使用哪个项目
     * @param moduleName 项目名
     * @returns Storage
     */
    Storage.prototype.useModule = function (moduleName) {
        return new Storage(moduleName);
    };
    /**
     * 选择存储工具
     * @param storage 'localStorage' | 'sessionStorage' | 'memory'
     * @returns LocalStorage | SessionStorage | MemoryStorage
     */
    Storage.prototype.useStorage = function (storage) {
        if (isServer)
            return new MemoryStorage(this.module);
        switch (storage) {
            case 'localStorage':
                return new LocalStorage(this.module);
            case 'sessionStorage':
                return new SessionStorage(this.module);
            case 'memory':
                return new MemoryStorage(this.module);
            default:
                return this;
        }
    };
    Storage.prototype.setItem = function (key, data, expires) {
        if (isServer) {
            return new MemoryStorage(this.module).setItem(key, data, expires);
        }
        return new LocalStorage(this.module).setItem(key, data, expires);
    };
    Storage.prototype.getItem = function (key) {
        if (isServer) {
            return new MemoryStorage(this.module).getItem(key);
        }
        return new LocalStorage(this.module).getItem(key);
    };
    Storage.prototype.removeItem = function (key) {
        if (isServer) {
            return new MemoryStorage(this.module).removeItem(key);
        }
        return new LocalStorage(this.module).removeItem(key);
    };
    Storage.prototype.clear = function () {
        if (isServer) {
            return new MemoryStorage(this.module).clear();
        }
        return new LocalStorage(this.module).clear();
    };
    /**
     * 更新配置
     * @param config 配置参数 { debug: boolean, cache: boolean }
     */
    Storage.prototype.setConfig = function (config) {
        storageConfig.user = config;
        storageConfig.merged = __assign(__assign({}, storageConfig.merged), config);
        if (config.debug) {
            Promise.resolve().then(function () { return loggerUtil$1; }).then(function (_a) {
                var loggerUtil = _a.loggerUtil;
                storageConfig.merged.logger = loggerUtil.use(undefined, 'storage');
            });
        }
    };
    return Storage;
}());
var storage$1 = new Storage();

var storage = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Storage: Storage,
    storage: storage$1
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var sha1$1 = {exports: {}};

var core = {exports: {}};

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory();
	}
}(commonjsGlobal, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined$1) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native crypto in web worker (Browser)
	    if (typeof self !== 'undefined' && self.crypto) {
	        crypto = self.crypto;
	    }

	    // Native crypto from worker
	    if (typeof globalThis !== 'undefined' && globalThis.crypto) {
	        crypto = globalThis.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof commonjsGlobal !== 'undefined' && commonjsGlobal.crypto) {
	        crypto = commonjsGlobal.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && typeof commonjsRequire === 'function') {
	        try {
	            crypto = require('crypto');
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }());

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined$1) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var j = 0; j < thatSigBytes; j += 4) {
	                    thisWords[(thisSigBytes + j) >>> 2] = thatWords[j >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));
}(core));

(function (module, exports) {
(function (root, factory) {
	{
		// CommonJS
		module.exports = factory(core.exports);
	}
}(commonjsGlobal, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));
}(sha1$1));

var sha1 = sha1$1.exports;

/**
 * 对 Object 对象的属性名按ASCII码来排序
 * @param obj -
 * @returns -
 */
var sortObject = function (obj) {
    var newObj = {};
    Object.keys(obj)
        // 按照对象的 key 按 ASCII码来排序
        .sort()
        .forEach(function (key) {
        var value = obj[key];
        /**
         * https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Data_structures
         */
        if (value instanceof Array) {
            throw new Error('params contains array elements.');
        }
        if (value instanceof Object) {
            sortObject(value);
        }
        newObj[key] = value;
    });
    return newObj;
};
/**
 * 计算传入参数的 hash 值（sha1 string.length 为 40）
 *    cgi 接口入参不一样时，接口返回的数据也是不一样的。这种情况需要计算一下params的hash值，将其视为一个新接口
 * @param {string | Record<string, any>} params
 *    - 若 cgi 接口不需要传参，则传函数名（string）
 *    - 若 cgi 接口需要传入参数（由于不同的参数，后台接口返回的数据会不一致），则对传入参数进行 hash 计算
 * @returns {string} -
 */
var getParamHash = function (params) {
    if (!(params instanceof Object)) {
        return sha1(params).toString();
    }
    // 默认值为: 1680000118386yAEe8yRD - (21)
    var hashRes = "".concat((new Date()).getTime()).concat(getRandomString(8));
    try {
        var jsonStr = JSON.stringify(sortObject(params));
        hashRes = sha1(jsonStr).toString();
    }
    catch (err) {
        console.error(err);
    }
    return hashRes;
};

// sessionStorage 的 key
var CGI_TMPCACHE_KEY = 'cgiTmpCache';
/**
 * cgi 接口缓存公共函数
 *    - 注意:
 *      - cgiUrl 需要是唯一的。不然计算的 hash 值会有可能相同。
 *      - cgiParams 参数可不传 或 需要为 Object.(若传入 cgiParams 参数则会参与hash的计算，因为不同的传参，后台接口返回的data会不一样)
 *    - 缓存数据的 key 为 cacheName;
 * @param {object} param0 -
 * @param {CgiParamsT} param0.cgiParams -
 * @param {Function} param0.cgiFunction -
 * @returns {Promise<TencentResponse<CgiDataT>>}
 */
var cgiTemporaryCache = function (_a) {
    var cgiUrl = _a.cgiUrl, cgiParams = _a.cgiParams, cgiFunction = _a.cgiFunction;
    return __awaiter(void 0, void 0, void 0, function () {
        var cacheName, storage, cgiTmpCache, cacheDatas, currentCgiTmpPromiseCache;
        return __generator(this, function (_b) {
            /**
             * 服务端不做缓存
             */
            if (isServer) {
                // return cgiFunction();
                // import { post } from '@/http/http-adapter'; 不支持服务端调用
                return [2 /*return*/, Promise.reject(new Error('window is undefined.'))];
            }
            cacheName = '';
            if (cgiParams
                && cgiParams instanceof Object
                && Object.keys(cgiParams).length > 0) {
                cacheName = getParamHash(__assign(__assign({}, cgiParams), { $$cgiUrl: cgiUrl }));
            }
            else {
                cacheName = getParamHash(cgiUrl);
            }
            storage = new Storage('web-base').useStorage('sessionStorage');
            cgiTmpCache = storage.getItem(CGI_TMPCACHE_KEY) || {};
            cacheDatas = cgiTmpCache[cacheName];
            /**
             * 若 sessionStorage 有缓存的数据则返回;
             *    - sessionStorage的数据缓存 0.5秒
             */
            if (cacheDatas) {
                return [2 /*return*/, Promise.resolve(cacheDatas)];
            }
            if (!isObject(window._cgiTmpPromiseCache)) {
                window._cgiTmpPromiseCache = {};
            }
            currentCgiTmpPromiseCache = window._cgiTmpPromiseCache[cacheName];
            /**
             * 若 window._cgiTmpPromiseCache 有 cgi Promise 的缓存则返回;
             *    - 不需要重复发送cgi接口请求
             */
            if (isPromise(currentCgiTmpPromiseCache)) {
                return [2 /*return*/, currentCgiTmpPromiseCache];
            }
            try {
                // 用户中心等项目 webpack 等构建工具会处理 process.env.NODE_ENV;
                if (process.env.NODE_ENV !== 'production') {
                    console.info('cgiTemporaryCache:', cacheName, cgiParams, cgiUrl, cgiFunction.name);
                }
            }
            catch (err) {
            }
            currentCgiTmpPromiseCache = cgiFunction(cgiParams)
                .then(function (res) {
                if ((res === null || res === void 0 ? void 0 : res.code) !== 0 || !(res === null || res === void 0 ? void 0 : res.data)) {
                    return Promise.reject(new Error("code: ".concat(res === null || res === void 0 ? void 0 : res.code, "; nonce: ").concat(res === null || res === void 0 ? void 0 : res.nonce, "; message: ").concat(res === null || res === void 0 ? void 0 : res.message, ";")));
                }
                cgiTmpCache[cacheName] = __assign(__assign({}, res), { 
                    // @ts-ignore
                    $cgiTmpCache: {
                        cgiUrl: cgiUrl,
                        params: cgiParams,
                    } });
                // sessionStorage的数据缓存 0.5秒
                storage.setItem(CGI_TMPCACHE_KEY, cgiTmpCache, 0.5);
                return res;
            })
                .finally(function () {
                // 500ms 之后，清空本次 promise 对象缓存
                setTimeout(function () {
                    if (window._cgiTmpPromiseCache[cacheName]) {
                        delete window._cgiTmpPromiseCache[cacheName];
                    }
                }, 500);
            });
            // 设置 window._cgiTmpPromiseCache 的 cgi Promise 缓存
            window._cgiTmpPromiseCache[cacheName] = currentCgiTmpPromiseCache;
            return [2 /*return*/, currentCgiTmpPromiseCache];
        });
    });
};

var ACCOUNT_LOGIN_REFRESHTOKEN_URL = '/v2/account/login/refresh-token';
/**
 * 查询用户信息或刷新token
 *    http://cowork.yapi.woa.com/project/41/interface/api/92
 * @param params -
 * @returns -
 */
var accountLoginRefreshToken = function (params) {
    if (params === void 0) { params = {
        refresh_token: 0,
    }; }
    return post({
        url: ACCOUNT_LOGIN_REFRESHTOKEN_URL,
        data: params,
    });
};

/**
 * @param url {string} prefix url like `/webtapi`
 * @description 部分接口区分环境添加后缀
 */
function getPostfix(url) {
    var res = url;
    if (url) {
        if (isLocalEnv() || isTestEnv()) {
            res += '-test';
        }
        else if (isPreReleaseEnv()) {
            res += '-pre-release';
        }
    }
    return res;
}
var PrefixType;
(function (PrefixType) {
    PrefixType["CLOUD_RECORDING"] = "/cloudRecording";
    PrefixType["WEMEET_CLOUD_RECORDING_WEBAPI"] = "/wemeet-cloudrecording-webapi";
    PrefixType["WEBHOOK"] = "/webhook";
    PrefixType["WEMEET_WEBHOOK_WEBAPI"] = "/wemeet-webhook-webapi";
    PrefixType["WEB_TAPI"] = "/webtapi";
    PrefixType["WEMEET_TAPI"] = "/wemeet-tapi";
    PrefixType["WEWORK_SDK_API"] = "/wework-sdk-api";
    PrefixType["WEMEET_WEB_API"] = "/wemeet-webapi";
})(PrefixType || (PrefixType = {}));
/**
 * 获取前缀
 * @param url {string}
 * @description 传入`PrefixType`类型的数据, 根据环境自动添加-test, -pre-release后缀。传入其他string
 * 则直接返回string。
 * @example
 * ```
 *    let pf = '/wemeet-webapi';
 *    pf = getPrefix(pf); // 如果是测试环境, 则返回'/wemeet-webapi-test', 如果是预发布环境, 则返回'/wemeet-webapi-pre-release'
 *    pf = '/wemeet-tapi';
 *    pf = getPrefix(pf); // 所有环境都返回'/wemeet-tapi'
 *    pf = '/custom-prefix';
 *    pf = getPrefix(pf); // 自定义前缀所有环境都返回'/custom-prefix'
 * ```
 */
function getHttpPrefix(url) {
    if (!url || typeof url !== 'string') {
        return '';
    }
    var pt = url;
    if (url[0] !== '/') {
        pt = "/".concat(url);
    }
    switch (pt) {
        // 加后缀的接口
        case PrefixType.WEMEET_WEB_API:
        case PrefixType.WEMEET_CLOUD_RECORDING_WEBAPI:
        case PrefixType.WEMEET_WEBHOOK_WEBAPI:
            return getPostfix(pt);
        // 兼容写法
        case PrefixType.CLOUD_RECORDING:
            return getPostfix('/wemeet-cloudrecording-webapi');
        case PrefixType.WEBHOOK:
            return getPostfix('/wemeet-webhook-webapi');
        // 固定地址的接口
        case PrefixType.WEB_TAPI:
        case PrefixType.WEMEET_TAPI:
            return '/wemeet-tapi';
        case PrefixType.WEWORK_SDK_API:
            return '/wework-sdk-api';
        // 自定义接口前缀
        default:
            return pt;
    }
}

function getIsI18N() {
    var _a;
    if (typeof process === 'object' && process) {
        return ((_a = process.env) === null || _a === void 0 ? void 0 : _a.IS_I18N) === 'true';
    }
    return false;
}
var DEFAULT_C_APP_VERSION = 1;
/**
 * 生成traceId
 * https://tapd.woa.com/Tencent_Meeting2/prong/stories/view/1020375092886066323?jump_count=1
 */
var generateTraceId = function () {
    var hexDigits = '0123456789abcdef';
    var randomPart = '';
    for (var i = 0; i < 8; i++) {
        randomPart += hexDigits.charAt(Math.floor(Math.random() * 16));
    }
    var traceId = randomPart;
    for (var i = 0; i < 24; i++) {
        traceId += hexDigits.charAt(Math.floor(Math.random() * 16));
    }
    return traceId;
};
/**
 * 基础公共参数
 */
function getCommonQueryParams(href) {
    if (href === void 0) { href = ''; }
    var random = getRequest('rnds', href) || randomString(8);
    var allCookies = getCookies();
    var appId = allCookies.corp_id || allCookies.app_id || getRequest('app_id', href) || '';
    return {
        c_os: 'web',
        c_os_version: 1,
        c_os_model: 'web',
        c_timestamp: new Date().getTime(),
        c_instance_id: 5,
        c_nonce: random,
        c_app_id: appId,
        c_app_version: DEFAULT_C_APP_VERSION,
        c_lang: getHtmlLang(),
        c_district: getIsI18N() ? 1 : 0,
        'trace-id': generateTraceId(),
        rnds: random,
    };
}
/**
 * 文档接口data添加公共参数
 */
function mergeDocDataOptions(options) {
    var data = options.data;
    if (typeof data !== 'object') {
        return options;
    }
    if (Object.prototype.toString.call(data) === '[object FormData]') {
        data.append('os', 'web');
        data.append('instance_id', 5);
        data.append('os_version', 1);
        data.append('os_model', 'web');
        data.append('time', new Date().getTime());
    }
    else {
        data.os = 'web';
        data.instance_id = 5;
        data.os_version = 1;
        data.os_model = 'web';
        data.time = new Date().getTime();
    }
    return Object.assign({}, options, { data: data });
}
/**
 * 获取请求的CGI地址
 * @param url {string} 请求地址, `/v2/wemeet/meeting/query-pmi-info`
 * @param prefix {string} 前缀, 默认`/wemeet-webapi`
 */
function getRequestUrl(url, prefix) {
    if (prefix === void 0) { prefix = '/wemeet-webapi'; }
    var regURL = /^(https|http):\/\//;
    if (regURL.test(url) || !prefix) {
        return url;
    }
    var rf = getHttpPrefix(prefix);
    if (url[0] === '/') {
        return rf + url;
    }
    return "".concat(rf, "/").concat(url);
}
/**
 * 合并请求参数
 * @param options
 * @param ctx
 */
function mergeCommonConfig(options, ctx) {
    var baseOptions = options;
    var url = getRequestUrl(options.url, options.prefix);
    if (url && url.indexOf('/docs/doc/') !== -1) {
        baseOptions = mergeDocDataOptions(options);
    }
    var params = Object.assign({}, getCommonQueryParams(getLocationHref(ctx)), options.params);
    if (!isServer && isWeMeetApp()) {
        params = __assign(__assign(__assign({}, params), paramsFromWeMeetApp()), options.params);
    }
    if (ctx) {
        return Object.assign({}, baseOptions, { params: params, url: url }, getConfigFromContext(ctx));
    }
    return Object.assign({}, baseOptions, { params: params, url: url });
}
/**
 * 从app内获取小票参数
 */
function paramsFromWeMeetApp() {
    var userAgent = getUserAgent();
    var allCookies = getCookies();
    var instanceId = getInstanceId(userAgent);
    var cToken = allCookies.ticket || allCookies.we_meet_token || (getRequest === null || getRequest === void 0 ? void 0 : getRequest('token')) || '';
    if (window.currentTicket) {
        cToken = window.currentTicket || cToken;
    }
    var appId = allCookies.corp_id || allCookies.app_id || (getRequest === null || getRequest === void 0 ? void 0 : getRequest('app_id')) || '';
    var appUid = allCookies.app_uid || (getRequest === null || getRequest === void 0 ? void 0 : getRequest('app_uid')) || '';
    var lang = (getRequest === null || getRequest === void 0 ? void 0 : getRequest('lang')) || 'zh-CN';
    var random = randomString(8);
    // 公共参数
    var queryParams = {
        c_instance_id: 5,
        c_os: 'web',
        c_os_model: 'web',
        c_os_version: encodeURIComponent(userAgent),
        c_nonce: random,
        c_timestamp: new Date().getTime(),
        c_app_id: appId,
        c_app_uid: appUid,
        c_platform: isWeMeetApp(userAgent) ? '5' : '0',
        c_token: cToken,
        c_app_version: allCookies.app_version || getAppVersion(userAgent) || '',
        platform: instanceId.name || '',
        platform_id: (allCookies === null || allCookies === void 0 ? void 0 : allCookies.instance_id) || instanceId.id,
        app_id: appId,
        c_lang: lang,
    };
    return queryParams;
}
/**
 * 从服务端获取请求参数
 * @deprecated 放弃ctx
 * @param ctx {NextGetServerSidePropsContext}
 */
function getConfigFromContext(ctx) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var options = {};
    if (ctx) {
        var allCookies = getCookies(ctx);
        var ua = ((_b = (_a = ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b['user-agent']) || '';
        var userAgent = getUserAgent(ua);
        var cookies = ((_d = (_c = ctx.req) === null || _c === void 0 ? void 0 : _c.headers) === null || _d === void 0 ? void 0 : _d.cookie) || '';
        var pathUrl = (_e = ctx.req) === null || _e === void 0 ? void 0 : _e.url;
        var referer = ((_g = (_f = ctx.req) === null || _f === void 0 ? void 0 : _f.headers) === null || _g === void 0 ? void 0 : _g.referer) || '';
        var realIp = ((_h = ctx.req) === null || _h === void 0 ? void 0 : _h.headers['x-forwarded-for']) || '';
        options.headers = {
            Cookie: cookies,
            Referer: referer || "https://meeting.tencent.com".concat(pathUrl),
            'X-Forwarded-For': realIp,
        };
        options.params = {
            c_app_id: allCookies.corp_id || allCookies.app_id || '',
            c_app_uid: allCookies.app_uid || '',
            c_platform: isWeMeetApp(userAgent) ? '5' : '0',
            c_token: allCookies.ticket || allCookies.we_meet_token || '',
            c_app_version: '',
            platform: getDeviceType$2(userAgent),
            app_id: allCookies.corp_id || allCookies.app_id || '',
        };
    }
    return options;
}

var CORP_CORP_CORPPAYTAG_URL = '/v2/corp/corp/corp-pay-tag';
/**
 * 查询当前企业支付购买版本信息
 *    http://cowork.yapi.woa.com/project/41/interface/api/2088
 * @param params -
 * @returns -
 */
var corpCorpCorpPayTag = function (params) {
    if (params === void 0) { params = {
        c_app_version: DEFAULT_C_APP_VERSION,
    }; }
    return get({
        url: CORP_CORP_CORPPAYTAG_URL,
        params: params,
    });
};

var ACCOUNT_PROFILE_CHANGEACCOUNT_URL = '/v2/account/profile/change-account';
/**
 * 查询当前账号可切换账号详情
 *    http://cowork.yapi.woa.com/project/41/interface/api/1300
 * @param params -
 * @returns -
 */
var accountProfileChangeAccount = function () { return get({
    url: ACCOUNT_PROFILE_CHANGEACCOUNT_URL,
    params: {},
}); };

var CORP_USERROLE_AUTHPOWER_URL = '/v2/wemeet-ability-logic/auth-power';
/**
 * 查询-当前登录用户-角色权限点
 *    http://cowork.yapi.woa.com/project/41/interface/api/1308
 * @param params -
 * @returns -
 */
var corpUserRoleAuthPower = function () { return get({
    url: CORP_USERROLE_AUTHPOWER_URL,
    prefix: '/wemeet-tapi',
    params: {},
}); };

var USER_LOGIC_USER_GET_ACCOUNT_BRIEF_INFO = '/v2/user-logic/user/get-account-breif-info';
/**
 * 查询当前登录账号的简要信息
 * http://cowork.yapi.woa.com/project/41/interface/api/30117
 */
var getAccountBriefInfo = function () { return post({
    url: USER_LOGIC_USER_GET_ACCOUNT_BRIEF_INFO,
}); };

/**
 * 注意:
 *    - cgiUrl 需要是唯一的。不然计算的 hash 值会有可能相同。
 *    - cgiParams 参数可不传 或 需要为 Object.(若传入 cgiParams 参数则会参与hash的计算，因为不同的传参，后台接口返回的data会不一样)
 */
var CGI_URL = {
    ACCOUNT_LOGIN_REFRESHTOKEN_URL: ACCOUNT_LOGIN_REFRESHTOKEN_URL,
    CORP_CORP_CORPPAYTAG_URL: CORP_CORP_CORPPAYTAG_URL,
    ACCOUNT_PROFILE_CHANGEACCOUNT_URL: ACCOUNT_PROFILE_CHANGEACCOUNT_URL,
    CORP_USERROLE_AUTHPOWER_URL: CORP_USERROLE_AUTHPOWER_URL,
    USER_LOGIC_USER_GET_ACCOUNT_BRIEF_INFO: USER_LOGIC_USER_GET_ACCOUNT_BRIEF_INFO,
};
var accountLoginRefreshTokenTmpCache = function (params) { return cgiTemporaryCache({
    cgiUrl: ACCOUNT_LOGIN_REFRESHTOKEN_URL,
    cgiParams: params,
    cgiFunction: accountLoginRefreshToken,
}); };
var corpCorpCorpPayTagTmpCache = function (params) { return cgiTemporaryCache({
    cgiUrl: CORP_CORP_CORPPAYTAG_URL,
    cgiParams: params,
    cgiFunction: corpCorpCorpPayTag,
}); };
var accountProfileChangeAccountTmpCache = function () { return cgiTemporaryCache({
    cgiUrl: ACCOUNT_PROFILE_CHANGEACCOUNT_URL,
    cgiFunction: accountProfileChangeAccount,
}); };
var corpUserRoleAuthPowerTmpCache = function () { return cgiTemporaryCache({
    cgiUrl: CORP_USERROLE_AUTHPOWER_URL,
    cgiFunction: corpUserRoleAuthPower,
}); };
var getAccountBriefInfoTmpCache = function () { return cgiTemporaryCache({
    cgiUrl: USER_LOGIC_USER_GET_ACCOUNT_BRIEF_INFO,
    cgiFunction: getAccountBriefInfo,
}); };
/**
 * `src/tencent/http/index.ts`
 * - export * as cgiTmpCache from './cgi-temporary-cache/index'; 改为 export * from './cgi-temporary-cache/index';
 * - web-base有个脚本，会刷一遍所有目录，在目录下面去把所有文件导出到index文件下，最后递归导出到根目录
 */
var cgiTmpCache = {
    CGI_URL: CGI_URL,
    accountLoginRefreshTokenTmpCache: accountLoginRefreshTokenTmpCache,
    corpCorpCorpPayTagTmpCache: corpCorpCorpPayTagTmpCache,
    accountProfileChangeAccountTmpCache: accountProfileChangeAccountTmpCache,
    corpUserRoleAuthPowerTmpCache: corpUserRoleAuthPowerTmpCache,
    getAccountBriefInfoTmpCache: getAccountBriefInfoTmpCache,
};

/**
 * 获取当前登录状态
 * https://iwiki.woa.com/pages/viewpage.action?pageId=4007940382
 * @returns {Promise<AccountBriefInfoInt>}
 */
function queryLoginStatus() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var res, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAccountBriefInfoTmpCache()];
                case 1:
                    res = _b.sent();
                    if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.user_id) {
                        return [2 /*return*/, Promise.resolve(res.data)];
                    }
                    return [2 /*return*/, Promise.reject(res)];
                case 2:
                    error_1 = _b.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 3: return [2 /*return*/];
            }
        });
    });
}

/**
 * @description 用户信息中的corp_type枚举
 * @doc http://cowork.yapi.woa.com/project/41/interface/api/92
 */
var UserCropTypeEnum;
(function (UserCropTypeEnum) {
    /** 外部企业 */
    UserCropTypeEnum[UserCropTypeEnum["NORMAL"] = 1] = "NORMAL";
    /** 内部测试企业 */
    UserCropTypeEnum[UserCropTypeEnum["INNER_TEST"] = 2] = "INNER_TEST";
    /** 企业微信 */
    UserCropTypeEnum[UserCropTypeEnum["QYWECHAT"] = 3] = "QYWECHAT";
    /** restapi */
    UserCropTypeEnum[UserCropTypeEnum["REST_API"] = 4] = "REST_API";
    /** idaas */
    UserCropTypeEnum[UserCropTypeEnum["SSO_API"] = 5] = "SSO_API";
    /** 腾讯云 */
    UserCropTypeEnum[UserCropTypeEnum["SASS_CLOUD"] = 6] = "SASS_CLOUD";
    /** OAuth */
    UserCropTypeEnum[UserCropTypeEnum["OAUTH"] = 7] = "OAUTH";
    /** 渠道代理商 */
    UserCropTypeEnum[UserCropTypeEnum["AGENCY"] = 8] = "AGENCY";
    /** 渠道代理商客户 */
    UserCropTypeEnum[UserCropTypeEnum["AGENCY_CUSTOMER"] = 9] = "AGENCY_CUSTOMER";
    /** 企微虚拟企业 */
    UserCropTypeEnum[UserCropTypeEnum["QYWECHAT_VIRTUAL"] = 10] = "QYWECHAT_VIRTUAL";
    /** 虚拟审批企业 */
    UserCropTypeEnum[UserCropTypeEnum["APPROVE_VIRTUAL"] = 11] = "APPROVE_VIRTUAL";
    /** 其他 */
    UserCropTypeEnum[UserCropTypeEnum["TYPE_NONE"] = 100] = "TYPE_NONE";
})(UserCropTypeEnum || (UserCropTypeEnum = {}));

/**
 * ADMIN_ROLE：超级管理员；
 * MANAGER_ROLE：管理员；
 * NORMAL_ROLE：普通成员；
 * 其他为管理员自定义的：
 * CORP_ADMIN_ROLE 企业管理员；
 */
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["ADMIN"] = "ADMIN_ROLE";
    UserRoleEnum["MANAGER"] = "MANAGER_ROLE";
    UserRoleEnum["NORMAL"] = "NORMAL_ROLE";
    UserRoleEnum["CORP_ADMIN"] = "CORP_ADMIN_ROLE";
    UserRoleEnum["UN_KNOWN"] = "";
})(UserRoleEnum || (UserRoleEnum = {}));
/**
 * @param roleCode: “/v2/corp/user-role/auth-power” 接口里返回的 “role_code”
 * http://cowork.yapi.woa.com/project/41/interface/api/1308
 */
var getUserRole = function (roleCode) {
    switch (roleCode) {
        case UserRoleEnum.ADMIN:
            return UserRoleEnum.ADMIN;
        case UserRoleEnum.MANAGER:
            return UserRoleEnum.MANAGER;
        case UserRoleEnum.NORMAL:
            return UserRoleEnum.NORMAL;
        case UserRoleEnum.CORP_ADMIN:
            return UserRoleEnum.CORP_ADMIN;
        default:
            return roleCode || UserRoleEnum.UN_KNOWN;
    }
};
var isNormalUser = function (roleCode) { return roleCode === UserRoleEnum.NORMAL; };

/**
 * 获取服务端Host
 * @param ctx
 */
var getServerHost = function (ctx) {
    var hostName = (ctx === null || ctx === void 0 ? void 0 : ctx.req.headers.host) || '';
    if (hostName === 'source.meeting.qq.com') {
        return 'meeting.tencent.com';
    }
    return hostName;
};
/**
 * 获取UserAgent
 * @param ctx
 */
var getNextUserAgent = function (ctx) {
    var _a;
    var userAgent = '';
    if (isServer) {
        userAgent = ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers['user-agent']) || '';
    }
    else {
        userAgent = window.navigator.userAgent;
    }
    return userAgent;
};
/**
 * 微信登录函数
 * @param {Object} urlParams 链接参数
 * @param {NextGetServerSidePropsContext=} ctx 服务端请求上下文（可选）
 * @param {string=} basePath 项目子目录（可选） eg：nextMeeting => /v2，优先使用系统process.env.BASE_PATH，再basePath
 * @param {any=} report 上报方法，允许单个msg参数（可选）会记录跳转地址
 * @returns {any}
 */
function wechatLogin(urlParams, ctx, basePath, report) {
    if (urlParams === void 0) { urlParams = {}; }
    var pasePathString = '';
    // 处理项目子目录，优先使用系统process.env.BASE_PATH，再basePath
    if (process.env.BASE_PATH) {
        pasePathString = process.env.BASE_PATH;
    }
    else if (basePath) {
        pasePathString = basePath;
    }
    // 获取当前页面的地址
    var pageUrl = isServer && ctx
        ? "https://".concat(getServerHost(ctx)).concat(pasePathString).concat(ctx.resolvedUrl)
        : window.location.href;
    // 最终回跳链接参数处理
    var params = __assign({}, urlParams);
    if (params.login_default) {
        Reflect.deleteProperty(params, 'login_default');
    }
    var loginParams = {
        m_login_source_id: '3',
    };
    if (typeof urlParams.login_default !== undefined) {
        loginParams.default_login = urlParams.login_default;
    }
    var redirectLink = addURLSearch(pageUrl, params);
    // 最终跳转地址组合
    var loginUrl = getLoginUrl(redirectLink, loginParams, getNextUserAgent(ctx));
    // 日志记录
    report === null || report === void 0 ? void 0 : report("web-base-wechatAuth-redirectLink: /".concat(redirectLink));
    report === null || report === void 0 ? void 0 : report("web-base-wechatAuth-loginUrl: /".concat(loginUrl));
    // 服务端返回
    if (isServer) {
        return {
            redirect: {
                destination: loginUrl,
                permanent: false,
            },
        };
    }
    // 非服务端直接跳转
    window.location.replace(loginUrl);
    return;
}

/**
 * 从session取出persist:root原始数据
 */
function getPersistRoot() {
    if (typeof localStorage !== 'undefined') {
        var root = localStorage.getItem('persist:root');
        if (root) {
            try {
                return JSON.parse(root);
            }
            catch (_) {
                return {};
            }
        }
    }
    return {};
}

/**
 * 从session中取corpInfos
 */
function getPersistCorp() {
    var root = getPersistRoot();
    if (root === null || root === void 0 ? void 0 : root.corpInfos) {
        try {
            return JSON.parse(root.corpInfos);
        }
        catch (e) {
            return {};
        }
    }
    return {};
}

/**
 * 从session中取userInfos
 */
function getPersistUser() {
    if (typeof sessionStorage !== 'undefined') {
        var str = sessionStorage.getItem('report_user_info');
        if (str) {
            try {
                var user = JSON.parse(str);
                if (user.app_id) {
                    return user;
                }
            }
            catch (_) {
            }
        }
    }
    var root = getPersistRoot();
    if (root === null || root === void 0 ? void 0 : root.userInfos) {
        try {
            return JSON.parse(root.userInfos);
        }
        catch (e) {
            return {};
        }
    }
    return {};
}

/**
 * 包装promise
 * @param promise
 */
function awaitWrap(promise) {
    return promise.then(function (data) { return [data, null]; }).catch(function (err) { return [null, err]; });
}

/**
 * 判断两数组是否有重复元素
 * @param array1 array
 * @param array2 array
 * @returns boolean
 */
function hasSome(array1, array2) {
    if (array1 === void 0) { array1 = []; }
    if (array2 === void 0) { array2 = []; }
    return array1.some(function (value) { return array2.includes(value); });
}

/**
 * 判断是否是数组
 * @param value unknown
 * @returns boolean
 */
function isArray(value) {
    return Object.prototype.toString.call(value) === '[object Array]';
}

function isBigint(value) {
    return typeof value === 'bigint';
}

function isBoolean(value) {
    return typeof value === 'boolean';
}

/**
 * 判断是否是可执行方法
 * @param value unknown
 * @returns boolean
 */
function isFunction(value) {
    return Object.prototype.toString.call(value) === '[object Function]';
}

function isNullUndefined(obj) {
    return obj === null || obj === undefined;
}

function isNumber(value) {
    return typeof value === 'number';
}

function isString(value) {
    return typeof value === 'string';
}

/**
 * 设置只读属性
 * @param obj Object
 * @param keys
 */
function makeReadonly(obj, keys) {
    if (Array.isArray(keys)) {
        keys.forEach(function (key) {
            if (obj[key] !== undefined) {
                Object.defineProperty(obj, key, { writable: false });
            }
        });
    }
    else {
        Object.defineProperty(obj, keys, { writable: false });
    }
}

/**
 * 合并对象，返回新对象
 * ```
 * 		const res = mergeObjects({a: 1}, {b: 2}, {c: {a: 1}});
 * 	  // { a: 1, b: 2, c: {a: 1} }
 * ```
 * @param obj1 泛型对象
 * @param obj2 泛型对象
 * @param obj3 泛型对象
 * @return 深度合并后的对象
 */
function mergeObjects(obj1, obj2) {
    var obj3 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        obj3[_i - 2] = arguments[_i];
    }
    var res = Object.assign({}, obj1);
    if (obj2 && typeof obj2 === 'object') {
        var iter = Object.entries(obj2);
        iter.forEach(function (el) {
            var key = el[0], value = el[1];
            if (res[key] && toString(res[key]) === '[object Object]') {
                res[key] = mergeObjects(res[key], value);
            }
            else {
                res[key] = value;
            }
        });
    }
    return obj3.reduce(function (prev, curr) { return mergeObjects(prev, curr); }, res);
}

var objects = /*#__PURE__*/Object.freeze({
    __proto__: null,
    awaitWrap: awaitWrap,
    deepCopy: deepCopy,
    hasSome: hasSome,
    isArray: isArray,
    isBigint: isBigint,
    isBoolean: isBoolean,
    isFunction: isFunction,
    isNullUndefined: isNullUndefined,
    isNumber: isNumber,
    isObject: isObject,
    isPromise: isPromise,
    isString: isString,
    makeReadonly: makeReadonly,
    mergeObjects: mergeObjects
});

/**
 * 腾讯文档开放API
 */
var BaseTencentDocAuthInfo = /** @class */ (function () {
    function BaseTencentDocAuthInfo(tencentDocAuthInfo) {
        var _a, _b, _c;
        this.appId = (_a = tencentDocAuthInfo === null || tencentDocAuthInfo === void 0 ? void 0 : tencentDocAuthInfo.appId) !== null && _a !== void 0 ? _a : '';
        this.toid = (_b = tencentDocAuthInfo === null || tencentDocAuthInfo === void 0 ? void 0 : tencentDocAuthInfo.toid) !== null && _b !== void 0 ? _b : '';
        this.toidKey = (_c = tencentDocAuthInfo === null || tencentDocAuthInfo === void 0 ? void 0 : tencentDocAuthInfo.toidKey) !== null && _c !== void 0 ? _c : '';
    }
    return BaseTencentDocAuthInfo;
}());

/**
 * 微信登录跳转类型
 */
var WechatJumpInfoEnum;
(function (WechatJumpInfoEnum) {
    /**
     * 注册
     */
    WechatJumpInfoEnum[WechatJumpInfoEnum["REGISTER"] = 1] = "REGISTER";
    /**
     * 绑定微信
     */
    WechatJumpInfoEnum[WechatJumpInfoEnum["BIND"] = 2] = "BIND";
    /**
     * 免费体验
     */
    WechatJumpInfoEnum[WechatJumpInfoEnum["FREE"] = 3] = "FREE";
})(WechatJumpInfoEnum || (WechatJumpInfoEnum = {}));
/**
 * 微信开放API
 */
var BaseWechatAuthInfo = /** @class */ (function () {
    function BaseWechatAuthInfo(redirectUrl, jumpType) {
        if (redirectUrl === void 0) { redirectUrl = ''; }
        if (jumpType === void 0) { jumpType = WechatJumpInfoEnum.BIND; }
        this.redirectUrl = redirectUrl;
        this.jumpInfo = {
            jumpType: jumpType,
        };
    }
    return BaseWechatAuthInfo;
}());

/**
 * 基本开放平台信息
 */
var BaseAuthInfo = /** @class */ (function () {
    function BaseAuthInfo(baseAuthInfo) {
        this.tencentDocAuthInfo = mergeObjects(new BaseTencentDocAuthInfo(), baseAuthInfo === null || baseAuthInfo === void 0 ? void 0 : baseAuthInfo.tencentDocAuthInfo);
        this.wechatAuthInfo = mergeObjects(new BaseWechatAuthInfo(), baseAuthInfo === null || baseAuthInfo === void 0 ? void 0 : baseAuthInfo.wechatAuthInfo);
    }
    return BaseAuthInfo;
}());

/**
 * 基本会议信息
 */
var BaseMeetingInfo = /** @class */ (function () {
    function BaseMeetingInfo(meetingInfo) {
        var _a, _b, _c;
        this.meetingID = (_a = meetingInfo === null || meetingInfo === void 0 ? void 0 : meetingInfo.meetingID) !== null && _a !== void 0 ? _a : '';
        this.meetingCode = (_b = meetingInfo === null || meetingInfo === void 0 ? void 0 : meetingInfo.meetingCode) !== null && _b !== void 0 ? _b : '';
        this.meetingSubject = (_c = meetingInfo === null || meetingInfo === void 0 ? void 0 : meetingInfo.meetingSubject) !== null && _c !== void 0 ? _c : '';
    }
    return BaseMeetingInfo;
}());

/**
 * 基础用户信息
 */
var BaseUserInfo = /** @class */ (function () {
    function BaseUserInfo(userInfo) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        this.userid = (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userid) !== null && _a !== void 0 ? _a : '';
        this.appid = (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.appid) !== null && _b !== void 0 ? _b : '';
        this.username = (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.username) !== null && _c !== void 0 ? _c : '';
        this.vipLevel = (_d = userInfo === null || userInfo === void 0 ? void 0 : userInfo.vipLevel) !== null && _d !== void 0 ? _d : '0';
        this.chineseName = (_e = userInfo === null || userInfo === void 0 ? void 0 : userInfo.chineseName) !== null && _e !== void 0 ? _e : '';
        this.avatar = (_f = userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatar) !== null && _f !== void 0 ? _f : '';
        this.lang = (_g = userInfo === null || userInfo === void 0 ? void 0 : userInfo.lang) !== null && _g !== void 0 ? _g : 'zh-cn';
        this.area = (_h = userInfo === null || userInfo === void 0 ? void 0 : userInfo.area) !== null && _h !== void 0 ? _h : '';
        this.phone = (_j = userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone) !== null && _j !== void 0 ? _j : '';
        this.email = (_k = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _k !== void 0 ? _k : '';
        this.userType = (_l = userInfo === null || userInfo === void 0 ? void 0 : userInfo.userType) !== null && _l !== void 0 ? _l : 1;
        this.roleId = (_m = userInfo === null || userInfo === void 0 ? void 0 : userInfo.roleId) !== null && _m !== void 0 ? _m : 0;
        this.isResetPassword = (_o = userInfo === null || userInfo === void 0 ? void 0 : userInfo.isResetPassword) !== null && _o !== void 0 ? _o : false;
        this.qyWechatOpenUserid = (_p = userInfo === null || userInfo === void 0 ? void 0 : userInfo.qyWechatOpenUserid) !== null && _p !== void 0 ? _p : '';
        this.nickName = (_q = userInfo === null || userInfo === void 0 ? void 0 : userInfo.nickName) !== null && _q !== void 0 ? _q : '';
    }
    /**
     * 是付费用户
     */
    BaseUserInfo.prototype.isVipUser = function () {
        return this.vipLevel === '1';
    };
    /**
     * 是企业用户
     */
    BaseUserInfo.prototype.isCompanyUser = function () {
        return this.userType === 2;
    };
    return BaseUserInfo;
}());

/**
 * 1. 提供rootState的默认值
 * 2. 提供一个函数修改rootState的默认值
 * 3. 返回一个带类型的默认值
 * 4. 在window对象上绑定一个同步的state
 * 5. 提供基础的action供其他项目继承
 * 6. 提供通用的具体action
 */
var BaseRootState = /** @class */ (function () {
    function BaseRootState(rootState) {
        this.authInfo = mergeObjects(new BaseAuthInfo(), rootState === null || rootState === void 0 ? void 0 : rootState.authInfo);
        this.meetingInfo = mergeObjects(new BaseMeetingInfo(), rootState === null || rootState === void 0 ? void 0 : rootState.meetingInfo);
        this.userInfos = mergeObjects(new BaseUserInfo(), rootState === null || rootState === void 0 ? void 0 : rootState.userInfos);
    }
    return BaseRootState;
}());

var model = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BaseAuthInfo: BaseAuthInfo,
    BaseTencentDocAuthInfo: BaseTencentDocAuthInfo,
    get WechatJumpInfoEnum () { return WechatJumpInfoEnum; },
    BaseWechatAuthInfo: BaseWechatAuthInfo,
    BaseMeetingInfo: BaseMeetingInfo,
    BaseUserInfo: BaseUserInfo,
    BaseRootState: BaseRootState
});

/**
 * 同步redux和localStorage的数据
 */
var StorageManage = /** @class */ (function () {
    function StorageManage() {
        this.store = StorageManage.getStateFromLocalStorage();
    }
    StorageManage.getStateFromLocalStorage = function () {
        if (typeof window !== 'undefined') {
            var data = void 0;
            try {
                data = localStorage.getItem(ConstantEnum.WEMEET_STORAGE_KEY);
            }
            catch (e) { }
            var dataObject = void 0;
            if (!data) {
                var toolsData = void 0;
                try {
                    toolsData = localStorage.getItem(ConstantEnum.WEMEET_WEB_TOOLS_KEY);
                }
                catch (e) { }
                if (toolsData) {
                    dataObject = toolsData;
                }
                else {
                    return new BaseRootState();
                }
            }
            else {
                dataObject = data;
            }
            try {
                dataObject = JSON.parse(dataObject);
            }
            catch (_a) {
                return new BaseRootState();
            }
            for (var _i = 0, _b = Object.getOwnPropertyNames(dataObject); _i < _b.length; _i++) {
                var dataKey = _b[_i];
                try {
                    dataObject[dataKey] = JSON.parse(dataObject[dataKey]);
                }
                catch (error) {
                    console.warn('web-base: getStateFromLocalStorage parse err', error);
                }
            }
            return Object.assign({}, new BaseRootState(), dataObject);
        }
        return new BaseRootState();
    };
    StorageManage.prototype.getRootState = function () {
        return this.store;
    };
    StorageManage.prototype.setRootState = function (inputState) {
        this.store = Object.assign({}, this.store, inputState);
        return this.updateLocalStorage();
    };
    StorageManage.prototype.getState = function (key) {
        return this.store[key];
    };
    StorageManage.prototype.setState = function (key, value) {
        var change = Object.assign({}, this.store);
        change[key] = Object.assign({}, change[key], value);
        return this.setRootState(new BaseRootState(change));
    };
    StorageManage.prototype.updateLocalStorage = function () {
        var _this = this;
        var save = {};
        Object.keys(this.store).forEach(function (key) {
            var val = _this.store[key];
            save[key] = JSON.stringify(val);
        });
        if (typeof window !== 'undefined') {
            try {
                localStorage.setItem(ConstantEnum.WEMEET_STORAGE_KEY, JSON.stringify(save));
            }
            catch (e) { }
        }
        return this.store;
    };
    return StorageManage;
}());
var storageManage = new StorageManage();
/**
 * 读取和更新数据[会议web全局数据]
 * 同步localStorage,同步sessionStorage
 * @version 0.0.10
 */
var StorageService = /** @class */ (function () {
    function StorageService() {
    }
    StorageService.getRootState = function () {
        return storageManage.getRootState();
    };
    StorageService.getState = function (key) {
        return storageManage.getState(key);
    };
    StorageService.setState = function (key, value) {
        return storageManage.setState(key, value);
    };
    StorageService.setRootState = function (value) {
        return storageManage.setRootState(value);
    };
    return StorageService;
}());

var getCorpType = function (payTag) {
    if (payTag === void 0) { payTag = ''; }
    if (String(payTag) === '2') {
        // 企业版
        return 1;
    }
    if (String(payTag) === '11') {
        // 商业版
        return 0;
    }
    if (String(payTag) === '16') {
        // 教育版
        return 2;
    }
    return '';
};
/**
 * 合并基础的report数据上报信息
 * @param input object
 * @return report object
 */
function mergeBaseReport(input) {
    var _a;
    if (input === void 0) { input = {}; }
    var reportObj = input;
    var user = getPersistUser();
    var corp = getPersistCorp();
    var id = user.userid || user.username;
    if (typeof reportObj === 'object') {
        reportObj.userid = reportObj.userid || reportObj.username || id || '';
        // 设备类型 'mobile' : 'pc'
        reportObj.device_type = reportObj.device_type || (isMobile() ? 'mobile' : 'pc');
        // 浏览器ua
        reportObj.user_agent = getWindow().navigator.userAgent;
        reportObj.app_uid = reportObj.app_uid || getCookie('app_uid') || getRequest('app_uid') || reportObj.userid;
        reportObj.app_id = reportObj.app_id || getCookie('app_id') || getRequest('app_id') || user.appid || '';
        // 支付信息
        reportObj.corp_type = reportObj.corp_type || getCorpType(corp.payTag);
        reportObj.corp_name = reportObj.corp_name || user.corp_name || '';
        reportObj.nick_name = reportObj.nick_name || user.nickName || user.username || '';
        /**
         * 是否为海外版本: yes or no
         */
        reportObj.is_overseas = reportObj.is_overseas || 'no';
        // 浏览器平台
        var navPlatform = '';
        if ((_a = getWindow().navigator) === null || _a === void 0 ? void 0 : _a.platform) {
            navPlatform = getWindow().navigator.platform;
        }
        reportObj.nav_platform = navPlatform;
    }
    return reportObj;
}

var getPlatForm$1 = function () {
    var _a, _b, _c, _d;
    if ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator) === null || _b === void 0 ? void 0 : _b.platform) {
        return (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.navigator) === null || _d === void 0 ? void 0 : _d.platform;
    }
    return '';
};
var getDeviceType$1 = function () {
    if (isIpad() || isAndroidPad()) {
        return 'tablet';
    }
    if (isMobile()) {
        return 'mobile';
    }
    return 'pc';
};
function setWebUid() {
    if (isServer) {
        return uuidv4();
    }
    var uuid = '';
    var locaUuid = getCookie('web_uid');
    if (locaUuid) {
        uuid = locaUuid;
    }
    else {
        uuid = uuidv4();
        setCookie('web_uid', uuid, 365 * 100, '/');
    }
    return uuid;
}
// 格式化 md5 字符串为 uuid 的格式
function formatMd5ToUuid$1(str) {
    var s = str;
    try {
        s = "".concat(str.slice(0, 8), "-").concat(str.slice(8, 12), "-").concat(str.slice(12, 16), "-").concat(str.slice(16, 20), "-").concat(str.slice(20));
    }
    catch (err) {
        console.log(err, 'formatMd5ToUuid, err');
    }
    return s;
}
function getNetType$1() {
    var _a;
    return (_a = void 0 ) === null || _a === void 0 ? void 0 : _a.effectiveType;
}
function mergeBaseParams(options, eventName) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (options === void 0) { options = {}; }
    if (eventName === void 0) { eventName = ''; }
    var reportObj = mergeBaseReport(options);
    var user;
    try {
        user = (_b = JSON.parse(((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.getItem('MC_USER_RESPONSE_SESSION')) || '{}')) === null || _b === void 0 ? void 0 : _b.data;
    }
    catch (err) {
        user = {};
    }
    var id = (user === null || user === void 0 ? void 0 : user.userid) || (user === null || user === void 0 ? void 0 : user.username);
    var hardwareObj = {
        windows: 'Windows',
        android: 'Android',
        ios: 'IOS',
        mac: 'Mac',
        linux: 'Linux',
        unknown: reportObj.nav_platform,
    };
    var browserInfo = getBrowserInfo();
    var actPageModule = getActPageModule$1(eventName);
    if (actPageModule) {
        reportObj.act = actPageModule.act;
        reportObj.page_name = actPageModule.page_name;
        reportObj.element_name = actPageModule.element_name;
    }
    if (typeof reportObj === 'object') {
        reportObj.source_id = reportObj.source_id || '7';
        reportObj.userid = reportObj.userid || reportObj.username || id || '';
        reportObj.device_type = reportObj.device_type || getDeviceType$1();
        reportObj.user_agent = (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.navigator) === null || _d === void 0 ? void 0 : _d.userAgent;
        reportObj.uid = reportObj.app_uid || getCookie('app_uid') || getRequest('app_uid') || (user === null || user === void 0 ? void 0 : user.userid) || reportObj.userid || '';
        reportObj.corp_id = reportObj.app_id || getCookie('app_id') || getRequest('app_id') || (user === null || user === void 0 ? void 0 : user.app_id) || '';
        reportObj.corp_type = reportObj.corp_type || '';
        reportObj.corp_name = reportObj.corp_name || (user === null || user === void 0 ? void 0 : user.corp_name) || '';
        reportObj.nick_name = reportObj.nick_name || (user === null || user === void 0 ? void 0 : user.nickName) || (user === null || user === void 0 ? void 0 : user.username) || '';
        reportObj.is_overseas = reportObj.is_overseas || 'no';
        reportObj.nav_platform = getPlatForm$1();
        reportObj.unique_report_id = uuidv4();
        reportObj.hardware_os = getOsName() === 'unknown' ? reportObj.nav_platform : hardwareObj[getOsName()];
        reportObj.multi_from = getCookie('multifrom') || '';
        reportObj.web_uid = setWebUid() || '';
        reportObj.prev_url = reportObj.from_path || document.referrer;
        reportObj.current_url = reportObj.path || ((_f = (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.href);
        reportObj.current_path = reportObj.current_path || "".concat((_h = (_g = getWindow()) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.origin).concat((_k = (_j = getWindow()) === null || _j === void 0 ? void 0 : _j.location) === null || _k === void 0 ? void 0 : _k.pathname);
        reportObj.explore_name = reportObj.explore_name || browserInfo.type;
        reportObj.explore_version = reportObj.explore_version || browserInfo.versions;
        reportObj.from_source = reportObj.from_source || getRequest('fromSource') || '';
        reportObj.experiment_id = reportObj.experiment_id || '';
        reportObj.experiment_group_id = reportObj.experiment_group_id || '';
        reportObj.mid = reportObj.mid || getRequest('mid') || '';
        reportObj.net_type = reportObj.net_type || getNetType$1() || '';
    }
    var objStr = JSON.stringify(__assign(__assign({}, options), reportObj));
    reportObj.unique_report_id = formatMd5ToUuid$1(md5(objStr));
    if (!(reportObj === null || reportObj === void 0 ? void 0 : reportObj.unique_report_id) || ((_l = reportObj === null || reportObj === void 0 ? void 0 : reportObj.unique_report_id) === null || _l === void 0 ? void 0 : _l.length) !== 36) {
        reportObj.unique_report_id = uuidv4();
    }
    return __assign(__assign({}, options), reportObj);
}

// 获取 e# 事件的 act page_name element_name
function getActPageModule$1(eventName) {
    if (eventName.startsWith('e#')) {
        var temp = eventName.split('#');
        var pageName = temp[1], elementName = temp[2], act = temp[3];
        return {
            act: act,
            page_name: pageName,
            element_name: elementName,
        };
    }
    return null;
}
/**
 * @deprecated use wemeetBeaconReport
 */
function srvBaseReport(eName, options) {
    try {
        if (typeof window !== 'undefined') {
            var nowTime = new Date().getTime();
            var actPageModule = getActPageModule$1(eName);
            var eventParam = __assign(__assign({}, mergeBaseParams(options)), { event_time: "".concat(nowTime), request_time: nowTime });
            if (actPageModule) {
                eventParam.act = actPageModule.act;
                eventParam.page_name = actPageModule.page_name;
                eventParam.element_name = actPageModule.element_name;
            }
            baseBeaconReport(eName, eventParam);
        }
    }
    catch (err) {
        console.error('srvBaseReport----->>>', err);
    }
}

var commonInfo;
var PROD_REPORT_URL$1 = 'https://report.meeting.tencent.com/api/data-report-beacon';
var TEST_REPORT_URL$1 = 'https://report-test.meeting.tencent.com/api/data-report-beacon';
// 'cmd_test_new_atta'  'cmd_prod_old_atta'
/**
 * 数据上报
 * @param eventName
 * @param report
 * @deprecated 请使用wemeetBeaconReport
 * 开启debug模式 ?debugBeacon=true 或者 localStorage.setItem('debugBeacon', 'true');
 */
function baseBeaconReport(eventName, reportParams) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    if (reportParams === void 0) { reportParams = {}; }
    try {
        // 浏览器环境下才执行
        if (typeof window !== 'undefined') {
            var report_1 = {};
            if (isNewReport$1(eventName)) {
                var nowTime = new Date().getTime();
                var actPageModule = getActPageModule$1(eventName);
                report_1 = __assign(__assign({}, mergeBaseParams(reportParams)), { event_time: "".concat(nowTime), request_time: nowTime });
                if (actPageModule) {
                    report_1.act = actPageModule.act;
                    report_1.page_name = actPageModule.page_name;
                    report_1.element_name = actPageModule.element_name;
                }
            }
            else {
                report_1 = reportParams;
            }
            var reportData = mergeBaseReport(report_1);
            getWindow().copyReportData = JSON.stringify(reportData);
            if (!((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.beaconActionIns) || !((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.beaconActionInsNew)) {
                var isDebug_1 = Boolean(getRequest('debugBeacon') || getRequest('dbgbeacon'));
                var prodKey_1 = ConstantEnum.WEMEET_BEACON_PROD_KEY;
                var debugKey_1 = ConstantEnum.WEMEET_BEACON_DEBUG_KEY;
                if (typeof window.BeaconAction === 'function') {
                    generateBeacon$1(isDebug_1, debugKey_1, prodKey_1, 'BeaconAction', report_1);
                    if (isNewReport$1(eventName)) {
                        (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.beaconActionInsNew) === null || _d === void 0 ? void 0 : _d.onDirectUserAction(eventName, __assign(__assign({}, reportData), commonInfo));
                    }
                    else {
                        (_f = (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.beaconActionIns) === null || _f === void 0 ? void 0 : _f.onDirectUserAction(eventName, __assign({}, reportData));
                    }
                }
                else if (typeof window.BeaconActionSDKClass === 'function') {
                    generateBeacon$1(isDebug_1, debugKey_1, prodKey_1, 'BeaconActionSDKClass', report_1);
                    if (isNewReport$1(eventName)) {
                        (_h = (_g = getWindow()) === null || _g === void 0 ? void 0 : _g.beaconActionInsNew) === null || _h === void 0 ? void 0 : _h.onDirectUserAction(eventName, __assign(__assign({}, reportData), commonInfo));
                    }
                    else {
                        (_k = (_j = getWindow()) === null || _j === void 0 ? void 0 : _j.beaconActionIns) === null || _k === void 0 ? void 0 : _k.onDirectUserAction(eventName, __assign({}, reportData));
                    }
                }
                else {
                    if (!((_l = getWindow()) === null || _l === void 0 ? void 0 : _l.beaconReportList)) {
                        getWindow().beaconReportList = [];
                    }
                    (_o = (_m = getWindow()) === null || _m === void 0 ? void 0 : _m.beaconReportList) === null || _o === void 0 ? void 0 : _o.push({
                        eventName: eventName,
                        reportData: __assign({}, JSON.parse(((_p = getWindow()) === null || _p === void 0 ? void 0 : _p.copyReportData) || report_1)),
                    });
                    loadScript({
                        namespace: 'BeaconAction',
                        cdnPath: 'https://cdn.meeting.tencent.com/assets/client/beacon_web.4.5.20.min.js',
                        staticPath: '/static/js/beacon_web.min.js',
                    })
                        .then(function () {
                        var _a, _b, _c, _d, _e, _f;
                        generateBeacon$1(isDebug_1, debugKey_1, prodKey_1, 'BeaconAction', report_1);
                        if ((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.beaconReportList) {
                            var arr = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.beaconReportList) || [];
                            while (arr.length !== 0) {
                                var _g = arr.shift(), eventName_1 = _g.eventName, reportData_1 = _g.reportData;
                                if (isNewReport$1(eventName_1)) {
                                    (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.beaconActionInsNew) === null || _d === void 0 ? void 0 : _d.onDirectUserAction(eventName_1, __assign(__assign({}, reportData_1), commonInfo));
                                }
                                else {
                                    (_f = (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.beaconActionIns) === null || _f === void 0 ? void 0 : _f.onDirectUserAction(eventName_1, __assign({}, reportData_1));
                                }
                            }
                        }
                    })
                        .catch();
                }
            }
            else {
                if (isNewReport$1(eventName)) {
                    (_r = (_q = getWindow()) === null || _q === void 0 ? void 0 : _q.beaconActionInsNew) === null || _r === void 0 ? void 0 : _r.onDirectUserAction(eventName, __assign(__assign({}, reportData), commonInfo));
                }
                else {
                    (_t = (_s = getWindow()) === null || _s === void 0 ? void 0 : _s.beaconActionIns) === null || _t === void 0 ? void 0 : _t.onDirectUserAction(eventName, __assign({}, reportData));
                }
            }
        }
    }
    catch (err) {
        console.log('baseBeaconReport err');
    }
}
function getCommonInfo$1(beacon) {
    try {
        var info = beacon === null || beacon === void 0 ? void 0 : beacon.commonInfo;
        return __assign(__assign({}, info), { language: info === null || info === void 0 ? void 0 : info.language, resolution: info === null || info === void 0 ? void 0 : info.pixel, query: info === null || info === void 0 ? void 0 : info.query, user_agent: info === null || info === void 0 ? void 0 : info.userAgent, sdkVersion: info === null || info === void 0 ? void 0 : info.sdkVersion, deviceId: info === null || info === void 0 ? void 0 : info.deviceId, channelID: info === null || info === void 0 ? void 0 : info.channelID, openid: info === null || info === void 0 ? void 0 : info.openid, unid: info === null || info === void 0 ? void 0 : info.unid });
    }
    catch (err) {
        return {};
    }
}
function isNewReport$1(eventName) {
    if (eventName.startsWith('e#')) {
        return true;
    }
    return false;
}
function generateBeacon$1(isDebug, debugKey, prodKey, type, report) {
    var _a;
    if (report === void 0) { report = {}; }
    var beaconNew;
    var beacon;
    if (type === 'BeaconAction') {
        beaconNew = new window.BeaconAction({
            appkey: isDebug ? debugKey : prodKey,
            uploadUrl: isNormalEnv() ? PROD_REPORT_URL$1 : TEST_REPORT_URL$1,
            needReportRqdEvent: false,
        });
        beacon = new window.BeaconAction({
            appkey: isDebug ? debugKey : prodKey,
        });
    }
    else {
        beaconNew = new window.BeaconActionSDKClass({
            appkey: isDebug ? debugKey : prodKey,
            uploadUrl: isNormalEnv() ? PROD_REPORT_URL$1 : TEST_REPORT_URL$1,
            needReportRqdEvent: false,
        });
        beacon = new window.BeaconActionSDKClass({
            appkey: isDebug ? debugKey : prodKey,
        });
    }
    var data = JSON.parse(((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.copyReportData) || report);
    var commonOptions = {
        source_id: data === null || data === void 0 ? void 0 : data.source_id,
        report_cmd: isNormalEnv() ? 'cmd_prod_old_atta' : 'cmd_test_new_atta',
        report_flag: (data === null || data === void 0 ? void 0 : data.report_flag) || 3,
        request_time: "".concat(new Date().getTime()),
    };
    // 添加 common 参数
    beaconNew.addAdditionalParams(commonOptions);
    setWindowInstance('beaconActionInsNew', beaconNew);
    setWindowInstance('beaconActionIns', beacon);
    commonInfo = getCommonInfo$1(beacon);
}

var beacon_web_min = {exports: {}};

(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t=function(e,n){return t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e;}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);},t(e,n)};var e=function(){return e=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t},e.apply(this,arguments)};function n(t,e,n,r){return new(n||(n=Promise))((function(o,i){function s(t){try{u(r.next(t));}catch(t){i(t);}}function a(t){try{u(r.throw(t));}catch(t){i(t);}}function u(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(s,a);}u((r=r.apply(t,e||[])).next());}))}function r(t,e){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(a){return function(u){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;i&&(i=0,a[0]&&(s=0)),s;)try{if(n=1,r&&(o=2&a[0]?r.return:a[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,a[1])).done)return o;switch(r=0,o&&(a=[2&a[0],o.value]),a[0]){case 0:case 1:o=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,r=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!(o=s.trys,(o=o.length>0&&o[o.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!o||a[1]>o[0]&&a[1]<o[3])){s.label=a[1];break}if(6===a[0]&&s.label<o[1]){s.label=o[1],o=a;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(a);break}o[2]&&s.ops.pop(),s.trys.pop();continue}a=e.call(t,s);}catch(t){a=[6,t],r=0;}finally{n=o=0;}if(5&a[0])throw a[1];return {value:a[0]?a[1]:void 0,done:!0}}([a,u])}}}var o="__BEACON_",i="__BEACON_deviceId",s="last_report_time",a="sending_event_ids",u="beacon_config",c="beacon_config_request_time",l=new Set(["rqd_js_init","rqd_applaunched"]),p=function(){function t(){var t=this;this.emit=function(e,n){if(t){var r,o=t.__EventsList[e];if(null==o?void 0:o.length){o=o.slice();for(var i=0;i<o.length;i++){r=o[i];try{var s=r.callback.apply(t,[n]);if(1===r.type&&t.remove(e,r.callback),!1===s)break}catch(t){throw t}}}return t}},this.__EventsList={};}return t.prototype.indexOf=function(t,e){for(var n=0;n<t.length;n++)if(t[n].callback===e)return n;return -1},t.prototype.on=function(t,e,n){if(void 0===n&&(n=0),this){var r=this.__EventsList[t];if(r||(r=this.__EventsList[t]=[]),-1===this.indexOf(r,e)){var o={name:t,type:n||0,callback:e};return r.push(o),this}return this}},t.prototype.one=function(t,e){this.on(t,e,1);},t.prototype.remove=function(t,e){if(this){var n=this.__EventsList[t];if(!n)return null;if(!e){try{delete this.__EventsList[t];}catch(t){}return null}if(n.length){var r=this.indexOf(n,e);n.splice(r,1);}return this}},t}();function h(t,e){for(var n={},r=0,o=Object.keys(t);r<o.length;r++){var i=o[r],s=t[i];if("string"==typeof s)n[f(i)]=f(s);else {if(e)throw new Error("value mast be string  !!!!");n[f(String(i))]=f(String(s));}}return n}function f(t){if("string"!=typeof t)return t;try{return t.replace(new RegExp("\\|","g"),"%7C").replace(new RegExp("\\&","g"),"%26").replace(new RegExp("\\=","g"),"%3D").replace(new RegExp("\\+","g"),"%2B")}catch(t){return ""}}function d(t){return String(t.A99)+String(t.A100)}var v=function(){};var g=function(){function t(t){var n=this;this.lifeCycle=new p,this.uploadJobQueue=[],this.additionalParams={},this.delayTime=0,this._normalLogPipeline=function(t){if(!t||!t.reduce||!t.length)throw new TypeError("createPipeline 方法需要传入至少有一个 pipe 的数组");return 1===t.length?function(e,n){t[0](e,n||v);}:t.reduce((function(t,e){return function(n,r){return void 0===r&&(r=v),t(n,(function(t){return null==e?void 0:e(t,r)}))}}))}([function(t){n.send({url:n.strategy.getUploadUrl(),data:t,method:"post",contentType:"application/json;charset=UTF-8"},(function(){var e=n.config.onReportSuccess;"function"==typeof e&&e(JSON.stringify(t.events));}),(function(){var e=n.config.onReportFail;"function"==typeof e&&e(JSON.stringify(t.events));}));}]),function(t,e){if(!t)throw e instanceof Error?e:new Error(e)}(Boolean(t.appkey),"appkey must be initial"),this.config=e(e({},t),{needReportRqdEvent:null==t.needReportRqdEvent||t.needReportRqdEvent});}return t.prototype.onUserAction=function(t,e){this.preReport(t,e,!1);},t.prototype.onDirectUserAction=function(t,e){this.preReport(t,e,!0);},t.prototype.preReport=function(t,e,n){t?this.strategy.isEventUpOnOff()&&(this.strategy.isBlackEvent(t)||this.strategy.isSampleEvent(t)||!this.config.needReportRqdEvent&&l.has(t)||this.onReport(t,e,n)):this.errorReport.reportError("602"," no eventCode");},t.prototype.addAdditionalParams=function(t){for(var e=0,n=Object.keys(t);e<n.length;e++){var r=n[e];this.additionalParams[r]=t[r];}},t.prototype.setChannelId=function(t){this.commonInfo.channelID=String(t);},t.prototype.setOpenId=function(t){this.commonInfo.openid=String(t);},t.prototype.setUnionid=function(t){this.commonInfo.unid=String(t);},t.prototype.getDeviceId=function(){return this.commonInfo.deviceId},t.prototype.getCommonInfo=function(){return this.commonInfo},t.prototype.removeSendingId=function(t){try{var e=JSON.parse(this.storage.getItem(a)),n=e.indexOf(t);-1!=n&&(e.splice(n,1),this.storage.setItem(a,JSON.stringify(e)));}catch(t){}},t}(),y=function(){function t(t,e,n,r){this.requestParams={},this.network=r,this.requestParams.attaid="00400014144",this.requestParams.token="6478159937",this.requestParams.product_id=t.appkey,this.requestParams.platform=n,this.requestParams.uin=e.deviceId,this.requestParams.model="",this.requestParams.os=n,this.requestParams.app_version=t.appVersion,this.requestParams.sdk_version=e.sdkVersion,this.requestParams.error_stack="",this.uploadUrl=t.isOversea?"https://htrace.wetvinfo.com/kv":"https://h.trace.qq.com/kv";}return t.prototype.reportError=function(t,e){this.requestParams._dc=Math.random(),this.requestParams.error_msg=e,this.requestParams.error_code=t,this.network.get(this.uploadUrl,{params:this.requestParams}).catch((function(t){}));},t}(),m=function(){function t(t,e,n,r,o){this.strategy={isEventUpOnOff:!0,httpsUploadUrl:"https://otheve.beacon.qq.com/analytics/v2_upload",requestInterval:30,blacklist:[],samplelist:[]},this.realSample={},this.appkey="",this.needQueryConfig=!0,this.appkey=e.appkey,this.storage=r,this.needQueryConfig=t;try{var i=JSON.parse(this.storage.getItem(u));i&&this.processData(i);}catch(t){}e.isOversea&&(this.strategy.httpsUploadUrl="https://svibeacon.onezapp.com/analytics/v2_upload"),!e.isOversea&&this.needRequestConfig()&&this.requestConfig(e.appVersion,n,o);}return t.prototype.requestConfig=function(t,e,n){var r=this;this.storage.setItem(c,Date.now().toString()),n.post("https://oth.str.beacon.qq.com/trpc.beacon.configserver.BeaconConfigService/QueryConfig",{platformId:"undefined"==typeof wx?"3":"4",mainAppKey:this.appkey,appVersion:t,sdkVersion:e.sdkVersion,osVersion:e.userAgent,model:"",packageName:"",params:{A3:e.deviceId}}).then((function(t){if(0==t.data.ret)try{var e=JSON.parse(t.data.beaconConfig);e&&(r.processData(e),r.storage.setItem(u,t.data.beaconConfig));}catch(t){}else r.processData(null),r.storage.setItem(u,"");})).catch((function(t){}));},t.prototype.processData=function(t){var e,n,r,o,i;this.strategy.isEventUpOnOff=null!==(e=null==t?void 0:t.isEventUpOnOff)&&void 0!==e?e:this.strategy.isEventUpOnOff,this.strategy.httpsUploadUrl=null!==(n=null==t?void 0:t.httpsUploadUrl)&&void 0!==n?n:this.strategy.httpsUploadUrl,this.strategy.requestInterval=null!==(r=null==t?void 0:t.requestInterval)&&void 0!==r?r:this.strategy.requestInterval,this.strategy.blacklist=null!==(o=null==t?void 0:t.blacklist)&&void 0!==o?o:this.strategy.blacklist,this.strategy.samplelist=null!==(i=null==t?void 0:t.samplelist)&&void 0!==i?i:this.strategy.samplelist;for(var s=0,a=this.strategy.samplelist;s<a.length;s++){var u=a[s].split(",");2==u.length&&(this.realSample[u[0]]=u[1]);}},t.prototype.needRequestConfig=function(){if(!this.needQueryConfig)return !1;var t=Number(this.storage.getItem(c));return Date.now()-t>60*this.strategy.requestInterval*1e3},t.prototype.getUploadUrl=function(){return this.strategy.httpsUploadUrl+"?appkey="+this.appkey},t.prototype.isBlackEvent=function(t){return -1!=this.strategy.blacklist.indexOf(t)},t.prototype.isEventUpOnOff=function(){return this.strategy.isEventUpOnOff},t.prototype.isSampleEvent=function(t){return !!Object.prototype.hasOwnProperty.call(this.realSample,t)&&this.realSample[t]<Math.floor(Math.random()*Math.floor(1e4))},t}(),w="session_storage_key",b=function(){function t(t,e,n){this.getSessionStackDepth=0,this.beacon=n,this.storage=t,this.duration=e,this.appkey=n.config.appkey;}return t.prototype.getSession=function(){this.getSessionStackDepth+=1;var t=this.storage.getItem(w);if(!t)return this.createSession();var e="",n=0;try{var r=JSON.parse(t)||{sessionId:void 0,sessionStart:void 0};if(!r.sessionId||!r.sessionStart)return this.createSession();var o=Number(this.storage.getItem(s));if(Date.now()-o>this.duration)return this.createSession();e=r.sessionId,n=r.sessionStart,this.getSessionStackDepth=0;}catch(t){}return {sessionId:e,sessionStart:n}},t.prototype.createSession=function(){var t=Date.now(),e={sessionId:this.appkey+"_"+t.toString(),sessionStart:t};this.storage.setItem(w,JSON.stringify(e)),this.storage.setItem(s,t.toString());var n="is_new_user",r=this.storage.getItem(n);return this.getSessionStackDepth<=1&&this.beacon.onDirectUserAction("rqd_applaunched",{A21:r?"N":"Y"}),this.storage.setItem(n,JSON.stringify(!1)),e},t}();function S(){var t=navigator.userAgent,e=t.indexOf("compatible")>-1&&t.indexOf("MSIE")>-1,n=t.indexOf("Edge")>-1&&!e,r=t.indexOf("Trident")>-1&&t.indexOf("rv:11.0")>-1;if(e){new RegExp("MSIE (\\d+\\.\\d+);").test(t);var o=parseFloat(RegExp.$1);return 7==o?7:8==o?8:9==o?9:10==o?10:6}return n?-2:r?11:-1}function I(t,e){var n,r;return (n="https://tun-cos-1258344701.file.myqcloud.com/fp.js",void 0===r&&(r=Date.now()+"-"+Math.random()),new Promise((function(t,e){if(document.getElementById(r))t(void 0);else {var o=document.getElementsByTagName("head")[0],i=document.createElement("script");i.onload=function(){return function(){i.onload=null,t(void 0);}},i.onerror=function(t){i.onerror=null,o.removeChild(i),e(t);},i.src=n,i.id=r,o.appendChild(i);}}))).then((function(){(new Fingerprint).getQimei36(t,e);})).catch((function(t){})),""}var E=function(){return (E=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};var k,O=function(){function t(t,e){void 0===e&&(e={}),this.reportOptions={},this.config=t,this.reportOptions=e;}return t.canUseDB=function(){return !!(null===window||void 0===window?void 0:window.indexedDB)},t.prototype.openDB=function(){var e=this;return new Promise((function(n,r){if(!t.canUseDB())return r({message:"当前不支持 indexeddb"});var o=e.config,i=o.name,s=o.version,a=o.stores,u=indexedDB.open(i,s);u.onsuccess=function(){e.db=u.result,n(),E({result:1,func:"open",params:JSON.stringify(e.config)},e.reportOptions);},u.onerror=function(t){var n,o;r(t),E({result:0,func:"open",params:JSON.stringify(e.config),error_msg:null===(o=null===(n=t.target)||void 0===n?void 0:n.error)||void 0===o?void 0:o.message},e.reportOptions);},u.onupgradeneeded=function(){e.db=u.result;try{null==a||a.forEach((function(t){e.createStore(t);}));}catch(t){E({result:0,func:"open",params:JSON.stringify(e.config),error_msg:t.message},e.reportOptions),r(t);}};}))},t.prototype.useStore=function(t){return this.storeName=t,this},t.prototype.deleteDB=function(){var t=this;return this.closeDB(),new Promise((function(e,n){var r=indexedDB.deleteDatabase(t.config.name);r.onsuccess=function(){return e()},r.onerror=n;}))},t.prototype.closeDB=function(){var t;null===(t=this.db)||void 0===t||t.close(),this.db=null;},t.prototype.getStoreCount=function(){var t=this;return new Promise((function(e,n){var r=t.getStore("readonly").count();r.onsuccess=function(){return e(r.result)},r.onerror=n;}))},t.prototype.clearStore=function(){var t=this;return new Promise((function(e,n){var r=t.getStore("readwrite").clear();r.onsuccess=function(){return e()},r.onerror=n;}))},t.prototype.add=function(t,e){var n=this;return new Promise((function(r,o){var i=n.getStore("readwrite").add(t,e);i.onsuccess=function(){r(i.result);},i.onerror=o;}))},t.prototype.put=function(t,e){var n=this;return new Promise((function(r,o){var i=n.getStore("readwrite").put(t,e);i.onsuccess=function(){r(i.result);},i.onerror=o;}))},t.prototype.getStoreAllData=function(){var t=this;return new Promise((function(e,n){var r=t.getStore("readonly").openCursor(),o=[];r.onsuccess=function(){var t;if(null===(t=r.result)||void 0===t?void 0:t.value){var n=r.result.value;o.push(n),r.result.continue();}else e(o);},r.onerror=n;}))},t.prototype.getDataRangeByIndex=function(t,e,n,r,o){var i=this;return new Promise((function(s,a){var u=i.getStore().index(t),c=IDBKeyRange.bound(e,n,r,o),l=[],p=u.openCursor(c);p.onsuccess=function(){var t;(null===(t=null==p?void 0:p.result)||void 0===t?void 0:t.value)?(l.push(null==p?void 0:p.result.value),null==p||p.result.continue()):s(l);},p.onerror=a;}))},t.prototype.removeDataByIndex=function(t,e,n,r,o){var i=this;return new Promise((function(s,a){var u=i.getStore("readwrite").index(t),c=IDBKeyRange.bound(e,n,r,o),l=u.openCursor(c),p=0;l.onsuccess=function(t){var e=t.target.result;e?(p+=1,e.delete(),e.continue()):s(p);},l.onerror=a;}))},t.prototype.createStore=function(t){var e=t.name,n=t.indexes,r=void 0===n?[]:n,o=t.options;if(this.db){this.db.objectStoreNames.contains(e)&&this.db.deleteObjectStore(e);var i=this.db.createObjectStore(e,o);r.forEach((function(t){i.createIndex(t.indexName,t.keyPath,t.options);}));}},t.prototype.getStore=function(t){var e;return void 0===t&&(t="readonly"),null===(e=this.db)||void 0===e?void 0:e.transaction(this.storeName,t).objectStore(this.storeName)},t}(),C="event_table_v3",D="eventId",_=function(){function t(t,e){this.isReady=!1,this.taskQueue=Promise.resolve(),this.db=new O({name:"Beacon_"+t+"_V3",version:1,stores:[{name:C,options:{keyPath:D},indexes:[{indexName:D,keyPath:D,options:{unique:!0}}]}]}),this.open(e);}return t.prototype.getCount=function(){var t=this;return this.readyExec((function(){return t.db.getStoreCount()}))},t.prototype.setItem=function(t,e){var n=this;return this.readyExec((function(){return n.db.add({eventId:t,value:e})}))},t.prototype.getItem=function(t){return n(this,void 0,void 0,(function(){var e=this;return r(this,(function(n){return [2,this.readyExec((function(){return e.db.getDataRangeByIndex(D,t,t)}))]}))}))},t.prototype.removeItem=function(t){var e=this;return this.readyExec((function(){return e.db.removeDataByIndex(D,t,t)}))},t.prototype.updateItem=function(t,e){var n=this;return this.readyExec((function(){return n.db.put({eventId:t,value:e})}))},t.prototype.iterate=function(t){var e=this;return this.readyExec((function(){return e.db.getStoreAllData().then((function(e){e.forEach((function(e){t(e.value);}));}))}))},t.prototype.open=function(t){return n(this,void 0,void 0,(function(){var e,n=this;return r(this,(function(r){switch(r.label){case 0:return r.trys.push([0,2,,3]),this.taskQueue=this.taskQueue.then((function(){return n.db.openDB()})),[4,this.taskQueue];case 1:return r.sent(),this.isReady=!0,this.db.useStore(C),[3,3];case 2:return e=r.sent(),null==t||t.openDBFail(e),[3,3];case 3:return [2]}}))}))},t.prototype.readyExec=function(t){return this.isReady?t():(this.taskQueue=this.taskQueue.then((function(){return t()})),this.taskQueue)},t}(),x=function(){function t(t){this.keyObject={},this.storage=t;}return t.prototype.getCount=function(){return this.storage.getStoreCount()},t.prototype.removeItem=function(t){this.storage.removeItem(t),delete this.keyObject[t];},t.prototype.setItem=function(t,e){var n=JSON.stringify(e);this.storage.setItem(t,n),this.keyObject[t]=e;},t.prototype.iterate=function(t){for(var e=Object.keys(this.keyObject),n=0;n<e.length;n++){var r=this.storage.getItem(e[n]);t(JSON.parse(r));}},t}(),P=function(){function t(t,e){var n=this;this.dbEventCount=0;var r=S(),o=function(){n.store=new x(e),n.dbEventCount=n.store.getCount();};r>0||!window.indexedDB||/X5Lite/.test(navigator.userAgent)?o():(this.store=new _(t,{openDBFail:function(t){o();}}),this.getCount().then((function(t){n.dbEventCount=t;})).catch((function(t){})));}return t.prototype.getCount=function(){return n(this,void 0,void 0,(function(){return r(this,(function(t){switch(t.label){case 0:return t.trys.push([0,2,,3]),[4,this.store.getCount()];case 1:return [2,t.sent()];case 2:return t.sent(),[2,Promise.reject()];case 3:return [2]}}))}))},t.prototype.insertEvent=function(t,e){return n(this,void 0,void 0,(function(){var n,o;return r(this,(function(r){switch(r.label){case 0:if(this.dbEventCount>=1e4)return [2,Promise.reject()];n=d(t.mapValue),r.label=1;case 1:return r.trys.push([1,3,,4]),this.dbEventCount++,[4,this.store.setItem(n,t)];case 2:return [2,r.sent()];case 3:return o=r.sent(),e&&e(o,t),this.dbEventCount--,[2,Promise.reject()];case 4:return [2]}}))}))},t.prototype.getEvents=function(){return n(this,void 0,void 0,(function(){var t;return r(this,(function(e){switch(e.label){case 0:t=[],e.label=1;case 1:return e.trys.push([1,3,,4]),[4,this.store.iterate((function(e){t.push(e);}))];case 2:return e.sent(),[2,Promise.all(t)];case 3:return e.sent(),[2,Promise.all(t)];case 4:return [2]}}))}))},t.prototype.removeEvent=function(t){return n(this,void 0,void 0,(function(){var e;return r(this,(function(n){switch(n.label){case 0:e=d(t.mapValue),n.label=1;case 1:return n.trys.push([1,3,,4]),this.dbEventCount--,[4,this.store.removeItem(e)];case 2:return [2,n.sent()];case 3:return n.sent(),this.dbEventCount++,[2,Promise.reject()];case 4:return [2]}}))}))},t}(),T=function(){return (T=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function U(t){try{return decodeURIComponent(t.replace(/\+/g," "))}catch(t){return null}}function q(t,e){var n=[null,void 0,"",NaN].includes(t);if(e.isSkipEmpty&&n)return null;var r=!e.isSkipEmpty&&n?"":t;try{return e.encode?encodeURIComponent(r):r}catch(t){return null}}function j(t,e){void 0===e&&(e={encode:!0,isSkipEmpty:!1});var n=t.url,r=t.query,o=void 0===r?{}:r,i=t.hash,s=n.split("#"),a=s[0],u=s[1],c=void 0===u?"":u,l=a.split("?")[0],p=[],h=q(i||c,e),f=T(T({},function(t){var e=t.split("#"),n=e[0],r=e[1],o=void 0===r?"":r,i=n.split("?"),s=i[0],a=i[1],u=void 0===a?"":a,c=U(o),l=Object.create(null);return u.split("&").forEach((function(t){var e=t.split("="),n=e[0],r=e[1],o=void 0===r?"":r,i=U(n),s=U(o);null===i||null===s||""===i&&""===s||l[i]||(l[i]=s);})),{url:s,query:l,hash:c}}(n).query),o);return Object.keys(f).forEach((function(t){var n=q(t,e),r=q(f[t],e);null!==n&&null!==r&&p.push(n+"="+r);})),l+(p.length?"?"+p.join("&"):"")+(h?"#"+h:"")}function N(t,e){return new Promise((function(n,r){if(e&&document.querySelectorAll("script[data-tag="+e+"]").length)return n();var o=document.createElement("script"),i=T({type:"text/javascript",charset:"utf-8"},t);Object.keys(i).forEach((function(t){return function(t,e,n){if(t)return void 0===n?t.getAttribute(e):t.setAttribute(e,n)}(o,t,i[t])})),e&&(o.dataset.tag=e),o.onload=function(){return n()},o.onreadystatechange=function(){var t=o.readyState;["complete","loaded"].includes(t)&&(o.onreadystatechange=null,n());},o.onerror=r,document.body.appendChild(o);}))}!function(t){t[t.equal=0]="equal",t[t.low=-1]="low",t[t.high=1]="high";}(k||(k={}));var A=function(){return (A=Object.assign||function(t){for(var e,n=1,r=arguments.length;n<r;n++)for(var o in e=arguments[n])Object.prototype.hasOwnProperty.call(e,o)&&(t[o]=e[o]);return t}).apply(this,arguments)};function R(t,e,n,r){return new(n||(n=Promise))((function(o,i){function s(t){try{u(r.next(t));}catch(t){i(t);}}function a(t){try{u(r.throw(t));}catch(t){i(t);}}function u(t){var e;t.done?o(t.value):(e=t.value,e instanceof n?e:new n((function(t){t(e);}))).then(s,a);}u((r=r.apply(t,e||[])).next());}))}function B(t,e){var n,r,o,i,s={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function a(i){return function(a){return function(i){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return s.label++,{value:i[1],done:!1};case 5:s.label++,r=i[1],i=[0];continue;case 7:i=s.ops.pop(),s.trys.pop();continue;default:if(!((o=(o=s.trys).length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){s=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){s.label=i[1];break}if(6===i[0]&&s.label<o[1]){s.label=o[1],o=i;break}if(o&&s.label<o[2]){s.label=o[2],s.ops.push(i);break}o[2]&&s.ops.pop(),s.trys.pop();continue}i=e.call(t,s);}catch(t){i=[6,t],r=0;}finally{n=o=0;}if(5&i[0])throw i[1];return {value:i[0]?i[1]:void 0,done:!0}}([i,a])}}}var J=function(){function t(){this.interceptors=[];}return t.prototype.use=function(t,e){return this.interceptors.push({resolved:t,rejected:e}),this.interceptors.length-1},t.prototype.traverse=function(t,e){void 0===e&&(e=!1);var n=Promise.resolve(t);return (e?Array.prototype.reduceRight:Array.prototype.reduce).call(this.interceptors,(function(t,e){if(e){var r=e.resolved,o=e.rejected;n=n.then(r,o);}return t}),""),n},t.prototype.eject=function(t){this.interceptors[t]&&(this.interceptors[t]=null);},t}(),V={defaults:{timeout:0,method:"GET",mode:"cors",redirect:"follow",credentials:"same-origin"},headers:{common:{Accept:"application/json, text/plain, */*"},POST:{"Content-Type":"application/x-www-form-urlencoded"},PUT:{"Content-Type":"application/x-www-form-urlencoded"},PATCH:{"Content-Type":"application/x-www-form-urlencoded"}},baseURL:"",polyfillUrl:"https://vm.gtimg.cn/comps/script/fetch.min.js",interceptors:{request:new J,response:new J}},Q=/^([a-z][a-z\d+\-.]*:)?\/\//i,L=Object.prototype.toString;function M(t){return R(this,void 0,void 0,(function(){var e;return B(this,(function(n){switch(n.label){case 0:if(window.fetch)return [2];n.label=1;case 1:return n.trys.push([1,3,,4]),[4,N({src:t})];case 2:return n.sent(),[3,4];case 3:throw e=n.sent(),new Error("加载 polyfill "+t+" 失败: "+e.message);case 4:return [2]}}))}))}function K(t){return ["Accept","Content-Type"].forEach((function(e){return n=e,void((r=t.headers)&&Object.keys(r).forEach((function(t){t!==n&&t.toUpperCase()===n.toUpperCase()&&(r[n]=r[t],delete r[t]);})));var n,r;})),function(t){if("[object Object]"!==L.call(t))return !1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype}(t.body)&&(t.body=JSON.stringify(t.body),t.headers&&(t.headers["Content-Type"]="application/json;charset=utf-8")),t}function F(t){return R(this,void 0,void 0,(function(){var e,n,r,o,i,s,a,u,c,l,p,h,f,d,v,g,y;return B(this,(function(m){switch(m.label){case 0:return e=V.baseURL,n=V.defaults,r=V.interceptors,[4,M(V.polyfillUrl)];case 1:return m.sent(),(o=A(A({},n),t)).headers||(o.headers=function(t){void 0===t&&(t="GET");var e=V.headers[t]||{};return A(A({},V.headers.common),e)}(o.method)),K(o),[4,r.request.traverse(o,!0)];case 2:if((i=m.sent())instanceof Error)throw i;return i.url=function(t,e){return !t||Q.test(e)?e:t.replace(/\/+$/,"")+"/"+e.replace(/^\/+/,"")}(e,i.url),s=i.url,a=i.timeout,u=i.params,c=i.method,l=["GET","DELETE","OPTIONS","HEAD"].includes(void 0===c?"GET":c)&&!!u,p=l?j({url:s,query:u}):s,h=[],a&&!i.signal&&(v=new Promise((function(t){f=setTimeout((function(){t(new Error("timeout"));}),a);})),h.push(v),d=new AbortController,i.signal=d.signal),h.push(fetch(p,i).catch((function(t){return t}))),[4,Promise.race(h)];case 3:return g=m.sent(),f&&clearTimeout(f),[4,r.response.traverse(g)];case 4:if((y=m.sent())instanceof Error)throw null==d||d.abort(),y;return [2,y]}}))}))}var G=function(){function t(t){V.interceptors.request.use((function(n){var r=n.url,o=n.method,i=n.body,s=i;if(t.onReportBeforeSend){var a=t.onReportBeforeSend({url:r,method:o,data:i?JSON.parse(i):null});s=(null==a?void 0:a.data)?JSON.stringify(a.data):null;}return "GET"!=o&&s?e(e({},n),{body:s}):n}));}return t.prototype.get=function(t,o){return n(this,void 0,void 0,(function(){var n,i;return r(this,(function(r){switch(r.label){case 0:return [4,F(e({url:t},o))];case 1:return [4,(n=r.sent()).json()];case 2:return i=r.sent(),[2,Promise.resolve({data:i,status:n.status,statusText:n.statusText,headers:n.headers})]}}))}))},t.prototype.post=function(t,o,i){return n(this,void 0,void 0,(function(){var n,s;return r(this,(function(r){switch(r.label){case 0:return [4,F(e({url:t,body:o,method:"POST"},i))];case 1:return [4,(n=r.sent()).json()];case 2:return s=r.sent(),[2,Promise.resolve({data:s,status:n.status,statusText:n.statusText,headers:n.headers})]}}))}))},t}(),z=function(){function t(t){this.appkey=t;}return t.prototype.getItem=function(t){try{return window.localStorage.getItem(this.getStoreKey(t))}catch(t){return ""}},t.prototype.removeItem=function(t){try{window.localStorage.removeItem(this.getStoreKey(t));}catch(t){}},t.prototype.setItem=function(t,e){try{window.localStorage.setItem(this.getStoreKey(t),e);}catch(t){}},t.prototype.setSessionItem=function(t,e){try{window.sessionStorage.setItem(this.getStoreKey(t),e);}catch(t){}},t.prototype.getSessionItem=function(t){try{return window.sessionStorage.getItem(this.getStoreKey(t))}catch(t){return ""}},t.prototype.getStoreKey=function(t){return o+this.appkey+"_"+t},t.prototype.createDeviceId=function(){try{var t=window.localStorage.getItem(i);return t||(t=function(t){for(var e="ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz0123456789",n="",r=0;r<t;r++)n+=e.charAt(Math.floor(Math.random()*e.length));return n}(32),window.localStorage.setItem(i,t)),t}catch(t){return ""}},t.prototype.clear=function(){try{for(var t=window.localStorage.length,e=0;e<t;e++){var n=window.localStorage.key(e);(null==n?void 0:n.substr(0,9))==o&&window.localStorage.removeItem(n);}}catch(t){}},t.prototype.getStoreCount=function(){var t=0;try{t=window.localStorage.length;}catch(t){}return t},t}(),W="logid_start",H="4.5.20-web";return function(n){function r(t){var e=n.call(this,t)||this;e.qimei36="",e.uselessCycleTaskNum=0,e.underWeakNet=!1,e.pauseSearching=!1,e.send=function(t,n,r){e.storage.setItem(s,Date.now().toString()),e.network.post(e.uploadUrl||e.strategy.getUploadUrl(),t.data).then((function(r){var o;100==(null===(o=null==r?void 0:r.data)||void 0===o?void 0:o.result)?e.delayTime=1e3*r.data.delayTime:e.delayTime=0,n&&n(t.data),t.data.events.forEach((function(t){e.store.removeEvent(t).then((function(){e.removeSendingId(d(t.mapValue));})).catch((function(t){}));})),e.doCustomCycleTask();})).catch((function(n){var o=t.data.events;e.errorReport.reportError(n.code?n.code.toString():"600",n.message),r&&r(t.data);var i=JSON.parse(e.storage.getItem(a));o.forEach((function(t){i&&-1!=i.indexOf(d(t))&&e.store.insertEvent(t,(function(t,n){t&&e.errorReport.reportError("604","insertEvent fail!");})),e.removeSendingId(d(t));})),e.monitorUploadFailed();}));};var r,o,i=S();return e.isUnderIE8=i>0&&i<8,e.isUnderIE8||(e.isUnderIE=i>0,t.needInitQimei&&I(t.appkey,(function(t){e.qimei36=t.q36;})),e.network=new G(t),e.storage=new z(t.appkey),e.initCommonInfo(t),e.store=new P(t.appkey,e.storage),e.errorReport=new y(e.config,e.commonInfo,"web",e.network),e.strategy=new m(null==t.needQueryConfig||t.needQueryConfig,e.config,e.commonInfo,e.storage,e.network),e.logidStartTime=e.storage.getItem(W),e.logidStartTime||(e.logidStartTime=Date.now().toString(),e.storage.setItem(W,e.logidStartTime)),r=e.logidStartTime,o=Date.now()-Number.parseFloat(r),Math.floor(o/864e5)>=365&&e.storage.clear(),e.initSession(t),e.onDirectUserAction("rqd_js_init",{}),setTimeout((function(){return e.lifeCycle.emit("init")}),0),e.initDelayTime=t.delay?t.delay:1e3,e.cycleTask(e.initDelayTime)),e}return function(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function r(){this.constructor=e;}t(e,n),e.prototype=null===n?Object.create(n):(r.prototype=n.prototype,new r);}(r,n),r.prototype.initSession=function(t){var e=18e5;t.sessionDuration&&t.sessionDuration>3e4&&(e=t.sessionDuration),this.beaconSession=new b(this.storage,e,this);},r.prototype.initCommonInfo=function(t){var e=Number(this.storage.getItem(s));try{var n=JSON.parse(this.storage.getItem(a));(Date.now()-e>3e4||!n)&&this.storage.setItem(a,JSON.stringify([]));}catch(t){}t.uploadUrl&&(this.uploadUrl=t.uploadUrl+"?appkey="+t.appkey);var r=[window.screen.width,window.screen.height];window.devicePixelRatio&&r.push(window.devicePixelRatio),this.commonInfo={deviceId:this.storage.createDeviceId(),language:navigator&&navigator.language||"zh_CN",query:window.location.search,userAgent:navigator.userAgent,pixel:r.join("*"),channelID:t.channelID?String(t.channelID):"",openid:t.openid?String(t.openid):"",unid:t.unionid?String(t.unionid):"",sdkVersion:H},this.config.appVersion=t.versionCode?String(t.versionCode):"",this.config.strictMode=t.strictMode;},r.prototype.cycleTask=function(t){var e=this;this.intervalID=window.setInterval((function(){e.pauseSearching||e.store.getEvents().then((function(t){0==t.length&&(e.pauseSearching=!0);var n=[],r=JSON.parse(e.storage.getItem(a));r||(r=[]),t&&t.forEach((function(t){var e=d(t.mapValue);-1==r.indexOf(e)&&(n.push(t),r.push(e));})),r.length>1e3&&(r=[]),0!=n.length&&(e.storage.setItem(a,JSON.stringify(r)),e._normalLogPipeline(e.assembleData(n)));})).catch((function(t){}));}),t);},r.prototype.onReport=function(t,e,n){var r=this;if(this.isUnderIE8)this.errorReport.reportError("601","UnderIE8");else {this.pauseSearching=!1;var o=this.generateData(t,e,n);if(n&&0==this.delayTime&&!this.underWeakNet)this._normalLogPipeline(this.assembleData(o));else {var i=o.shift();i&&this.store.insertEvent(i,(function(t){t&&r.errorReport.reportError("604","insertEvent fail!");})).catch((function(t){r._normalLogPipeline(r.assembleData(o));}));}}},r.prototype.onSendBeacon=function(t,e){if(this.isUnderIE)this.errorReport.reportError("605","UnderIE");else {this.pauseSearching=!1;var n=this.assembleData(this.generateData(t,e,!0));"function"==typeof navigator.sendBeacon&&navigator.sendBeacon(this.uploadUrl||this.strategy.getUploadUrl(),JSON.stringify(n));}},r.prototype.generateData=function(t,n,r){var o=[],i="4.5.20-web_"+(r?"direct_log_id":"normal_log_id"),s=Number(this.storage.getItem(i));return s=s||1,n=e(e({},n),{A99:r?"Y":"N",A100:s.toString(),A72:H,A88:this.logidStartTime}),s++,this.storage.setItem(i,s.toString()),o.push({eventCode:t,eventTime:Date.now().toString(),mapValue:h(n,this.config.strictMode)}),o},r.prototype.assembleData=function(t){var n=this.beaconSession.getSession();return {appVersion:this.config.appVersion?f(this.config.appVersion):"",sdkId:"js",sdkVersion:H,mainAppKey:this.config.appkey,platformId:3,common:h(e(e({},this.additionalParams),{A2:this.commonInfo.deviceId,A8:this.commonInfo.openid,A12:this.commonInfo.language,A17:this.commonInfo.pixel,A23:this.commonInfo.channelID,A50:this.commonInfo.unid,A76:n.sessionId,A101:this.commonInfo.userAgent,A102:window.location.href,A104:document.referrer,A119:this.commonInfo.query,A153:this.qimei36}),!1),events:t}},r.prototype.monitorUploadFailed=function(){this.uselessCycleTaskNum++,this.uselessCycleTaskNum>=5&&(window.clearInterval(this.intervalID),this.cycleTask(6e4),this.underWeakNet=!0);},r.prototype.doCustomCycleTask=function(){this.uselessCycleTaskNum>=5&&(window.clearInterval(this.intervalID),this.cycleTask(this.initDelayTime)),this.uselessCycleTaskNum=0,this.underWeakNet=!1;},r.prototype.setQimei=function(t){this.qimei36=t;},r}(g)}));
}(beacon_web_min));

var BeaconAction = beacon_web_min.exports;

var beaconActionIns = null;
var beaconActionInsNew = null;
var beaconActionI18nIns = null;
var beaconActionI18nInsNew = null;
var wemeetBeaconReportCommonInfo = {};
var PROD_REPORT_URL = 'https://report.meeting.tencent.com/api/data-report-beacon';
var TEST_REPORT_URL = 'https://report-test.meeting.tencent.com/api/data-report-beacon';
var PROD_I18N_REPORT_URL = 'https://report.voovmeeting.com/api/data-report-beacon';
// const TEST_I18N_REPORT_URL = 'https://report-test.voovmeeting.com/api/data-report-beacon';
var I18N_DATAHUB_REPORT_URL = 'https://svibeacon.onezapp.com/analytics/v2_upload';
/**
 * 判断上报是否是新通道 e# 开头事件名
 * @param eventName 事件名
 * @returns
 */
function isNewReport(eventName) {
    if (eventName.startsWith('e#')) {
        return true;
    }
    return false;
}
/**
 * 获取 e# 事件的 act page_name element_name
 * @param eventName
 * @returns
 */
function getActPageModule(eventName) {
    if (eventName.startsWith('e#')) {
        var temp = eventName.split('#');
        var pageName = temp[1], elementName = temp[2], act = temp[3];
        return {
            act: act,
            page_name: pageName,
            element_name: elementName,
        };
    }
    return null;
}
/**
 * 获取灯塔 sdk 提供的 common 参数
 * @param beacon
 * @returns
 */
function getCommonInfo(beacon) {
    try {
        var info = beacon === null || beacon === void 0 ? void 0 : beacon.commonInfo;
        return __assign(__assign({}, info), { language: info === null || info === void 0 ? void 0 : info.language, resolution: info === null || info === void 0 ? void 0 : info.pixel, query: info === null || info === void 0 ? void 0 : info.query, user_agent: info === null || info === void 0 ? void 0 : info.userAgent, sdkVersion: info === null || info === void 0 ? void 0 : info.sdkVersion, deviceId: info === null || info === void 0 ? void 0 : info.deviceId, channelID: info === null || info === void 0 ? void 0 : info.channelID, openid: info === null || info === void 0 ? void 0 : info.openid, unid: info === null || info === void 0 ? void 0 : info.unid });
    }
    catch (err) {
        return {};
    }
}
// 初始化灯塔 sdk
function initBeaconSDK(reportParams) {
    if (reportParams === void 0) { reportParams = {}; }
    if (beaconActionIns && beaconActionInsNew) {
        return;
    }
    var isDebug = Boolean(getRequest('debugBeacon') || getRequest('dbgbeacon'));
    var prodKey = ConstantEnum.WEMEET_BEACON_PROD_KEY;
    var debugKey = ConstantEnum.WEMEET_BEACON_DEBUG_KEY;
    generateBeacon(isDebug, debugKey, prodKey, reportParams);
}
/**
 * 生成灯塔 sdk 实例并挂载在 window 上
 * @param isDebug
 * @param debugKey
 * @param prodKey
 * @param type
 * @param report
 */
function generateBeacon(isDebug, debugKey, prodKey, report) {
    if (report === void 0) { report = {}; }
    // 新通道实例
    var beaconNew = new BeaconAction({
        appkey: isDebug ? debugKey : prodKey,
        uploadUrl: isNormalEnv() ? PROD_REPORT_URL : TEST_REPORT_URL,
        needReportRqdEvent: false,
    });
    // 旧通道实例
    var beacon = new BeaconAction({
        appkey: isDebug ? debugKey : prodKey,
    });
    // 海外新通道
    var i18nBeaconNew = new BeaconAction({
        appkey: isDebug ? debugKey : prodKey,
        uploadUrl: isNormalEnv() ? PROD_I18N_REPORT_URL : PROD_I18N_REPORT_URL,
        needReportRqdEvent: false,
    });
    // 海外旧通道
    var i18nBeacon = new BeaconAction({
        appkey: isDebug ? debugKey : prodKey,
        uploadUrl: I18N_DATAHUB_REPORT_URL,
        needReportRqdEvent: false,
    });
    var commonOptions = {
        source_id: (report === null || report === void 0 ? void 0 : report.source_id) || '7',
        report_cmd: isNormalEnv() ? 'cmd_prod_old_atta' : 'cmd_test_new_atta',
        report_flag: (report === null || report === void 0 ? void 0 : report.report_flag) || '3',
        request_time: "".concat(new Date().getTime()),
        product: 'meeting',
    };
    // 新通道需要添加 common 参数
    beaconNew.addAdditionalParams(commonOptions);
    i18nBeaconNew.addAdditionalParams(commonOptions);
    // 获取 sdk 提供的 common 参数
    var commonInfo = getCommonInfo(beacon);
    beaconActionInsNew = beaconNew;
    beaconActionIns = beacon;
    beaconActionI18nInsNew = i18nBeaconNew;
    beaconActionI18nIns = i18nBeacon;
    wemeetBeaconReportCommonInfo = commonInfo;
}
/**
 * 开始上报
 * @param eventName
 * @param reportData
 */
function doBeaconReport(eventName, reportData, isI18n) {
    initBeaconSDK(reportData);
    if (isNewReport(eventName)) {
        if (isI18n) {
            beaconActionI18nInsNew === null || beaconActionI18nInsNew === void 0 ? void 0 : beaconActionI18nInsNew.onDirectUserAction(eventName, __assign(__assign({}, reportData), wemeetBeaconReportCommonInfo));
        }
        else {
            beaconActionInsNew === null || beaconActionInsNew === void 0 ? void 0 : beaconActionInsNew.onDirectUserAction(eventName, __assign(__assign({}, reportData), wemeetBeaconReportCommonInfo));
        }
    }
    else {
        if (isI18n) {
            beaconActionI18nIns === null || beaconActionI18nIns === void 0 ? void 0 : beaconActionI18nIns.onDirectUserAction(eventName, __assign({}, reportData));
        }
        else {
            beaconActionIns === null || beaconActionIns === void 0 ? void 0 : beaconActionIns.onDirectUserAction(eventName, __assign({}, reportData));
        }
    }
}

// 存储时长365天
var VALIDATE = 365;
var setreferrer = function () {
    if (isServer)
        return;
    try {
        var domain = document.referrer ? getDomain(document.referrer) : '';
        // 访问页面的完整URL-cookie
        if (getCookie('landing_url') === null)
            setCookie('landing_url', window.location.href, VALIDATE, '/');
        // 访问页面的路径，不含参数-cookie
        if (getCookie('landing_path') === null)
            setCookie('landing_path', "".concat(window.location.origin).concat(window.location.pathname), VALIDATE, '/');
        // 上级页面的完整URL-cookie
        if (getCookie('landing_referralurl') === null)
            setCookie('landing_referralurl', document.referrer, VALIDATE, '/');
        // 上级页面的域名-cookie
        if (getCookie('landing_referraldomain') === null)
            setCookie('landing_referraldomain', domain, VALIDATE, '/');
        // 上级页面的完整URL-session
        if (sessionStorage.getItem('landing_url_session') === null)
            sessionStorage.setItem('landing_url_session', window.location.href);
        // 上级页面的域名-session
        if (sessionStorage.getItem('landing_path_session') === null)
            sessionStorage.setItem('landing_path_session', "".concat(window.location.origin).concat(window.location.pathname));
        // 访问页面的路径，不含参数-session
        if (sessionStorage.getItem('landing_referralurl_session') === null)
            sessionStorage.setItem('landing_referralurl_session', document.referrer);
        // 上级页面的完整URL-session
        if (sessionStorage.getItem('landing_referraldomain_session') === null)
            sessionStorage.setItem('landing_referraldomain_session', domain);
    }
    catch (error) {
        console.log('setreferrer===>', error);
    }
};
var getDomain = function (url) {
    try {
        var domain = url.split('/');
        if (domain[2]) {
            return "".concat(domain[0], "//").concat(domain[2]);
        }
        return '';
    }
    catch (error) {
        return '';
    }
};

var getreferrer = function () {
    var landingReferralurl = getCookie('landing_referralurl') || '';
    var landingReferraldomain = getCookie('landing_referraldomain') || '';
    var landingUrl = getCookie('landing_url') || '';
    var landingPath = getCookie('landing_path') || '';
    var landingUrlSession = sessionStorage.getItem('landing_url_session') || '';
    var landingPathSession = sessionStorage.getItem('landing_path_session') || '';
    var landingReferralurlSession = sessionStorage.getItem('landing_referralurl_session') || '';
    var landingReferraldomainSession = sessionStorage.getItem('landing_referraldomain_session') || '';
    return {
        landingReferralurl: landingReferralurl,
        landingReferraldomain: landingReferraldomain,
        landingUrl: landingUrl,
        landingPath: landingPath,
        landingUrlSession: landingUrlSession,
        landingPathSession: landingPathSession,
        landingReferralurlSession: landingReferralurlSession,
        landingReferraldomainSession: landingReferraldomainSession,
    };
};

var ACCOUNT_TYPE_COMMON = 'account_type_common';
var AccountType;
(function (AccountType) {
    AccountType["unlogin"] = "unlogin";
    AccountType["unknown"] = "unknown";
})(AccountType || (AccountType = {}));
var getCorpTag = function () { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 2, , 3]);
                // 未登录情况下上报空串
                if (sessionStorage.getItem(ACCOUNT_TYPE_COMMON) === AccountType.unlogin) {
                    return [2 /*return*/, ''];
                }
                // 登录后并且接口返回值不为空
                if (sessionStorage.getItem(ACCOUNT_TYPE_COMMON)
                    && sessionStorage.getItem(ACCOUNT_TYPE_COMMON) !== AccountType.unknown) {
                    return [2 /*return*/, sessionStorage.getItem(ACCOUNT_TYPE_COMMON)];
                }
                // 接口返回值为空
                if (sessionStorage.getItem(ACCOUNT_TYPE_COMMON) === '') {
                    return [2 /*return*/, ''];
                }
                return [4 /*yield*/, corpCorpCorpPayTagTmpCache()];
            case 1:
                response = _e.sent();
                // 登录状态下取值
                if ((response === null || response === void 0 ? void 0 : response.code) === 0) {
                    sessionStorage.setItem(ACCOUNT_TYPE_COMMON, (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.account_tag) === null || _b === void 0 ? void 0 : _b.account_type);
                    return [2 /*return*/, (_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.account_tag) === null || _d === void 0 ? void 0 : _d.account_type];
                }
                // 未登录状态下取值
                if ((response === null || response === void 0 ? void 0 : response.code) === -20000) {
                    sessionStorage.setItem(ACCOUNT_TYPE_COMMON, AccountType.unlogin);
                    return [2 /*return*/, ''];
                }
                // 其他code码
                sessionStorage.setItem(ACCOUNT_TYPE_COMMON, AccountType.unknown);
                return [2 /*return*/, ''];
            case 2:
                _e.sent();
                sessionStorage.setItem(ACCOUNT_TYPE_COMMON, AccountType.unknown);
                return [2 /*return*/, ''];
            case 3: return [2 /*return*/];
        }
    });
}); };

// 获取 nav_platform
var getPlatForm = function () {
    var _a, _b, _c, _d;
    if ((_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator) === null || _b === void 0 ? void 0 : _b.platform) {
        return (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.navigator) === null || _d === void 0 ? void 0 : _d.platform;
    }
    return '';
};
// 获取 device_type tablet mobile pc
var getDeviceType = function () {
    if (isIpad() || isAndroidPad()) {
        return 'tablet';
    }
    if (isMobile()) {
        return 'mobile';
    }
    return 'pc';
};
// 获取 cookie 中的 web_uid
function getWebUid() {
    if (isServer) {
        return uuidv4();
    }
    var uuid = '';
    var locaUuid = getCookie('web_uid');
    if (locaUuid) {
        uuid = locaUuid;
    }
    else {
        uuid = uuidv4();
        setCookie('web_uid', uuid, 365 * 100, '/');
    }
    return uuid;
}
// 格式化 md5 字符串为 uuid 的格式
function formatMd5ToUuid(str) {
    var s = str;
    try {
        s = "".concat(str.slice(0, 8), "-").concat(str.slice(8, 12), "-").concat(str.slice(12, 16), "-").concat(str.slice(16, 20), "-").concat(str.slice(20));
    }
    catch (err) {
        console.log(err, 'formatMd5ToUuid, err');
    }
    return s;
}
// 获取网络类型 net_type
function getNetType() {
    var _a;
    return (_a = void 0 ) === null || _a === void 0 ? void 0 : _a.effectiveType;
}
/**
 * 获取全局公共参数
 * 不允许业务参数覆盖，数据分析所需基础字段
 * @param eventName 上报事件
 * @returns
 */
function getGlobalReportParams(eventName) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if (eventName === void 0) { eventName = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var reportObj, user, id, hardwareObj, browserInfo, actPageModule, landingData, _m, objStr;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    reportObj = {};
                    try {
                        // 获取用户登录信息
                        user = (_b = JSON.parse(((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.getItem('MC_USER_RESPONSE_SESSION')) || '{}')) === null || _b === void 0 ? void 0 : _b.data;
                    }
                    catch (err) {
                        user = {};
                    }
                    id = (user === null || user === void 0 ? void 0 : user.userid) || (user === null || user === void 0 ? void 0 : user.username);
                    hardwareObj = {
                        windows: 'Windows',
                        android: 'Android',
                        ios: 'IOS',
                        mac: 'Mac',
                        linux: 'Linux',
                        unknown: reportObj.nav_platform,
                    };
                    browserInfo = getBrowserInfo();
                    actPageModule = getActPageModule(eventName);
                    if (actPageModule) {
                        reportObj.act = actPageModule.act;
                        reportObj.page_name = actPageModule.page_name;
                        reportObj.element_name = actPageModule.element_name;
                    }
                    setreferrer();
                    landingData = getreferrer();
                    reportObj.source_id = '7';
                    reportObj.userid = id || '';
                    reportObj.device_type = getDeviceType();
                    reportObj.user_agent = (_d = (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.navigator) === null || _d === void 0 ? void 0 : _d.userAgent;
                    reportObj.uid = getCookie('app_uid') || getRequest('app_uid') || (user === null || user === void 0 ? void 0 : user.userid) || reportObj.userid || '';
                    reportObj.corp_id = getCookie('app_id') || getRequest('app_id') || (user === null || user === void 0 ? void 0 : user.app_id) || '';
                    reportObj.corp_type = (user === null || user === void 0 ? void 0 : user.corp_type) || '';
                    reportObj.corp_name = (user === null || user === void 0 ? void 0 : user.corp_name) || '';
                    reportObj.nick_name = (user === null || user === void 0 ? void 0 : user.nickName) || (user === null || user === void 0 ? void 0 : user.username) || '';
                    reportObj.is_overseas = 'no';
                    reportObj.nav_platform = getPlatForm();
                    reportObj.unique_report_id = uuidv4();
                    reportObj.hardware_os = getOsName() === 'unknown' ? reportObj.nav_platform : hardwareObj[getOsName()];
                    reportObj.web_uid = getWebUid() || '';
                    reportObj.prev_url = document.referrer;
                    reportObj.current_url = (_f = (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.location) === null || _f === void 0 ? void 0 : _f.href;
                    reportObj.current_path = "".concat((_h = (_g = getWindow()) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.origin).concat((_k = (_j = getWindow()) === null || _j === void 0 ? void 0 : _j.location) === null || _k === void 0 ? void 0 : _k.pathname);
                    reportObj.explore_name = browserInfo.type;
                    reportObj.explore_version = browserInfo.versions;
                    reportObj.from_source = getRequest('fromSource') || '';
                    reportObj.net_type = getNetType() || '';
                    reportObj.event_time = "".concat(new Date().getTime());
                    reportObj.event_code = eventName;
                    // 新增加8个参数，4个getCookie，4个getSession
                    reportObj.landing_referralurl = (landingData === null || landingData === void 0 ? void 0 : landingData.landingReferralurl) || '';
                    reportObj.landing_referraldomain = (landingData === null || landingData === void 0 ? void 0 : landingData.landingReferraldomain) || '';
                    reportObj.landing_url = (landingData === null || landingData === void 0 ? void 0 : landingData.landingUrl) || '';
                    reportObj.landing_path = (landingData === null || landingData === void 0 ? void 0 : landingData.landingPath) || '';
                    reportObj.landing_url_session = (landingData === null || landingData === void 0 ? void 0 : landingData.landingUrlSession) || '';
                    reportObj.landing_path_session = (landingData === null || landingData === void 0 ? void 0 : landingData.landingPathSession) || '';
                    reportObj.landing_referralurl_session = (landingData === null || landingData === void 0 ? void 0 : landingData.landingReferralurlSession) || '';
                    reportObj.landing_referraldomain_session = (landingData === null || landingData === void 0 ? void 0 : landingData.landingReferraldomainSession) || '';
                    _m = reportObj;
                    return [4 /*yield*/, getCorpTag()];
                case 1:
                    _m.current_account_type = _o.sent();
                    objStr = JSON.stringify(__assign({}, reportObj));
                    // 上报id，唯一
                    reportObj.unique_report_id = formatMd5ToUuid(md5(objStr));
                    if (!(reportObj === null || reportObj === void 0 ? void 0 : reportObj.unique_report_id) || ((_l = reportObj === null || reportObj === void 0 ? void 0 : reportObj.unique_report_id) === null || _l === void 0 ? void 0 : _l.length) !== 36) {
                        reportObj.unique_report_id = uuidv4();
                    }
                    return [2 /*return*/, __assign({}, reportObj)];
            }
        });
    });
}

/**
 * 全局可选公参
 * 优先级：业务参数 > 默认取值逻辑 > 空值
 * @param options 用户上报参数
 * @returns
 */
function getOptionalReportParams(options) {
    if (options === void 0) { options = {}; }
    var reportObj = options || {};
    reportObj.multi_from = reportObj.multi_from || getCookie('multifrom') || '';
    reportObj.experiment_id = reportObj.experiment_id || '';
    reportObj.experiment_group_id = reportObj.experiment_group_id || '';
    reportObj.mid = reportObj.mid || getRequest('mid') || '';
    return __assign({}, reportObj);
}

var IS_I18N = process.env.IS_I18N;

/**
 * 会议新版上报链路
 * 1、旧灯塔事件：业务上报字段+（全局公参+可选公参），业务参数可覆盖
 *    上报通道：灯塔sdk
 * 2、新上报事件(e#web#xxx格式)：全局公参+可选公参+业务上报
 *    上报通道：基于灯塔sdk>4.5.x版本，自定义reportUrl上报至会议数据平台，再转发tdbank存储，可灯塔分析
 * @param eventName 上报事件
 * @param userParams 业务上报参数
 */
function wemeetBeaconReport(eventName, userParams) {
    if (userParams === void 0) { userParams = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var reportParams, userMergedParams, globalReportParams, optionalReportParams, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!(typeof window !== 'undefined')) return [3 /*break*/, 2];
                    reportParams = {};
                    userMergedParams = mergeBaseReport(userParams);
                    return [4 /*yield*/, getGlobalReportParams(eventName)];
                case 1:
                    globalReportParams = _a.sent();
                    optionalReportParams = getOptionalReportParams(userParams);
                    if (isNewReport(eventName)) {
                        // 新事件上报，优先级：全局公参 > 可选全局公参 > 业务参数
                        reportParams = __assign(__assign(__assign({ isI18n: IS_I18N }, userMergedParams), optionalReportParams), globalReportParams);
                    }
                    else {
                        // 旧事件上报，优先级：业务参数 > 可选全局公参 > 全局公参
                        reportParams = __assign(__assign(__assign({ isI18n: IS_I18N }, globalReportParams), optionalReportParams), userMergedParams);
                    }
                    doBeaconReport(eventName, reportParams, userParams.isI18n);
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    console.log('wemeetBeaconReport err', err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}

function loadTencentCaptcha() {
    return new Promise(function (resolve, reject) {
        if (window.TencentCaptcha) {
            resolve(window.TencentCaptcha);
        }
        else {
            var script = document.createElement('script');
            if (process.env.IS_I18N) {
                script.src = 'https://global.captcha.gtimg.com/TCaptcha-global.js';
            }
            else {
                script.src = 'https://ssl.captcha.qq.com/TCaptcha.js';
            }
            script.onload = function () {
                resolve(window.TencentCaptcha);
            };
            script.onerror = reject;
            document.body.appendChild(script);
        }
    });
}
/**
 * 创建防水墙
 * @param appid {string} 应用id
 * @param options {TencentCaptchaOptions} 配置项
 * @return {Promise<CaptchaState>}
 * @example
 * ```ts
 *    createTencentCaptcha().then(sendRequest);
 * ```
 */
function createTencentCaptcha(appid, options) {
    if (appid === void 0) { appid = process.env.IS_I18N ? ConstantEnum.VOOV_CAPTCHA_APP_ID : ConstantEnum.CAPTCHA_APP_ID; }
    if (options === void 0) { options = {}; }
    return new Promise(function (resolve) {
        loadTencentCaptcha()
            .then(function (tencentCaptcha) {
            if (tencentCaptcha) {
                var captcha = new window.TencentCaptcha(appid, function (captchaRes) {
                    if (captchaRes.ticket && captchaRes.randstr) {
                        resolve(captchaRes);
                    }
                    else {
                        resolve(null);
                    }
                }, __assign({ enableAged: true }, options));
                captcha.show();
            }
            else {
                console.error('TencentCaptcha is not defined');
                resolve(null);
            }
        })
            .catch(function () {
            console.error('TencentCaptcha is not defined');
            resolve(null);
        });
    });
}

/* eslint-disable camelcase,@typescript-eslint/naming-convention */
/**
 * 安全校验接口响应code
 */
var SafeServiceCode;
(function (SafeServiceCode) {
    /**
     * 业务正常响应
     */
    SafeServiceCode[SafeServiceCode["SUCCESS"] = 0] = "SUCCESS";
    /**
     * 安全参数缺失或不合规
     */
    SafeServiceCode[SafeServiceCode["PARAMS_ERROR"] = 102021] = "PARAMS_ERROR";
    /**
     * 安全服务错误
     */
    SafeServiceCode[SafeServiceCode["SERVICE_ERROR"] = 102022] = "SERVICE_ERROR";
    /**
     * 请求需要安全认证, 正常业务逻辑，查询后需要做进一步认证
     */
    SafeServiceCode[SafeServiceCode["NEED_VERIFY"] = 102023] = "NEED_VERIFY";
    /**
     * 安全认证服务错误
     */
    SafeServiceCode[SafeServiceCode["VERIFY_ERROR"] = 102024] = "VERIFY_ERROR";
    /**
     * 请求被阻止执行此功能, 正常业务逻辑，标识进一步认证不通过
     */
    SafeServiceCode[SafeServiceCode["VERIFY_FAILED"] = 102025] = "VERIFY_FAILED";
})(SafeServiceCode || (SafeServiceCode = {}));
/**
 * 后台数据上报
 * @param params
 */
function getWebReportData(params) {
    if (params === void 0) { params = {}; }
    var WebVersion = '';
    var NetworkType = '';
    var ClientIP = '';
    if (!isServer && window.navigator) {
        // @ts-ignore
        var _a = window.navigator, userAgent = _a.userAgent, connection = _a.connection;
        if (userAgent) {
            WebVersion = Decoder.encoding(userAgent);
        }
        if (connection) {
            // @ts-ignore
            NetworkType = connection.effectiveType || '';
        }
        try {
            var base64Ip = window.sessionStorage.getItem('ip');
            if (base64Ip) {
                ClientIP = atou(base64Ip);
            }
        }
        catch (e) {
            // ignore
        }
    }
    return {
        ActionTime: Math.ceil(new Date().getTime() / 1000),
        OperID: params.OperID || 'send_sms',
        InstanceId: 5,
        ClientIP: ClientIP,
        WebVersion: WebVersion,
        NetworkType: NetworkType,
    };
}
var Decoder = /** @class */ (function () {
    function Decoder() {
    }
    /**
     * 第一次请求
     * @param params {Object} 原接口请求数据
     * @param metadata {Object} 自定义数据
     */
    Decoder.getPrevSafeData = function (params, metadata) {
        if (metadata === void 0) { metadata = {}; }
        var meeting_id = params.meeting_id, binary_meeting_type = params.binary_meeting_type;
        return {
            meeting_id: meeting_id,
            binary_meeting_type: binary_meeting_type,
            metadata: Object.assign({}, getWebReportData(params), metadata),
        };
    };
    /**
     * 第二次请求
     * @param prevBody {object} 第一次的body
     * @param safeInfo {SafeInfoVM} CGI签名
     * @param validate {string} web端校验票据
     */
    Decoder.getNextSafeData = function (prevBody, safeInfo, validate) {
        if (validate === void 0) { validate = ''; }
        return Object.assign({}, prevBody, {
            safe_credentials: safeInfo.safe_credentials,
            validate_type: safeInfo.validate_type,
            validate_json: validate,
        });
    };
    /**
     * 合并请求参数，添加`Safe-Validate-Key`字段
     * @param requestBody
     * @param safeData
     */
    Decoder.mergeSafeKey = function (requestBody, safeData) {
        return Object.assign({}, requestBody, {
            safe_validate_key: Decoder.encoding(safeData),
        });
    };
    /**
     * base64编码数据
     * @param body {Object}
     */
    Decoder.encoding = function (body) {
        if (isString(body)) {
            return utoa(body);
        }
        return utoa(JSON.stringify(body));
    };
    /**
     * base64解码数据
     * @param body {string}
     */
    Decoder.decoding = function (body) {
        try {
            return JSON.parse(atou(body));
        }
        catch (e) {
            return {};
        }
    };
    return Decoder;
}());
/**
 * 给接口加上安全验证
 * @param requestFn {RequestFn} cgi请求函数
 * @param appid {string} 2099486352 防水墙appid
 * @doc http://cowork.yapi.oa.com/project/326/interface/api/23468
 * @return {WithCaptchaFn}
 *   第一个参数 params，
 *   第二个参数 { meeting_id, binary_meeting_type }
 */
function withCaptcha(requestFn, appid) {
    if (appid === void 0) { appid = ConstantEnum.CAPTCHA_APP_ID; }
    return function safeRequest(params, meetingInfo) {
        if (meetingInfo === void 0) { meetingInfo = {}; }
        return new Promise(function (resolve, reject) {
            var prevSafe = Decoder.getPrevSafeData(meetingInfo);
            var prevBody = Decoder.mergeSafeKey(params, prevSafe);
            requestFn(prevBody)
                .then(function (resp) {
                if (resp && isObject(resp)) {
                    var _a = resp, code = _a.code, data = _a.data;
                    if (code === SafeServiceCode.SUCCESS) {
                        resolve(resp);
                    }
                    else if (code === SafeServiceCode.NEED_VERIFY) {
                        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
                        if (data && data.safe_info) {
                            startVerify(requestFn, params, prevSafe, data.safe_info, appid).then(resolve)
                                .catch(reject);
                        }
                        else {
                            reject(resp);
                        }
                    }
                    else {
                        var errorResponse = handleVerifyError(resp);
                        reject(errorResponse);
                    }
                }
                else {
                    resolve(resp);
                }
            })
                .catch(function (err) {
                console.error('safeRequest', err);
                reject(err);
            });
        });
    };
}
/**
 * 安全校验，成功resolve，失败reject
 * @param request
 * @param params
 * @param prevSafe
 * @param safeRes
 * @param appid
 */
function startVerify(request, params, prevSafe, safeRes, appid) {
    if (appid === void 0) { appid = ConstantEnum.CAPTCHA_APP_ID; }
    return new Promise(function (resolve, reject) {
        createTencentCaptcha(appid)
            .then(function (captchaRes) {
            if (captchaRes) {
                var safeInfo = SafeInfoVM.parseResponse(safeRes);
                var nextSafe = Decoder.getNextSafeData(prevSafe, safeInfo, JSON.stringify(captchaRes));
                var nextBody = Decoder.mergeSafeKey(params, nextSafe);
                request(nextBody)
                    .then(function (resp) {
                    resolve(resp);
                })
                    .catch(reject);
            }
            else {
                reject({
                    message: '取消验证',
                });
            }
        })
            .catch(reject);
    });
}
function mergeErrorMsg(message, resp) {
    return Object.assign({}, resp, { message: message });
}
/**
 * 处理安全校验失败
 * @param resp
 */
function handleVerifyError(resp) {
    var code = resp.code;
    switch (code) {
        case SafeServiceCode.PARAMS_ERROR:
            return mergeErrorMsg('安全参数缺失或不合规', resp);
        case SafeServiceCode.SERVICE_ERROR:
            return mergeErrorMsg('安全认证服务查询功能异常', resp);
        case SafeServiceCode.NEED_VERIFY:
            return mergeErrorMsg('需要安全认证', resp);
        case SafeServiceCode.VERIFY_ERROR:
            return mergeErrorMsg('安全认证服务校验功能异常', resp);
        case SafeServiceCode.VERIFY_FAILED:
            return mergeErrorMsg('安全认证失败', resp);
    }
    return resp;
}
/**
 * 安全凭证
 */
var SafeInfoVM = /** @class */ (function () {
    function SafeInfoVM(info) {
        if (info === void 0) { info = {}; }
        this.tips = info.tips || '';
        this.validate_type = info.validate_type || '';
        this.safe_credentials = info.safe_credentials || '';
    }
    SafeInfoVM.parseResponse = function (safe) {
        return new SafeInfoVM(Decoder.decoding(safe));
    };
    return SafeInfoVM;
}());

/**
 * 获取axios
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 * @returns Promise<AxiosStatic>
 */
function getAxios() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (getWindow().axios) {
                        return [2 /*return*/, getWindow().axios];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadScript('https://cdn.meeting.tencent.com/assets/axios/axios.v0.23.0.min.js')];
                case 2:
                    _b.sent();
                    return [2 /*return*/, getWindow().axios];
                case 3:
                    _b.sent();
                    console.error('load axios script err');
                    return [2 /*return*/, {}];
                case 4: return [2 /*return*/];
            }
        });
    });
}

/**
 * 接口前缀根据运行环境发生变化
 * @param apiUrl 请求接口路径
 * @param prefix 接口前缀
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 */
function getPrefixUrl(apiUrl, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var url = apiUrl;
    var pf = prefix;
    var regURL = /^(https|http):\/\//;
    if (!regURL.test(url)) {
        if (!pf) {
            pf = '/wemeet-webapi';
        }
        if (pf === '/wemeet-webapi') {
            if (getRequest('debug') !== 'product') {
                // add debug=product& 用于在本地调正式环境
                if (isTestEnv()) {
                    pf += '-test';
                }
                else if (isLocalEnv()) {
                    if (getRequest('debug') === 'pre-release') {
                        // add debug=pre-release& 用于在本地调预发布环境
                        pf += '-pre-release';
                    }
                    else {
                        pf += '-test';
                    }
                }
                else if (isPreReleaseEnv()) {
                    pf += '-pre-release';
                }
            }
        }
        if (url[0] === '/') {
            url = pf + url;
        }
        else {
            url = "".concat(pf, "/").concat(url);
        }
    }
    return url;
}

/**
 * 请求路径拼接
 * @param apiUrl 请求接口地址
 * @param query
 * @param prefix 接口请求路径前缀
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 */
function getMergedUrl(apiUrl, query, prefix) {
    if (query === void 0) { query = {}; }
    if (prefix === void 0) { prefix = ''; }
    return addURLSearch(getPrefixUrl(apiUrl, prefix), __assign({ c_os: 'web', c_os_version: 1, c_os_model: 'web', c_timestamp: +new Date(), c_instance_id: 5, c_nonce: randomString(8), c_app_id: '1400143280', c_app_version: 1, c_lang: 'zh-cn', c_district: 0 }, query));
}

/**
 * http-notice.service
 *  web-base
 * @author michaelbguo@tencent.com
 * @time 2021/3/15 17:27
 * @version
 */
/**
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 */
var HttpNoticeService = /** @class */ (function () {
    function HttpNoticeService() {
        this.noticeQueue = [];
        this.noticeDivId = 'web-base-http-notice';
        this.noticeQueue = [];
    }
    HttpNoticeService.createDivContent = function (span, top) {
        if (top === void 0) { top = 70; }
        var div = createElement('div', {
            style: "position:fixed; width:100%; left:0; top:".concat(top, "px; text-align:center; z-index:9999;"),
        });
        div.appendChild(span);
        return div;
    };
    HttpNoticeService.initToastSpan = function (msg) {
        var span = createElement('span', {
            style: 'background: #444;padding: 14px 15px;border-radius: 4px;',
        });
        var text = createElement('span', {
            style: 'font-family: PingFangSC-Regular, Microsoft YaHei; font-size: 12px; color: #fff; text-align: center',
        });
        text.innerText = msg;
        span.appendChild(text);
        return span;
    };
    HttpNoticeService.prototype.error = function (msg, timer) {
        var _this = this;
        if (timer === void 0) { timer = 2000; }
        var span = HttpNoticeService.initToastSpan(msg);
        var div = HttpNoticeService.createDivContent(span, (this.noticeQueue.length + 1) * 70);
        this.noticeQueue.push(div);
        this.getNoticeElement().appendChild(div);
        window.setTimeout(function (arg) {
            _this.getNoticeElement().removeChild(arg);
            _this.noticeQueue.shift();
        }, timer, div);
    };
    HttpNoticeService.prototype.getNoticeElement = function () {
        var target = document.getElementById(this.noticeDivId);
        if (target) {
            return target;
        }
        var div = createElement('div', { id: this.noticeDivId });
        document.body.appendChild(div);
        return div;
    };
    return HttpNoticeService;
}());

// TODO 接tam上报
var logger$2 = loggerUtil === null || loggerUtil === void 0 ? void 0 : loggerUtil.use(undefined, 'http');
/**
 * 腾讯会议前端项目的Axios接口交互基类
 * @version 0.0.10
 * @example
 * ```
 * // 项目内的response处理
 * const responseHandle = (req, res, url) => {
 *   if (!res.data) {
 *     console.warn('response no data');
 *   }
 * }
 *
 * const requestErrorHandle = (err, url) => {
 *   monitorIns.log({
 *     level: 3,
 *     log: JSON.stringify({
 *       title: 'http error',
 *       api: url,
 *     }),
 *   })
 * }
 *
 * const meetingLiveHttpService =
 * new BaseHttpService({responseHandle: responseHandle, requestErrorHandle: requestErrorHandle});
 *
 * // 带数据类型 UserInfoVM
 * const refreshToken = (refreshTokenType: number = 0) => {
 *   return meetingLiveHttpService.post<UserInfoVM>('/v2/account/login/refresh-token',
 *   {refresh_token: refreshTokenType,})
 * }
 *
 * ```
 * @deprecated 0.6.0之后的版本使用`src/http`代替(兼容next.js)
 */
var BaseHttpService = /** @class */ (function () {
    function BaseHttpService(options) {
        this.options = options;
        this.httpNotice = new HttpNoticeService();
    }
    /**
     * 处理http请求错误
     * @param err
     * @param url
     * @private
     */
    BaseHttpService.handleHttpError = function (err, url) {
        var response = err.response || {};
        logger$2.error({
            title: 'http error.',
            api: url,
            status: response.status,
            statusText: response.statusText,
            code: err.code || null,
            msg: err.message,
        });
    };
    /**
     * 处理后台接口状态码错误
     * @param request
     * @param response
     * @param url
     * @private
     */
    BaseHttpService.handleResCodeError = function (request, response, url) {
        if (response.data && response.data.code !== 0) {
            if (/\/service\/create-launch-id/i.test(url) || /\/service\/query-launch-id/i.test(url)) {
                return false;
            }
            var obj = {
                api: url,
                req: request,
                res: response.data,
            };
            logger$2.error(__assign(__assign({}, obj), { title: 'res.code is not 0.' }));
        }
    };
    /**
     * get 请求
     * @param option 请求传入的参数对象
     *
     */
    BaseHttpService.prototype.get = function (option) {
        var _this = this;
        if (option === void 0) { option = { url: '', timeout: 60000 }; }
        var options = Object.assign({ prefix: '/wemeet-webapi' }, option);
        options.url = getMergedUrl(options.url, {}, options.prefix);
        return getAxios()
            .then(function (axios) { return axios.get(options.url, {
            params: options.data,
            headers: options.headers,
            cancelToken: options.cancelToken,
            timeout: options.timeout,
            onDownloadProgress: function (progressEvent) {
                if (isFunction(options.onDownloadProgress)) {
                    options.onDownloadProgress(progressEvent);
                }
            },
        }); })
            .then(function (res) {
            var _a;
            if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.responseHandle) {
                _this.options.responseHandle(options.data, res, options.url);
            }
            else {
                BaseHttpService.handleResCodeError(options.data, res, options.url);
            }
            return res.data;
        })
            .catch(function (err) {
            var _a;
            if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.requestErrorHandle) {
                _this.options.requestErrorHandle(err, options.url);
            }
            else {
                BaseHttpService.handleHttpError(err, options.url);
            }
        });
    };
    /**
     * post请求
     * @param option
     */
    BaseHttpService.prototype.post = function (option) {
        var _this = this;
        if (option === void 0) { option = { url: '', timeout: 60000 }; }
        var options = Object.assign({ prefix: '/wemeet-webapi' }, option); // prefix可传入
        options.url = getMergedUrl(options.url, {}, options.prefix);
        return getAxios()
            .then(function (axios) { return axios.post(options.url, options.data, {
            headers: options.headers,
            cancelToken: options.cancelToken,
            timeout: options.timeout,
            onUploadProgress: function (progressEvent) {
                if (isFunction(options.onUploadProgress)) {
                    options.onUploadProgress(progressEvent);
                }
            },
        }); })
            .then(function (res) {
            var _a;
            if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.responseHandle) {
                _this.options.responseHandle(options.data, res, options.url);
            }
            else {
                BaseHttpService.handleResCodeError(options.data, res, options.url);
            }
            return res.data;
        })
            .catch(function (err) {
            var _a;
            if ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.requestErrorHandle) {
                _this.options.requestErrorHandle(err, options.url);
            }
            else {
                BaseHttpService.handleHttpError(err, options.url);
            }
        });
    };
    return BaseHttpService;
}());

/**
 * http对象
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 */
var http$1 = new BaseHttpService();

/**
 * 来源ID，用于数据上报，默认为0，来自官网本身
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 */
function getLoginSourceId() {
    var pq = new URL(window.location.href).searchParams;
    return pq.get('m_login_source_id') || '0';
}
/**
 * 是否是详情页切换帐号
 * @deprecated 旧版本http封装, 使用`/src/http`模块代替
 */
function isDetailedChangeAccount() {
    var pq = new URL(window.location.href).searchParams;
    if (Number(pq.get('m_login_source_id')) === 2) {
        var rl = pq.get('redirect_link');
        if (!rl) {
            return false;
        }
        var loginType = getRequest('login_type', decodeURIComponent(rl));
        if (Number(loginType) === 1) {
            return true;
        }
    }
    return false;
}

/**
 * 用户信息接口服务
 * ```TypeScript
 * // 集成到项目中使用单例
 * 	const userService = new UserService();
 * 	export default userService;
 *
 * 	let user = userService.getUserInfos();
 *  user = userService.updateUserInfos({ username: "赵四" });
 *  // 登录
 *  userService.loginByPassword({area, phone, password}).then(resp => {});
 * ```
 * @deprecated 已废弃, 请求不放在web-base内部
 */
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService() {
        var _this = _super.call(this) || this;
        _this.currentUser = new BaseUserInfo();
        _this.init();
        return _this;
    }
    UserService.prototype.loginByToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.refreshToken(0)];
            });
        });
    };
    UserService.prototype.getUserInfos = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.refreshToken()];
                    case 1:
                        response = _a.sent();
                        if (response.data) {
                            this.updateUserInfos(response.data);
                        }
                        return [2 /*return*/, this.currentUser];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this.currentUser];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 退出登录
     * @param onSuccess
     * @param onError
     */
    UserService.prototype.accountLogout = function (onSuccess, onError) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.get({
                        url: 'v2/account/logout',
                    })
                        .then(function (resp) {
                        if (resp.code === 0 && resp.data) {
                            try {
                                sessionStorage.clear();
                            }
                            catch (e) { }
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(resp);
                        }
                        else {
                            _this.httpNotice.error(resp.message);
                            onError === null || onError === void 0 ? void 0 : onError(resp);
                        }
                    })
                        .catch(function (err) {
                        onError === null || onError === void 0 ? void 0 : onError(err);
                    })];
            });
        });
    };
    UserService.prototype.updateUserInfos = function (userInfo) {
        var rootState = StorageService.setState('userInfos', userInfo);
        this.currentUser = rootState.userInfos;
        return this.currentUser;
    };
    UserService.prototype.init = function () {
        var user = StorageService.getState('userInfos');
        this.currentUser = new BaseUserInfo(user);
    };
    UserService.prototype.refreshToken = function (type) {
        if (type === void 0) { type = 0; }
        return this.post({
            url: 'v2/account/login/refresh-token',
            data: {
                refresh_token: type,
            },
        });
    };
    return UserService;
}(BaseHttpService));

/**
 * window.WeixinJSBridge存在
 * {@link WeixinJSBridgeObject}
 */
function hasWeiXinJSBridge() {
    return typeof window.WeixinJSBridge !== 'undefined';
}

/**
 * 获取 window.WeixinJSBridge
 */
function getWeiXinJSBridge() {
    return new Promise(function (resolve, reject) {
        document.addEventListener('WeixinJSBridgeReady', function () {
            resolve(getWindow().WeixinJSBridge);
        });
        if (hasWeiXinJSBridge()) {
            resolve(getWindow().WeixinJSBridge);
        }
        else {
            reject();
        }
    });
}

function isWeiXinMicroMessengerLt(version) {
    var userAgent = window.navigator.userAgent;
    var pattern = /MicroMessenger\/([\d.]+)/i;
    var microMessengerInfo = userAgent.match(pattern);
    var isWeiXin = /MicroMessenger/i.test(userAgent);
    return (isWeiXin
        && !userAgent.includes('wxwork')
        && microMessengerInfo
        && microMessengerInfo.length >= 2
        && compareVersion(microMessengerInfo[1], version) < 0);
}

function isWeiXinQBCoreLt(QBCoreVer) {
    var userAgent = window.navigator.userAgent;
    var qBCoreInfo = userAgent.match(/QBCore\/([\d.]+)/i);
    var isWeiXin = /MicroMessenger/i.test(userAgent);
    return (isWeiXin
        && !userAgent.includes('wxwork')
        && qBCoreInfo
        && qBCoreInfo.length >= 2
        && compareVersion(qBCoreInfo[1], QBCoreVer) < 0);
}

/**
 * 分割数字或字符串
 * @param {*} val
 * @param {*} n
 * @param {*} format
 * eg: divideNum(123456789, 4, ',')
 */
function divideNum(val, n1, n2, format) {
    if (n1 === void 0) { n1 = 3; }
    if (n2 === void 0) { n2 = 4; }
    if (format === void 0) { format = ' '; }
    var tmp = String(val);
    var res = '';
    var valLength = tmp.length;
    var sliceNum = !(tmp.length % n2) && valLength > 9 ? n2 : n1;
    while (tmp.length > sliceNum) {
        res = res + tmp.slice(0, sliceNum) + format;
        tmp = tmp.slice(sliceNum);
        sliceNum = !(tmp.length % n2) && valLength > 9 ? n2 : n1;
    }
    if (tmp) {
        res += tmp;
    }
    return res;
}

/**
 * 金钱格式化 3位加逗号
 *  @param { number } num
 */
function formatMoney(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 万分位转换
 * @param number number
 * return string | number
 */
function numberToWan(number) {
    var num = Number(number) || 0;
    if (Number.isNaN(num)) {
        return 0;
    }
    if (num > 9999) {
        return "".concat((num / 10000).toFixed(1), "\u4E07");
    }
    return num;
}

/**
 * @param { number } val 输入的数字
 * @param { number } maxNum 数字规定界限
 * demo 100 -> 99+
 */
var outOfNum = function (val, maxNum) {
    if (val > maxNum) {
        return "".concat(maxNum, "+");
    }
    return val;
};

/**
 * 十位0补充
 * @param number number
 * demo 2 -> 02
 * return string | number
 */
function tenSupplements(number) {
    var num = Number(number) || 0;
    if (Number.isNaN(num)) {
        return 0;
    }
    if (num >= 10 || num <= -10) {
        return num;
    }
    return num >= 0 ? "0".concat(num) : "-0".concat(Math.abs(num));
}

var numbers = /*#__PURE__*/Object.freeze({
    __proto__: null,
    divideNum: divideNum,
    formatMoney: formatMoney,
    numberToWan: numberToWan,
    outOfNum: outOfNum,
    tenSupplements: tenSupplements
});

/**
 * 获取特定格式的会议号
 * @param value {string | number} meetingCode 会议号
 * @param langPrefix {Language} 语言或前缀，默认为`#腾讯会议：`
 * @param mask {boolean} 是否打码，默认为`false`
 * @param appName {string} 应用名称; 除腾讯会议客户端场景，还有SDK场景(其应用名称不叫腾讯会议)
 */
function getCopiedMeetingCode(value, langPrefix, mask, appName) {
    if (langPrefix === void 0) { langPrefix = 'zh-cn'; }
    if (mask === void 0) { mask = false; }
    if (appName === void 0) { appName = ''; }
    var meetingCode = mask ? maskMeetingCode(value) : value;
    if (langPrefix === 'zh-cn') {
        return "#".concat(appName || '腾讯会议', "\uFF1A").concat(divideNum(meetingCode, 3, 4, '-'));
    }
    if (langPrefix === 'en') {
        return "#".concat(appName || 'TencentMeeting', ": ").concat(divideNum(meetingCode, 3, 4, '-'));
    }
    return "".concat(langPrefix, " ").concat(divideNum(meetingCode, 3, 4, '-'));
}
/**
 * 会议号格式化
 * @param value {string | number} 会议号
 * @param mask 是否打码，默认为`false`
 */
function formatMeetingCode(value, mask) {
    if (mask === void 0) { mask = false; }
    return mask ? divideNum(maskMeetingCode(value)) : divideNum(value);
}
/**
 * 会议号打码（不包含分隔符）
 * 9位会议号：12* *** *89
 * 10位会议号：12* *** *789
 * 11位会议号：12* **** *890
 * 12位会议号：123* **** *890
 * @param value {string | number} 会议号
 */
function maskMeetingCode(value) {
    var str = String(value);
    var startKeepLength = 2;
    var endKeepLength = 2;
    switch (str.length) {
        case 9:
            startKeepLength = 2;
            endKeepLength = 2;
            break;
        case 10:
            startKeepLength = 2;
            endKeepLength = 3;
            break;
        case 11:
            startKeepLength = 2;
            endKeepLength = 3;
            break;
        case 12:
            startKeepLength = 3;
            endKeepLength = 3;
            break;
    }
    var startKeep = str.substring(0, startKeepLength);
    var endKeep = str.substring(str.length - endKeepLength);
    return startKeep + endKeep.padStart(str.length - startKeepLength, '*');
}

var MaskMeetingCode = 0x01;
/**
 * 是否需要隐藏会议号
 * @param maskFlag 后台返回的 meeting_extra_config_mask_flag
 */
function isMaskMeetingCode(maskFlag) {
    return (maskFlag & MaskMeetingCode) === MaskMeetingCode;
}

var MaskMeetingLink = 0x02;
/**
 * 是否需要隐藏会议链接
 * @param maskFlag 后台返回的 meeting_extra_config_mask_flag
 */
function isMaskMeetingLink(maskFlag) {
    return (maskFlag & MaskMeetingLink) === MaskMeetingLink;
}

var FROM_INFO_SESSION_KEY = 'web_tools_from_session_key';
var getFromInfoFromSession = function () {
    var searchParamsObject;
    var session;
    try {
        session = sessionStorage.getItem(FROM_INFO_SESSION_KEY);
    }
    catch (e) { }
    if (typeof session === 'string') {
        try {
            searchParamsObject = JSON.parse(session);
        }
        catch (e) {
            e = null;
        }
    }
    return searchParamsObject;
};
function getPageFromQuery() {
    var url = new URL(window.location.href);
    var _a = url.origin.split('://'), website = _a[1];
    var from = {
        from_origin: website,
        from_pathname: url.pathname,
        from_fromSource: url.searchParams.get('fromSource') || url.searchParams.get('from_fromSource') || '',
    };
    if (!from.from_fromSource) {
        var session = getFromInfoFromSession();
        if (session) {
            from.from_fromSource = session.from_fromSource;
        }
    }
    return from;
}

/**
 * 合并URL
 * @param path
 * @param query
 */
function mergePathQuery(path, query) {
    var res = path;
    if (!path.startsWith('http')) {
        var url = new URL(window.location.href);
        if (path.startsWith('/')) {
            res = "".concat(url.origin).concat(path);
        }
        else {
            res = "".concat(url.origin, "/").concat(path);
        }
    }
    if (query && typeof query === 'object') {
        var searchParams = new URLSearchParams(query);
        searchParams.forEach(function (value, key) {
            if (res.includes('?')) {
                res += "&".concat(key, "=").concat(encodeURIComponent(value));
            }
            else {
                res += "?".concat(key, "=").concat(encodeURIComponent(value));
            }
        });
    }
    return res;
}

/**
 * 导航路由工具,携带from信息到下一个页面
 */
var navigation = {
    /**
     * 替换页面，携带来源数据
     * @param path {string}
     * @param query {object | undefined}
     * @param beforeFunction { Promise<void> | undefined}
     */
    push: function (path, query, beforeFunction) {
        if (query === void 0) { query = undefined; }
        var from = getPageFromQuery();
        try {
            sessionStorage.setItem(FROM_INFO_SESSION_KEY, JSON.stringify(from));
        }
        catch (e) { }
        var href = mergePathQuery(path, query);
        if (beforeFunction) {
            Promise.resolve(beforeFunction).then(function () {
                window.location.href = href;
            });
        }
        else {
            window.location.href = href;
        }
    },
    /**
     * 打开新tab页面，携带来源数据
     * @param path {string}
     * @param query {object | undefined}
     * @param beforeFunction {Promise<void> | undefined}
     */
    openPage: function (path, query, beforeFunction) {
        if (query === void 0) { query = undefined; }
        var from = getPageFromQuery();
        try {
            sessionStorage.setItem(FROM_INFO_SESSION_KEY, JSON.stringify(from));
        }
        catch (e) { }
        var target = {};
        if (from.from_fromSource) {
            target.fromSource = from.from_fromSource;
        }
        var href = mergePathQuery(path, Object.assign(target, query));
        try {
            var host = new URL(href).host;
            if (host !== location.host) {
                href = mergePathQuery(href, from);
            }
        }
        catch (e) {
            console.log(e);
        }
        if (beforeFunction) {
            Promise.resolve(beforeFunction).then(function () {
                window.open(href);
            });
        }
        else {
            window.open(href);
        }
    },
    reload: function () {
        window.location.reload();
    },
};

/**
 * 页面来源数据上报
 * @param eventName {string} 默认值 web_page_onload_from_info_explore
 * @param beaconReport {?function} 自定义数据上报的实例 window.beaconActionIns.onDirectUserAction
 */
function reportFromObject(eventName, beaconReport) {
    if (eventName === void 0) { eventName = 'web_page_onload_from_info_explore'; }
    var fromObject = {};
    var searchParamsObject = getFromInfoFromSession();
    if (searchParamsObject) {
        Object.keys(searchParamsObject).forEach(function (key) {
            fromObject[key] = searchParamsObject[key];
        });
    }
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.forEach(function (value, key) {
        if (key.startsWith('from_')) {
            fromObject[key] = value;
        }
        else if (key === 'fromSource') {
            fromObject.from_fromSource = value;
        }
    });
    if (!fromObject.from_fromSource) {
        if (window.location.href.indexOf('mobile') !== -1) {
            fromObject.from_fromSource = 'h5_meeting';
        }
        else {
            fromObject.from_fromSource = 'pc_meeting';
        }
    }
    var _a = currentUrl.origin.split('://'), website = _a[1];
    var currentPage = {
        current_page_origin: website,
        current_page_pathname: currentUrl.pathname,
        current_page_currentPageName: window.currentPageName || document.title,
    };
    var data = Object.assign({}, currentPage, fromObject);
    if (beaconReport) {
        beaconReport(eventName, data);
    }
    else {
        baseBeaconReport(eventName, data);
    }
}

var tencent = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get CorpTypeEnum () { return CorpTypeEnum; },
    get PayTagEnum () { return PayTagEnum; },
    get CorpPayTypeEnum () { return CorpPayTypeEnum; },
    PERSONAL_CORP_ID: PERSONAL_CORP_ID,
    getTagType: getTagType,
    getCorpPayType: getCorpPayType,
    isPersonalCorpType: isPersonalCorpType,
    getLoginUrl: getLoginUrl,
    queryLoginStatus: queryLoginStatus,
    get UserCropTypeEnum () { return UserCropTypeEnum; },
    get UserRoleEnum () { return UserRoleEnum; },
    getUserRole: getUserRole,
    isNormalUser: isNormalUser,
    wechatLogin: wechatLogin,
    baseBeaconReport: baseBeaconReport,
    mergeBaseReport: mergeBaseReport,
    wemeetBeaconReport: wemeetBeaconReport,
    getGlobalReportParams: getGlobalReportParams,
    getreferrer: getreferrer,
    createTencentCaptcha: createTencentCaptcha,
    withCaptcha: withCaptcha,
    BaseHttpService: BaseHttpService,
    getAxios: getAxios,
    getMergedUrl: getMergedUrl,
    getPrefixUrl: getPrefixUrl,
    HttpNoticeService: HttpNoticeService,
    http: http$1,
    getLoginSourceId: getLoginSourceId,
    isDetailedChangeAccount: isDetailedChangeAccount,
    UserService: UserService,
    CGI_URL: CGI_URL,
    accountLoginRefreshTokenTmpCache: accountLoginRefreshTokenTmpCache,
    corpCorpCorpPayTagTmpCache: corpCorpCorpPayTagTmpCache,
    accountProfileChangeAccountTmpCache: accountProfileChangeAccountTmpCache,
    corpUserRoleAuthPowerTmpCache: corpUserRoleAuthPowerTmpCache,
    getAccountBriefInfoTmpCache: getAccountBriefInfoTmpCache,
    cgiTmpCache: cgiTmpCache,
    getWeiXinJSBridge: getWeiXinJSBridge,
    hasWeiXinJSBridge: hasWeiXinJSBridge,
    isWeiXinMicroMessengerLt: isWeiXinMicroMessengerLt,
    isWeiXinQBCoreLt: isWeiXinQBCoreLt,
    getCopiedMeetingCode: getCopiedMeetingCode,
    formatMeetingCode: formatMeetingCode,
    isMaskMeetingCode: isMaskMeetingCode,
    isMaskMeetingLink: isMaskMeetingLink,
    FROM_INFO_SESSION_KEY: FROM_INFO_SESSION_KEY,
    getFromInfoFromSession: getFromInfoFromSession,
    getPageFromQuery: getPageFromQuery,
    mergePathQuery: mergePathQuery,
    navigation: navigation,
    reportFromObject: reportFromObject,
    mergeBaseParams: mergeBaseParams,
    getActPageModule: getActPageModule$1,
    srvBaseReport: srvBaseReport,
    getPersistCorp: getPersistCorp,
    getPersistRoot: getPersistRoot,
    getPersistUser: getPersistUser,
    StorageService: StorageService
});

/**
 * 获取用户ip
 * 只处理获取IP的逻辑
 */
var getClientIP = function () { return http$1
    .get({
    url: 'v2/common/ip/get-location-ip',
    data: {},
})
    .then(function (res) {
    if (res.code === 0 && res.data) {
        return Promise.resolve(res.data.user_ip || '');
    }
    return Promise.reject('');
})
    .catch(function () { return Promise.reject(''); }); };
var CLIENT_IP = 'ip';
var MEETING_ID = 'tencent_meeting_id';
// 枚举，init 0, pending 1, finally 2
var INIT = 0;
var PENDING = 1;
var FINALLY = 2;
// 初始化查询IP
var isFetchIP = INIT;
var initSetIp = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ip, lists, i;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // 判断当前状态
                if (isFetchIP !== INIT) {
                    return [2 /*return*/];
                }
                ip = '';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, 4, 5]);
                isFetchIP = PENDING;
                return [4 /*yield*/, getClientIP()];
            case 2:
                ip = _a.sent();
                return [3 /*break*/, 5];
            case 3:
                _a.sent();
                isFetchIP = FINALLY;
                return [3 /*break*/, 5];
            case 4:
                isFetchIP = FINALLY;
                // IP存到sessionstorage
                window.sessionStorage.setItem(CLIENT_IP, utoa(ip));
                lists = deepCopy(getWindow().$util.beaconReportLists);
                getWindow().$util.beaconReportLists = [];
                // eslint-disable-next-line no-restricted-syntax
                for (i in lists) {
                    beaconReport(lists[i].eventName, lists[i].reportObj);
                }
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * 加载灯塔 sdk
 *
 * 实时联调页面: http://datahub.tencent.com/common/view_debug
 */
var loadBeaconSdk = function () { return __awaiter(void 0, void 0, void 0, function () {
    var isDebug, dbgbeacon, appkey, dbgAppKey, lists, i;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                isDebug = sessionStorage.getItem('debug-beacon');
                dbgbeacon = getRequest('dbgbeacon') || isDebug || isLocalEnv();
                appkey = '00000C2AM539PVHX';
                dbgAppKey = 'LOGDEBUGKEY00028';
                if (!isNormalEnv() && !dbgbeacon) {
                    return [2 /*return*/, false];
                }
                if (!!getWindow().BeaconAction) return [3 /*break*/, 2];
                return [4 /*yield*/, loadScript('https://cdn.meeting.tencent.com/assets/client/beacon_web.3.1.53.min.js').catch(function (err) {
                        console.error('load-beacon-sdk:', err);
                    })];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2:
                if (getWindow().BeaconAction) {
                    // 2020.8.25 window.BeaconAction要使用new之后的实例，才有BeaconAction.onDirectUserAction方法
                    window.BeaconActionInstance = new (getWindow().BeaconAction)({
                        // 系统或项目id, 必填
                        appkey: dbgbeacon ? dbgAppKey : appkey,
                        // versionCode: '2.11.1', //项目版本,选填
                        // channelID: 'channel', //渠道,选填
                        // openid: 'openid', // 用户id, 选填
                        // delay: 1000, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
                        // onReportSuccess: success, // 上报成功回调,选填
                        // onReportFail: fail, // 上报失败回调,选填
                    });
                    /**
                     * 当 sdk 未加载时调用 beaconReport 会先缓存到 window.$util.beaconReportLists 变量中
                     */
                    if ((_a = getWindow().$util) === null || _a === void 0 ? void 0 : _a.beaconReportLists) {
                        lists = deepCopy(getWindow().$util.beaconReportLists);
                        // 清空上报缓存的数据
                        getWindow().$util.beaconReportLists = [];
                        // eslint-disable-next-line no-restricted-syntax
                        for (i in lists) {
                            beaconReport(lists[i].eventName, lists[i].reportObj);
                        }
                    }
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * report to beacon event
 * 需要加载灯塔 sdk : loadBeaconSdk();
 * @param {string} eventName
 * @param {object} reportObj
 * @param {object} configureStore
 * @deprecated 不要直接用，没有初始化公参
 */
// eslint-disable-next-line complexity
var beaconReport = function (eventName, reports, store) {
    var _a, _b, _c, _d;
    if (reports === void 0) { reports = {}; }
    var reportObj = Object.assign({}, reports);
    // 私有化版本不做数据上报
    if (process.env.WEMEET_PARAM_PRIVATE) {
        return;
    }
    if (getWindow().BeaconActionInstance && isFetchIP === FINALLY) {
        if (typeof reportObj === 'object') {
            var userInfos = (_a = store === null || store === void 0 ? void 0 : store.getState()) === null || _a === void 0 ? void 0 : _a.userInfos;
            reportObj.userid = reportObj.userid || (userInfos === null || userInfos === void 0 ? void 0 : userInfos.username) || '';
            reportObj.device_type = reportObj.device_type || (isMobile() ? 'mobile' : 'pc');
            reportObj.user_agent = window.navigator.userAgent;
            reportObj.app_uid = reportObj.app_uid || getCookie('app_uid') || getRequest('app_uid') || '';
            reportObj.app_id = reportObj.app_id || getCookie('app_id') || getRequest('app_id') || '';
            reportObj.user_ip = sessionStorage.getItem(CLIENT_IP) ? atou(sessionStorage.getItem(CLIENT_IP)) : '';
            // 从session中取meeting_id
            if (!reportObj.meeting_id) {
                reportObj.meeting_id = sessionStorage.getItem(MEETING_ID) || '';
            }
            // 是否为海外版本: yes or no;
            reportObj.is_overseas = 'no';
            var navPlatform = '';
            if ((_b = getWindow().navigator) === null || _b === void 0 ? void 0 : _b.platform) {
                navPlatform = window.navigator.platform;
            }
            reportObj.nav_platform = navPlatform;
        }
        (_d = (_c = getWindow().BeaconActionInstance).onDirectUserAction) === null || _d === void 0 ? void 0 : _d.call(_c, eventName, reportObj);
        return true;
    }
    // 未初始化好时, 缓存上报数据到 window.$util.beaconReportLists
    if (!getWindow().$util) {
        getWindow().$util = {};
    }
    if (!getWindow().$util.beaconReportLists) {
        getWindow().$util.beaconReportLists = [];
    }
    getWindow().$util.beaconReportLists.push({
        eventName: eventName,
        reportObj: reportObj,
    });
    // 初始化查询IP
    initSetIp();
    return false;
};
var loadBeacon = function () {
    if (!isServer && !getWindow().BeaconActionInstance) {
        loadBeaconSdk();
        loggerUtil.install(PluginEnum.beacon, beaconReport);
    }
};

/** ********************************************************/
/*                                                         */
/**                        初始化                          **/
/* loadBeacon();                                           */
/* loadAegis({ id: 'ebsNQtbXFBJJQVHCdx' }, Aegis);         */
/*                                                         */
/*                                                         */
/**                       更新配置                         **/
/* loggerUtil.use(PluginEnum.aegis).setConfig({            */
/*   uin: tokenInfo.uid,                                   */
/* });                                                     */
/* loggerUtil.use(PluginEnum.beacon).setConfig({           */
/*   userid: tokenInfo.nickname,                           */
/*   app_uid: tokenInfo.uid,                               */
/*   app_id: tokenInfo.app_id,                             */
/* });                                                     */
/** ********************************************************/

var logger$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    LoggerUtil: LoggerUtil,
    loggerUtil: loggerUtil,
    Config: Config,
    loadAegis: loadAegis,
    getClientIP: getClientIP,
    MEETING_ID: MEETING_ID,
    loadBeaconSdk: loadBeaconSdk,
    beaconReport: beaconReport,
    loadBeacon: loadBeacon,
    get PluginEnum () { return PluginEnum; }
});

var logger = loggerUtil === null || loggerUtil === void 0 ? void 0 : loggerUtil.use(undefined, 'http');
var ignoreCodes = [-20000, -20001, -200002, -200005, -521000, -521001, -521002, -51008];
/**
 * http监控
 * todo 监控页面接口错误,过滤指定错误码
 */
var HttpMonitor = /** @class */ (function () {
    function HttpMonitor() {
    }
    HttpMonitor.prototype.handleThen = function (request, response, startTime) {
        var url = request.url;
        if (response.data && response.data.code !== 0) {
            if (/\/service\/create-launch-id/i.test(url) || /\/service\/query-launch-id/i.test(url)) {
                return;
            }
            if (ignoreCodes.includes(response.data.code)) {
                return;
            }
            logger.error({
                title: 'CGI RESPONSE ERROR THE CODE IS NOT 0',
                api: request.url,
                params: request.params,
                body: request.data,
                req: request,
                res: response.data,
                duration: new Date().getTime() - startTime,
            });
        }
    };
    HttpMonitor.prototype.handleCatch = function (request, error, startTime) {
        var _a, _b;
        var errorData = {};
        if (error && typeof error.toJSON === 'function') {
            errorData = error.toJSON();
        }
        logger.error({
            title: 'HTTP ERROR NETWORK IS REFUSED',
            api: request.url,
            params: request.params,
            body: request.data,
            req: request,
            duration: new Date().getTime() - startTime,
            status: ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) || errorData.status,
            statusText: ((_b = error.response) === null || _b === void 0 ? void 0 : _b.statusText) || errorData.statusText,
            code: error.code,
            msg: error.message,
        });
    };
    return HttpMonitor;
}());

var httpMonitor = new HttpMonitor();
/**
 * 基础post请求
 * @param options {RequestOptions} 同axios配置
 * @param ctx {NextGetServerSidePropsContext} NextJs的context
 * ```js
 *    post({
 *      url: 'service/manage/user/login',
 *      data: {
 *        b: 2
 *      },
 *      params: {
 *        a: 1,
 *      },
 *      headers: {
 *        Customer: 'test'
 *      },
 *      prefix: '/custom-prefix' // 可选,默认为'/wemeet-tapi'
 *    }).then(res => {});
 * ```
 */
function post(options, ctx) {
    var safeOptions = mergeCommonConfig(options, ctx);
    var startTime = new Date().getTime();
    return axios
        .post(safeOptions.url, safeOptions.data, safeOptions)
        .then(function (resp) {
        httpMonitor.handleThen(safeOptions, resp, startTime);
        return resp.data;
    })
        .catch(function (err) {
        httpMonitor.handleCatch(safeOptions, err, startTime);
        return Object.assign({}, err, {
            code: err.code || 500,
            message: err.message || '网络错误，请稍后再试',
        });
    });
}
/**
 * 基础get请求
 * @param options {RequestOptions} 同axios配置
 * @param ctx {NextGetServerSidePropsContext} NextJs的context
 */
function get(options, ctx) {
    var safeOptions = mergeCommonConfig(options, ctx);
    var startTime = new Date().getTime();
    return axios
        .get(safeOptions.url, safeOptions)
        .then(function (resp) {
        httpMonitor.handleThen(safeOptions, resp, startTime);
        return resp.data;
    })
        .catch(function (err) {
        httpMonitor.handleCatch(safeOptions, err, startTime);
        return Object.assign({}, err, {
            code: err.code || 500,
            message: err.message || '网络错误，请稍后再试',
        });
    });
}
/**
 * 基础put请求
 * @param options {RequestOptions} 同axios配置
 * @param ctx {NextGetServerSidePropsContext} NextJs的context
 */
function put(options, ctx) {
    var safeOptions = mergeCommonConfig(options, ctx);
    var startTime = new Date().getTime();
    return axios
        .put(safeOptions.url, safeOptions.data, safeOptions)
        .then(function (resp) {
        httpMonitor.handleThen(safeOptions, resp, startTime);
        return resp.data;
    })
        .catch(function (err) {
        httpMonitor.handleCatch(safeOptions, err, startTime);
        return Object.assign({}, err, {
            code: err.code || 500,
            message: err.message || '网络错误，请稍后再试',
        });
    });
}
// noinspection OverlyComplexFunctionJS
/**
 * 兼容用户中心的封装, 请使用post替换, 后续会移除
 * @deprecated 函数的参数过多,请使用post替换
 */
function makePostPromise(url, params, cancelToken, onUploadProgress, prefixType, disableDefaultErrorHandlingCodes, urlParams) {
    if (cancelToken === void 0) { cancelToken = undefined; }
    if (onUploadProgress === void 0) { onUploadProgress = undefined; }
    if (prefixType === void 0) { prefixType = 'webapi'; }
    if (disableDefaultErrorHandlingCodes === void 0) { disableDefaultErrorHandlingCodes = []; }
    if (urlParams === void 0) { urlParams = {}; }
    return post({
        url: url,
        params: urlParams,
        data: params,
        cancelToken: cancelToken,
        onUploadProgress: onUploadProgress,
        prefix: prefixType,
        disableDefaultErrorHandlingCodes: disableDefaultErrorHandlingCodes,
    });
}
/**
 * 兼容用户中心的封装, 请使用get替换, 后续会移除
 * @deprecated 函数的参数过多,请使用get替换
 */
function makeGetPromise(url, params, cancelToken, onUploadProgress, prefixType) {
    if (params === void 0) { params = {}; }
    if (cancelToken === void 0) { cancelToken = undefined; }
    if (onUploadProgress === void 0) { onUploadProgress = undefined; }
    if (prefixType === void 0) { prefixType = 'webapi'; }
    return get({
        url: url,
        params: params,
        cancelToken: cancelToken,
        onUploadProgress: onUploadProgress,
        prefix: prefixType,
    });
}

/**
 * @description 获取用户信息
 * @returns Promise
 */
var getUserInfoFromServer = function (isRefresh) {
    if (isRefresh === void 0) { isRefresh = 0; }
    return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, accountLoginRefreshTokenTmpCache({
                            refresh_token: isRefresh,
                        })
                            .catch(function (err) { return err; })];
                case 1:
                    response = _a.sent();
                    if (response === null || response === void 0 ? void 0 : response.data) {
                        return [2 /*return*/, Promise.resolve(response.data)];
                    }
                    return [2 /*return*/, Promise.reject(response)];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 3: return [2 /*return*/];
            }
        });
    });
};

var http = /*#__PURE__*/Object.freeze({
    __proto__: null,
    getDeviceType: getDeviceType$2,
    getInstanceId: getInstanceId,
    axios: axios,
    get: get,
    makeGetPromise: makeGetPromise,
    makePostPromise: makePostPromise,
    post: post,
    put: put,
    mergeCommonConfig: mergeCommonConfig,
    getRequestUrl: getRequestUrl,
    generateTraceId: generateTraceId,
    getUserInfoFromServer: getUserInfoFromServer
});

// 审核人员专用账号
var AppStoreReviewers = [
    '144115215300016949',
    '144115215266196784',
    '144115215356410721',
    '144115215356410733',
    '144115215266196825',
    '144115215266196846',
    '144115215356410675',
    '144115215266196854',
    '144115215266196865',
    '144115215356410812',
    '144115215356410824',
];
/**
 * 腾讯会议内部语言
 */
function getAppDistrict(ua) {
    var _a;
    var res = '';
    var lowerUa = ua.toLowerCase();
    var regStrSaf = /c_district\/[\d._]*/gi;
    var district = lowerUa.match(regStrSaf);
    if (district && district.length > 0) {
        _a = district[0].split('/'), res = _a[1];
    }
    return res;
}
function getRequestWithCtx(key, ctx) {
    var _a;
    return isServer ? (_a = ctx === null || ctx === void 0 ? void 0 : ctx.query) === null || _a === void 0 ? void 0 : _a["".concat(key)] : getRequest(key);
}
var serverConfigPromiseCache;
var hasPromiseCache = false;
/**
 * 判断是否是 apple 提审应用版本
 * https://iwiki.woa.com/pages/viewpage.action?pageId=4007847121
 * @param ctx {?NextGetServerSidePropsContext} node端传入的执行上下文，客户端不需要传
 * @returns {Promise<boolean>} True if the app with a reviewing version, false if not.
 */
function isAppStoreReviewVersion(ctx) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var ua, isWeMeet, appVersion, appDistrict, osName, isiOS, isMac, installFromMacAppStore, cookies, curUid, isReviewer, iosReviewingVersion, iosMaxVersion, macReviewingVersion, macMaxVersion, res, data, config, notLess, between, notLess, between;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ua = isServer ? ((_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers['user-agent']) || '' : navigator.userAgent;
                    isWeMeet = isWeMeetApp(ua);
                    appVersion = isWeMeet ? getAppVersion(ua) : getRequestWithCtx('app_version', ctx);
                    appDistrict = isWeMeet ? getAppDistrict(ua) : getRequestWithCtx('c_district', ctx);
                    osName = getRequestWithCtx('os_name', ctx) || '';
                    isiOS = isWeMeet ? /os_name\/iOS/i.test(ua) : /iOS/i.test(osName);
                    isMac = isWeMeet ? /os_name\/Mac/i.test(ua) : /Mac/i.test(osName);
                    installFromMacAppStore = getRequestWithCtx('app_sdk_id', ctx) === '1410001423';
                    cookies = getCookies(ctx);
                    curUid = cookies.app_uid || getRequestWithCtx('app_uid', ctx) || '';
                    isReviewer = AppStoreReviewers.includes(curUid);
                    if (isReviewer) {
                        return [2 /*return*/, Promise.resolve(true)];
                    }
                    // 如果不是iOS且不是Mac，则判断为非审核版本
                    if (!isiOS && !isMac) {
                        return [2 /*return*/, Promise.resolve(false)];
                    }
                    // 如果不是应用市场渠道安装的Mac应用，则判断为非审核版本
                    if (!installFromMacAppStore && isMac) {
                        return [2 /*return*/, Promise.resolve(false)];
                    }
                    // 如果没有版本号信息，则判断为非审核版本
                    if (!appVersion) {
                        return [2 /*return*/, Promise.resolve(false)];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (!hasPromiseCache) {
                        serverConfigPromiseCache = post({
                            prefix: 'wemeet-tapi',
                            url: '/v2/wemeet_cowork_config/get-h5-common-config',
                            data: {
                                type: [1],
                                voov: String(appDistrict) === '1' ? 1 : 0, // 查询的是voov还是国内。1 国际版，0 或不传是国内
                            },
                        }, ctx);
                        hasPromiseCache = true;
                    }
                    return [4 /*yield*/, serverConfigPromiseCache];
                case 2:
                    res = _b.sent();
                    data = res === null || res === void 0 ? void 0 : res.data;
                    if (data.length > 0) {
                        config = data[0];
                        iosReviewingVersion = config === null || config === void 0 ? void 0 : config.iosShieldVersion;
                        iosMaxVersion = config === null || config === void 0 ? void 0 : config.iosMaxVersion;
                        macReviewingVersion = config === null || config === void 0 ? void 0 : config.macShieldVersion;
                        macMaxVersion = config === null || config === void 0 ? void 0 : config.macMaxVersion;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 4:
                    if (isiOS && iosReviewingVersion && appVersion) {
                        notLess = compareVersion(appVersion, iosReviewingVersion) > -1;
                        if (iosMaxVersion) {
                            between = notLess && compareVersion(appVersion, iosMaxVersion) < 1;
                            return [2 /*return*/, Promise.resolve(between)];
                        }
                        return [2 /*return*/, Promise.resolve(notLess)];
                    }
                    if (isMac && macReviewingVersion && appVersion) {
                        notLess = compareVersion(appVersion, macReviewingVersion) > -1;
                        if (macMaxVersion) {
                            between = notLess && compareVersion(appVersion, macMaxVersion) < 1;
                            return [2 /*return*/, Promise.resolve(between)];
                        }
                        return [2 /*return*/, Promise.resolve(notLess)];
                    }
                    // 默认返回
                    return [2 /*return*/, Promise.resolve(false)];
            }
        });
    });
}

/**
 * 判断是OA环境
 * @param href {?string} 默认为当前页面的location.href
 */
function isOAEnv(href) {
    if (href === void 0) { href = ''; }
    if (!isServer && !href) {
        // eslint-disable-next-line no-param-reassign
        href = location.href;
    }
    return /:\/\/wemeet\.(w)?oa\.com/.test(href);
}

/**
 * 判断是否是预发set环境
 * @param cookie cookie
 * @returns boolean
 */
function isPreSet(cookie) {
    if (isServer) {
        var _a = parseCookie(cookie), tdeProxy = _a.tde_proxy, tdeId = _a._tde_id;
        return tdeProxy === '1' && tdeId === '8005';
    }
    if (getCookie('tde_proxy') === '1' && getCookie('_tde_id') === '8005') {
        return true;
    }
    return false;
}

/**
 * 判断nodejs环境是否为生产环境
 */
function isNodeProduction() {
    if (typeof process === 'object' && process && process.env) {
        return process.env.NODE_ENV === 'production';
    }
    return true;
}
/**
 * 判断nodejs环境是否为生产环境
 */
function isProduction() {
    return isNodeProduction();
}

var env = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ConstantEnum: ConstantEnum,
    isAppStoreReviewVersion: isAppStoreReviewVersion,
    IS_I18N: IS_I18N,
    isLocalEnv: isLocalEnv,
    isNormalEnv: isNormalEnv,
    isOAEnv: isOAEnv,
    isPreReleaseEnv: isPreReleaseEnv,
    isPreSet: isPreSet,
    isNodeProduction: isNodeProduction,
    isProduction: isProduction,
    isTestEnv: isTestEnv
});

/**
 * 多个方法一起调用
 * @param fns
 * @returns
 */
function callBoth() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var lastResult;
        for (var _a = 0, fns_1 = fns; _a < fns_1.length; _a++) {
            var fn = fns_1[_a];
            if (typeof fn === 'function') {
                lastResult = fn.apply(void 0, args);
            }
        }
        return lastResult;
    });
}

/* eslint-disable no-param-reassign */
/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;
var nativeMin = Math.min;
function debounce(func, wait, options) {
    if (wait === void 0) { wait = 0; }
    if (options === void 0) { options = {}; }
    var lastArgs;
    var lastThis;
    var maxWait = 0;
    var result;
    var timerId;
    var lastCallTime;
    var lastInvokeTime = 0;
    var leading = false;
    var maxing = false;
    var trailing = true;
    if (typeof func !== 'function') {
        throw new TypeError(FUNC_ERROR_TEXT$1);
    }
    wait = Number(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(Number(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs;
        var thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime;
        var timeSinceLastInvoke = time - lastInvokeTime;
        var timeWaiting = wait - timeSinceLastCall;
        return maxing
            ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime;
        var timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait)
            || (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
    }
    function timerExpired() {
        var time = new Date().valueOf();
        if (shouldInvoke(time)) {
            return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
            return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) {
            clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(new Date().valueOf());
    }
    function debounced() {
        var time = new Date().valueOf();
        var isInvoking = shouldInvoke(time);
        // eslint-disable-next-line prefer-rest-params
        lastArgs = arguments;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) {
                return leadingEdge(lastCallTime);
            }
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) {
            timerId = setTimeout(timerExpired, wait);
        }
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';
function throttle(func, wait, options) {
    if (wait === void 0) { wait = 0; }
    if (options === void 0) { options = {}; }
    var leading = true;
    var trailing = true;
    if (typeof func !== 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
    }
    if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return debounce(func, wait, {
        leading: leading,
        maxWait: wait,
        trailing: trailing,
    });
}

/**
 * 延迟N秒后 执行某方法
 * @param time num
 * @returns Promise
 */
function sleep(time) {
    if (time === void 0) { time = 0; }
    return new Promise(function (resolve) { return setTimeout(resolve, time); });
}

var functions = /*#__PURE__*/Object.freeze({
    __proto__: null,
    callBoth: callBoth,
    debounce: debounce,
    throttle: throttle,
    sleep: sleep
});

// 更多类型检查，可参考npm node file-type
// 读取文件的二进制数据并将其转换为十六进制
var fileReader = function (blob) { return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsBinaryString(blob);
    /* eslint-disable */
    reader.onload = function () {
        // @ts-ignore
        var res = reader.result.split('').map(function (o) { return o.charCodeAt().toString(16)
            .padStart(2, '0'); });
        resolve(res.join(' ').toUpperCase());
    },
        reader.onerror = function (err) {
            reject(err);
        };
}); };
// png格式
var isPng = function (file) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, fileReader(file.slice(0, 8))];
        case 1: return [2 /*return*/, (_a.sent()) === '89 50 4E 47 0D 0A 1A 0A'];
    }
}); }); };
// jpg格式
var isJpg = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var start;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fileReader(file.slice(0, 2))];
            case 1:
                start = _a.sent();
                return [2 /*return*/, start === 'FF D8'];
        }
    });
}); };
// gif格式
var isGif = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var ret;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fileReader(file.slice(0, 6))];
            case 1:
                ret = _a.sent();
                return [2 /*return*/, '47 49 46 38 39 61' === ret || '47 49 46 38 37 61' === ret];
        }
    });
}); };
/**
 *
 * @param file File
 * @param type 类型配置对象，有png, jpg 和 gif
 * @returns boolean
 */
function isAcceptedImage(file, type) {
    if (type === void 0) { type = {
        png: false,
        jpg: false,
        gif: false,
    }; }
    return __awaiter(this, void 0, void 0, function () {
        var pngPass, jpgPass, gifPass, png, jpg, gif;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pngPass = false;
                    jpgPass = false;
                    gifPass = false;
                    png = type.png, jpg = type.jpg, gif = type.gif;
                    if (!png) return [3 /*break*/, 2];
                    return [4 /*yield*/, isPng(file)];
                case 1:
                    pngPass = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!jpg) return [3 /*break*/, 4];
                    return [4 /*yield*/, isJpg(file)];
                case 3:
                    jpgPass = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!gif) return [3 /*break*/, 6];
                    return [4 /*yield*/, isGif(file)];
                case 5:
                    gifPass = _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/, (pngPass || jpgPass || gifPass)];
            }
        });
    });
}

var imagetype = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isAcceptedImage: isAcceptedImage
});

/**
 * 时间戳格式化
 * @param stamp number
 * @param format string 例：'year-month-day hour:minute:second'
 * return string | number
 */
function timeFormat(stamp, format) {
    var str = format || 'year-month-day hour:minute:second';
    var time = new Date((stamp || stamp === 0) ? stamp : Number(new Date()));
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var day = time.getDate();
    var hour = time.getHours();
    var minute = time.getMinutes();
    var second = time.getSeconds();
    function strReplaceAll(str, find, replaceWith) {
        var regex = new RegExp(find, 'g');
        return str.replace(regex, replaceWith);
    }
    str = strReplaceAll(str, 'year', year.toString());
    str = strReplaceAll(str, 'month', tenSupplements(month).toString());
    str = strReplaceAll(str, 'day', tenSupplements(day).toString());
    str = strReplaceAll(str, 'hour', tenSupplements(hour).toString());
    str = strReplaceAll(str, 'minute', tenSupplements(minute).toString());
    str = strReplaceAll(str, 'second', tenSupplements(second).toString());
    return str;
}

var time = /*#__PURE__*/Object.freeze({
    __proto__: null,
    timeFormat: timeFormat
});

var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
 * 大陆及海外手机号校验 https://stackoverflow.com/questions/4338267/validate-phone-number-with-javascript
 * @param countryCode
 * @param phone
 */
function validateCodePhone(countryCode, phone) {
    if (countryCode === '86') {
        return /^[1][3-9][0-9]{9}$/.test(phone);
    }
    if (countryCode.length > 4 || countryCode.length < 1) {
        return false;
    }
    return /^[0-9]{3}[0-9]{3}[0-9]{2,7}$/.test(countryCode + phone);
}

/**
 * email 校验
 * @param {string} val
 */
function verifyEmail(val) {
    if (!val) {
        return false;
    }
    if (val.length > 254) {
        return false;
    }
    // eslint-disable-next-line no-useless-escape
    var regex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
    return regex.test(val);
}

var validate = /*#__PURE__*/Object.freeze({
    __proto__: null,
    validateCodePhone: validateCodePhone,
    verifyEmail: verifyEmail
});

var webBase = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, browser), dom), env), functions), http), imagetype), logger$1), model), numbers), objects), storage), strings), tencent), time), types), validate);

export { BaseAuthInfo, BaseHttpService, BaseMeetingInfo, BaseRootState, BaseTencentDocAuthInfo, BaseUserInfo, BaseWechatAuthInfo, CGI_URL, Config, ConstantEnum, CorpPayTypeEnum, CorpTypeEnum, FROM_INFO_SESSION_KEY, HttpNoticeService, IS_I18N, LoggerUtil, MEETING_ID, PERSONAL_CORP_ID, PayTagEnum, PluginEnum, Storage, StorageService, UserCropTypeEnum, UserRoleEnum, UserService, WechatJumpInfoEnum, accountLoginRefreshTokenTmpCache, accountProfileChangeAccountTmpCache, addClassName, addURLSearch, asciiToUnicode, atou, awaitWrap, baseBeaconReport, beaconReport, callBoth, cgiTmpCache, compareVersion, corpCorpCorpPayTagTmpCache, corpUserRoleAuthPowerTmpCache, createElement, createTencentCaptcha, dealSearchStr, debounce, deepCopy, deleteURLSearch, divideNum, escapeHtml, filterXss, findById, forEachNode, formatMeetingCode, formatMoney, generateTraceId, get, getAccountBriefInfoTmpCache, getActPageModule$1 as getActPageModule, getAppVersion, getAvatarByUser, getAvatarImg, getAxios, getBrowserInfo, getChangeLog, getClientIP, getCookie, getCookies, getCopiedMeetingCode, getCorpPayType, getDeviceType$2 as getDeviceType, getElements, getFlashVersion, getFromInfoFromSession, getGlobalReportParams, getGuid, getHost, getHtmlLang, getInstanceId, getLang, getLocationHref, getLoginSourceId, getLoginUrl, getMergedUrl, getName, getNodeList, getOffsetLeft, getOffsetTop, getOsName, getPageFromQuery, getPersistCorp, getPersistRoot, getPersistUser, getPrefixUrl, getQueryObject, getRandomString, getRequest, getRequestUrl, getStrLength, getTagType, getUserAgent, getUserInfoFromServer, getUserRole, getWebkitInfo, getWeiXinJSBridge, getWindow, getWxAppid, getWxOriginId, getreferrer, hasSome, hasWeiXinJSBridge, http$1 as http, isAcceptedImage, isAndroid, isAndroidPad, isAppStoreReviewVersion, isArray, isBankCardNum, isBigint, isBoolean, isChineseName, isChrome, isDetailedChangeAccount, isDingTalk, isEdge, isEmail, isFF, isFullScreenIPhone, isFunction, isHuaweiPadBrowser, isHuaweiPadQqBrowser, isIE, isIE8, isIOS, isIPhone, isIdNum, isIpad, isLinux, isLocalEnv, isMQQB, isMac, isMacApp, isMacWechat, isMaskMeetingCode, isMaskMeetingLink, isMobile, isNative, isNodeProduction, isNormalEnv, isNormalUser, isNullUndefined, isNumber, isOAEnv, isObject, isPad, isPersonalCorpType, isPostcode, isPreReleaseEnv, isPreSet, isProduction, isPromise, isQQ, isQQB, isSafari, isServer, isString, isTBS, isTestEnv, isWeChat, isWeMeetApp, isWechat, isWechatMiniProgram, isWeiXinGte656, isWeiXinMicroMessengerLt, isWeiXinQBCoreLt, isWin, isWinApp, isWindowsWechat, isWxWork, isWxWorkGte312, isWxWorkGteVersion, isWxWorkLocal, loadAegis, loadBeacon, loadBeaconSdk, loadCss, loadScript, loadScripts, loadVConsoleScript, localStorageClear, localStorageGet, localStorageRemove, localStorageSet, loggerUtil, makeGetPromise, makePostPromise, makeReadonly, md5, mergeBaseParams, mergeBaseReport, mergeCommonConfig, mergeObjects, mergePathQuery, navigation, numberToWan, outOfNum, parseCookie, parseQueryString, post, put, queryLoginStatus, randomString, removeClassName, removeEmoji, reportFromObject, scrollToDom, setCookie, setWindowInstance, sleep, srvBaseReport, storage$1 as storage, tenSupplements, textToImg, throttle, timeFormat, toString, unicodeToAscii, urlType, utoa, uuidv4, validateCodePhone, verifyEmail, webBase, wechatLogin, wemeetBeaconReport, withCaptcha, wxConfig };
